import React, { useEffect, useState, useMemo, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from 'sweetalert2';
import { AsyncPaginate } from "react-select-async-paginate";
import "../../../styles/Auth/pos.css"
import {
    idbGetData,
    idbPostData,
    idbPutData,
    idbDeleteData
} from "../../../indexedDB/indexDB.service";
import { getData, postData } from '../../../webService/webservice.js';
import { API_URL } from "../../../utils/utils.js";
import { formatWhatsAppMessage } from "../../../utils/constants.js";
import {
    savePosDraft,
    getPosDraft,
    clearPosDraft
} from "../../../indexedDB/posDraft.service";
import { Box, Modal, Button, Typography, IconButton, FormControl, FormLabel, MenuItem, Select as MuiSelect } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import AddCustomerForm from "../Customers/add-customerForm.jsx";
import CustomerSelect from "../../Challange/CustomerSelect.jsx";
import EmployeeSelect from "../../Challange/EmployeeSelect.jsx";
import { useStore } from "../../../Context/context.jsx";
import CustomerDetailsPopup from "./CustomerDetailsPopup.jsx";
import dayjs from "dayjs";
import Select from "react-select";
import { generateInvoiceHTML, generateWalletPrintHTML } from "../../../utils/invoicePrintTemplates";
const POSPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const appointmentId = searchParams.get("appointmentId");
    const [loadedAppointmentId, setLoadedAppointmentId] = useState(null);
    const sessionToken = localStorage.getItem("Token");
    const [activeTab, setActiveTab] = useState("services");
    const [isMembershipApplied, setIsMembershipApplied] = useState(false);
    const loggedInRole = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const [isAddCustomer, setIsAddCustomer] = useState(false);
    const [addCustomerPhone, setAddCustomerPhone] = useState("");
    const [customers, setCustomers] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [showPrintButton, setShowPrintButton] = useState(false);
    const [lastInvoice, setLastInvoice] = useState(null);
    const [activeMembership, setActiveMembership] = useState(null);
    const [hasExistingActiveMembership, setHasExistingActiveMembership] = useState(false);
    const [stores, setStores] = useState([]);
    const [products, setProducts] = useState([]);
    const [services, setServices] = useState([]);
    const [memberships, setMemberships] = useState([]);
    const [selectedCustomerOption, setSelectedCustomerOption] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [posSearchType, setPosSearchType] = useState("SERVICE");

    const userId = localStorage.getItem("userId");
    const [customerRefreshKey, setCustomerRefreshKey] = useState(0);
    const [customerSearch, setCustomerSearch] = useState("");
    const [showCustomerPopup, setShowCustomerPopup] = useState(false);
    const [changeToReturn, setChangeToReturn] = useState(0);
    const [showChangeModal, setShowChangeModal] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentModalTotal, setPaymentModalTotal] = useState(0);
    const [membershipFilterType, setMembershipFilterType] =
        useState("SERVICE");

    const [cart, setCart] = useState([]);
    const [cartId, setCartId] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [overallDiscount, setOverallDiscount] = useState(0);
    const [overallDiscountType, setOverallDiscountType] = useState("FLAT");
    const [miscellaneousCharges, setMiscellaneousCharges] = useState(0);
    const [miscReason, setMiscReason] = useState("");
    const [couponInput, setCouponInput] = useState("");
    const [availableCoupons, setAvailableCoupons] = useState([]);
    const [showCouponModal, setShowCouponModal] = useState(false);
    const cartContainerRef = useRef(null);
    const dateInputRef = useRef(null);
    const dateInputRef2 = useRef(null);
    const [appliedCoupons, setAppliedCoupons] = useState([]);
    const [mrpSelectionModal, setMrpSelectionModal] = useState({ open: false, product: null, options: [], type: "Product" });
    const [posRefreshKey, setPosRefreshKey] = useState(0);
    const { selectedStoreId, setSelectedStoreId } = useStore();

    /* ---------------- CUSTOMER WALLET STATES & HELPERS ---------------- */
    const [customerWallets, setCustomerWallets] = useState([]);
    const [isCashWalletApplied, setIsCashWalletApplied] = useState(false);
    const [appliedCashWallet, setAppliedCashWallet] = useState(null);
    const [customWalletDeductionAmount, setCustomWalletDeductionAmount] = useState(0);
    const [isServiceWalletUsedInCheckout, setIsServiceWalletUsedInCheckout] = useState(true);
    const [showBuyWalletModal, setShowBuyWalletModal] = useState(false);
    const [availableWalletPackages, setAvailableWalletPackages] = useState([]);
    const [selectedBuyPackage, setSelectedBuyPackage] = useState(null);
    const [buyWalletPaymentMethod, setBuyWalletPaymentMethod] = useState("Cash");

    /* ---------------- WALLET OTP STATES ---------------- */
    const [isWalletOtpVerified, setIsWalletOtpVerified] = useState(false);
    const [walletOtpVerificationId, setWalletOtpVerificationId] = useState(null);
    const [showWalletOtpModal, setShowWalletOtpModal] = useState(false);
    const [walletOtpInput, setWalletOtpInput] = useState("");
    const [walletOtpLoading, setWalletOtpLoading] = useState(false);
    const [walletOtpError, setWalletOtpError] = useState("");
    const [walletOtpResendTimer, setWalletOtpResendTimer] = useState(0);

    useEffect(() => {
        let timer;
        if (walletOtpResendTimer > 0) {
            timer = setTimeout(() => setWalletOtpResendTimer(prev => prev - 1), 1000);
        }
        return () => clearTimeout(timer);
    }, [walletOtpResendTimer]);

    const handleSendWalletOtp = async () => {
        const custId = formData.customer || selectedCustomerOption?.value;
        if (!custId) {
            toast.error("Please select a customer for wallet billing.");
            return;
        }
        setWalletOtpLoading(true);
        setWalletOtpError("");
        try {
            const token = localStorage.getItem("Token");
            const res = await postData("otps/wallet/send", {
                customerId: custId,
                storeId: selectedStoreId
            }, token);

            if (res && (res.status === 200 || res.success || res.message?.includes("sent"))) {
                const verId = res.data?.verificationId || res.data?._id;
                setWalletOtpVerificationId(verId);
                setWalletOtpInput("");
                setShowWalletOtpModal(true);
                setWalletOtpResendTimer(30);
                toast.success("OTP sent to customer registered mobile number.");
            } else {
                setWalletOtpError(res?.message || "Failed to send OTP. Please try again.");
                toast.error(res?.message || "Failed to send OTP.");
            }
        } catch (err) {
            console.error("Error sending wallet OTP:", err);
            setWalletOtpError(err.message || "Error sending OTP");
            toast.error("Error sending OTP");
        } finally {
            setWalletOtpLoading(false);
        }
    };

    const handleVerifyWalletOtp = async () => {
        if (!walletOtpInput || walletOtpInput.length !== 6) {
            setWalletOtpError("Please enter a valid 6-digit OTP.");
            return;
        }
        setWalletOtpLoading(true);
        setWalletOtpError("");
        try {
            const token = localStorage.getItem("Token");
            const res = await postData("otps/wallet/verify", {
                verificationId: walletOtpVerificationId,
                customerId: formData.customer || selectedCustomerOption?.value,
                otp: walletOtpInput
            }, token);

            if (res && (res.status === 200 || res.data?.isVerified || res.message?.includes("verified"))) {
                setIsWalletOtpVerified(true);
                if (res.data?.verificationId) {
                    setWalletOtpVerificationId(res.data.verificationId);
                }
                setShowWalletOtpModal(false);
                toast.success("✓ Wallet OTP verified successfully!");
            } else {
                setWalletOtpError(res?.message || "Invalid OTP code entered. Please try again.");
            }
        } catch (err) {
            console.error("Error verifying wallet OTP:", err);
            setWalletOtpError(err.message || "Error verifying OTP");
        } finally {
            setWalletOtpLoading(false);
        }
    };

    const fetchCustomerWallets = useCallback(async (customerId) => {
        if (!customerId) {
            setCustomerWallets([]);
            return;
        }
        try {
            const token = localStorage.getItem("Token");
            const validStore = (selectedStoreId && selectedStoreId !== 'null' && selectedStoreId !== 'undefined') ? selectedStoreId : 'all';
            const res = await getData(`wallets/customer/${validStore}/${customerId}`, {}, token);
            if (res && res.data) {
                setCustomerWallets(Array.isArray(res.data) ? res.data : []);
            } else {
                setCustomerWallets([]);
            }
        } catch (err) {
            console.error("Error fetching customer wallets:", err);
            setCustomerWallets([]);
        }
    }, [selectedStoreId]);

    // 📜 WALLET HISTORY & DIRECT WALLET CREATION STATE
    const [showActiveWalletsModal, setShowActiveWalletsModal] = useState(false);
    const [showWalletHistoryModal, setShowWalletHistoryModal] = useState(false);
    const [customerWalletHistory, setCustomerWalletHistory] = useState([]);
    const [walletHistoryLoading, setWalletHistoryLoading] = useState(false);

    const [walletModalTab, setWalletModalTab] = useState("Service"); // "Service" | "Cash"
    const [cashWalletSubTab, setCashWalletSubTab] = useState("New"); // "New" | "Recharge"
    const [availableServicesForWallet, setAvailableServicesForWallet] = useState([]);

    const [serviceWalletForm, setServiceWalletForm] = useState({
        serviceId: '',
        serviceName: '',
        name: 'Service Wallet',
        services: [{ serviceId: '', baseCount: '10', additionalCount: '0' }],
        allowedUsages: '',
        additionalUsages: '',
        price: '',
        totalAmount: '',
        validityDays: 365,
        paymentMethod: 'Cash',
        isGstApplicable: false,
        gstPercentage: 18,
        gstType: 'Exclusive'
    });

    const handleAddPosServiceRow = () => {
        setServiceWalletForm(prev => ({
            ...prev,
            services: [...(prev.services || []), { serviceId: '', baseCount: '10', additionalCount: '0' }]
        }));
    };

    const handleRemovePosServiceRow = (index) => {
        setServiceWalletForm(prev => ({
            ...prev,
            services: (prev.services || []).filter((_, i) => i !== index)
        }));
    };

    const handlePosServiceRowChange = (index, field, value) => {
        setServiceWalletForm(prev => {
            const updated = [...(prev.services || [])];
            updated[index] = { ...updated[index], [field]: value };
            return { ...prev, services: updated };
        });
    };

    const [cashWalletForm, setCashWalletForm] = useState({
        name: 'VIP Cash Wallet',
        customerPays: '',
        creditedAmount: '',
        validityDays: 365,
        paymentMethod: 'Cash',
        selectedWalletForRecharge: '',
        isGstApplicable: false,
        gstPercentage: 18,
        gstType: 'Exclusive'
    });

    const fetchAvailableServicesForWallet = useCallback(async () => {
        try {
            const token = localStorage.getItem("Token");
            const res = await getData("services/services", { storeId: selectedStoreId, page: 1, limit: 100, isActive: true }, token);
            const sData = Array.isArray(res?.data) ? res.data[0] : res?.data;
            const rawServices = sData?.paginatedResults || (Array.isArray(res?.data) ? res.data : []);
            const activeServices = rawServices.filter(s => s.isActive !== false && s.serviceStatus !== "Inactive");
            setAvailableServicesForWallet(activeServices);
        } catch (err) {
            console.error("Error fetching services for wallet:", err);
        }
    }, [selectedStoreId]);

    const fetchCustomerWalletHistory = useCallback(async (customerId) => {
        if (!customerId) return;
        setWalletHistoryLoading(true);
        try {
            const token = localStorage.getItem("Token");
            const validStore = (selectedStoreId && selectedStoreId !== 'null' && selectedStoreId !== 'undefined') ? selectedStoreId : 'all';
            const res = await getData(`wallets/history/${validStore}/${customerId}?customerId=${customerId}`, {}, token);
            if (res && res.data) {
                setCustomerWalletHistory(Array.isArray(res.data) ? res.data : []);
            } else {
                setCustomerWalletHistory([]);
            }
        } catch (err) {
            console.error("Error fetching customer wallet history:", err);
            setCustomerWalletHistory([]);
        } finally {
            setWalletHistoryLoading(false);
        }
    }, [selectedStoreId]);

    const fetchAvailableWalletPackages = useCallback(async () => {
        try {
            const token = localStorage.getItem("Token");
            const validStore = (selectedStoreId && selectedStoreId !== 'null' && selectedStoreId !== 'undefined') ? selectedStoreId : 'all';
            const res = await getData(`wallets/get-packages/${validStore}`, {}, token);
            if (res && res.data) {
                setAvailableWalletPackages(Array.isArray(res.data) ? res.data : []);
            }
        } catch (err) {
            console.error("Error fetching wallet packages:", err);
        }
    }, [selectedStoreId]);

    // 🧠 SERVICE WALLET DETECTION & EXPLICIT APPLICATION ONLY (NO AUTO-APPLICATION)
    // Service Wallet is applied ONLY when the user explicitly selects "Use Wallet" in the Checkout popup or Cart.

    const applyServiceWalletToCart = (wallet) => {
        if (!wallet) {
            toast.error("Invalid Service Wallet");
            return;
        }

        // Find matching item in cart for any service supported by this wallet
        const matchIdx = cart.findIndex(item => {
            const isSvc = item.category?.toLowerCase() === 'service';
            if (!isSvc) return false;

            if (item.isServiceWalletApplied && item.customerWalletId !== wallet._id) {
                return false;
            }

            const cartSvcId = String(
                item.serviceId?._id ||
                item.serviceId?.id ||
                (typeof item.serviceId === 'string' ? item.serviceId : '') ||
                item.id ||
                item._id ||
                ''
            );
            const cartSvcName = (item.serviceName || item.name || item.title || '').toLowerCase().trim();

            if (wallet.services && wallet.services.length > 0) {
                return wallet.services.some(s => {
                    const svcObj = s.serviceId;
                    const wSvcId = String(svcObj?._id || svcObj?.id || (typeof svcObj === 'string' ? svcObj : '') || '');
                    const wSvcName = (svcObj?.serviceName || '').toLowerCase().trim();

                    const isIdMatch = wSvcId && cartSvcId && wSvcId === cartSvcId;
                    const isNameMatch = wSvcName && cartSvcName && (
                        cartSvcName === wSvcName ||
                        cartSvcName.includes(wSvcName) ||
                        wSvcName.includes(cartSvcName)
                    );
                    return isIdMatch || isNameMatch;
                });
            } else {
                const walletSvcId = String(
                    wallet.serviceId?._id ||
                    wallet.serviceId?.id ||
                    (typeof wallet.serviceId === 'string' ? wallet.serviceId : '') ||
                    wallet.walletPackageId?.serviceId?._id ||
                    wallet.walletPackageId?.serviceId?.id ||
                    (typeof wallet.walletPackageId?.serviceId === 'string' ? wallet.walletPackageId?.serviceId : '') ||
                    ''
                );
                const walletSvcName = (
                    wallet.serviceId?.serviceName ||
                    wallet.walletPackageId?.serviceId?.serviceName ||
                    wallet.walletPackageId?.name ||
                    ''
                ).toLowerCase().trim();

                const isIdMatch = walletSvcId && cartSvcId && walletSvcId === cartSvcId;
                const isNameMatch = walletSvcName && cartSvcName && (
                    cartSvcName === walletSvcName ||
                    cartSvcName.includes(walletSvcName) ||
                    walletSvcName.includes(cartSvcName)
                );
                return isIdMatch || isNameMatch;
            }
        });

        const displaySvcName = wallet.services && wallet.services.length > 0
            ? wallet.services.map(s => s.serviceId?.serviceName || 'Service').join(', ')
            : (wallet.serviceId?.serviceName || wallet.walletPackageId?.name || 'matching service');

        if (matchIdx === -1) {
            const hasAnyServices = cart.some(item => item.category?.toLowerCase() === 'service');
            if (!hasAnyServices) {
                toast.warning(`Cart contains no matching services. Please add eligible service (${displaySvcName}) to the cart first.`);
            } else {
                toast.warning(`Please add eligible service (${displaySvcName}) to the cart first.`);
            }
            return;
        }

        // Toggle or Apply Wallet
        if (cart[matchIdx].isServiceWalletApplied && cart[matchIdx].customerWalletId === wallet._id) {
            setCart(prev => {
                const updated = [...prev];
                const restoredPrice = updated[matchIdx].unitPriceOriginal !== undefined
                    ? updated[matchIdx].unitPriceOriginal
                    : (updated[matchIdx].originalPrice || updated[matchIdx].nonMemberShipPrice || 0);

                updated[matchIdx] = {
                    ...updated[matchIdx],
                    isServiceWalletApplied: false,
                    customerWalletId: null,
                    serviceWalletName: null,
                    price: restoredPrice,
                    unitPrice: restoredPrice,
                    totalPrice: restoredPrice * (updated[matchIdx].qty || 1),
                    total: restoredPrice * (updated[matchIdx].qty || 1)
                };
                return updated;
            });
            toast.info(`Service Wallet unapplied from item`);
            return;
        }

        setCart(prev => {
            const updated = [...prev];
            const currentItem = updated[matchIdx];
            const originalPrice = (currentItem.unitPriceOriginal !== undefined && currentItem.unitPriceOriginal > 0)
                ? currentItem.unitPriceOriginal
                : (currentItem.price || currentItem.unitPrice || currentItem.nonMemberShipPrice || 0);

            const qty = currentItem.qty || 1;

            updated[matchIdx] = {
                ...currentItem,
                isServiceWalletApplied: true,
                customerWalletId: wallet._id,
                serviceWalletName: wallet.walletPackageId?.name || wallet.customWalletName || 'Service Wallet',
                unitPriceOriginal: originalPrice,
                unitPrice: originalPrice,
                price: originalPrice,
                totalPrice: originalPrice * qty,
                total: originalPrice * qty
            };
            return updated;
        });
        toast.success(`✓ Service Wallet applied to "${cart[matchIdx].serviceName || cart[matchIdx].name}"`);
    };

    const toggleServiceWalletForCartRow = (rowId) => {
        setCart(prev => prev.map(item => {
            if (item.rowId !== rowId) return item;
            const restoredPrice = item.unitPriceOriginal !== undefined
                ? item.unitPriceOriginal
                : (item.originalPrice || item.nonMemberShipPrice || item.price || 0);

            return {
                ...item,
                isServiceWalletApplied: false,
                customerWalletId: null,
                serviceWalletName: null,
                price: restoredPrice,
                unitPrice: restoredPrice,
                totalPrice: restoredPrice * (item.qty || 1),
                total: restoredPrice * (item.qty || 1)
            };
        }));
        toast.info("Service Wallet unapplied from item.");
    };

    const [gstType, setGstType] = useState("Inclusive");
    const [gstRate, setGstRate] = useState("");
    const [formData, setFormData] = useState({
        transactionType: 'SALE'
    });
    const isMembershipBilling = formData.transactionType === "MEMBERSHIP";
    const [currentStore, setCurrentStore] = useState(null);

    // Fetch Store Logic
    useEffect(() => {
        if (selectedStoreId) {
            const fetchCurrentStore = async () => {
                try {
                    const res = await getData(`stores/store/${selectedStoreId}`, {}, sessionToken);
                    setCurrentStore(res?.data);
                } catch (error) {
                    console.error("Failed to fetch store details", error);
                }
            };
            const fetchAvailableCoupons = async () => {
                try {
                    const res = await getData("coupons/coupons", { storeId: selectedStoreId, page: 1, limit: 100 }, sessionToken);
                    if (res?.status === 200) {
                        const allCoupons = res?.data?.results || [];
                        setAvailableCoupons(allCoupons);
                    }
                } catch (error) {
                    console.error("Failed to fetch coupons", error);
                }
            };
            fetchCurrentStore();
            fetchAvailableCoupons();
        }
    }, [selectedStoreId]);

    // Refresh coupons when modal opens
    useEffect(() => {
        if (showCouponModal && selectedStoreId) {
            const fetchAvailableCoupons = async () => {
                try {
                    const res = await getData("coupons/coupons", { storeId: selectedStoreId, page: 1, limit: 100 }, sessionToken);
                    if (res?.status === 200) {
                        const allCoupons = res?.data?.results || [];
                        setAvailableCoupons(allCoupons);
                    }
                } catch (error) {
                    console.error("Failed to fetch coupons", error);
                }
            };
            fetchAvailableCoupons();
        }
    }, [showCouponModal, selectedStoreId]);

    // 🗓️ AUTOMATICALLY FETCH & POPULATE APPOINTMENT DETAILS IN POS
    useEffect(() => {
        if (!appointmentId) return;

        const fetchAndPopulateAppointment = async () => {
            try {
                const token = localStorage.getItem("Token") || sessionToken;
                const res = await getData(`appointmentbookings/appointmentbooking/${appointmentId}`, {}, token);

                const appointmentData = res?.data;
                if (!appointmentData) {
                    toast.error("Appointment details not found.");
                    return;
                }

                const statusLower = (appointmentData.status || "").toLowerCase();

                if (statusLower === "completed") {
                    navigate("/pos", { replace: true });
                    return;
                }

                if (statusLower === "expired" || statusLower === "cancelled" || statusLower === "rejected") {
                    toast.error(`This appointment is ${appointmentData.status} and cannot be billed.`);
                    navigate("/appointments");
                    return;
                }

                setLoadedAppointmentId(appointmentData._id);

                // 1. Auto-select Store if present
                if (appointmentData.storeId?._id && setSelectedStoreId) {
                    const appStoreId = appointmentData.storeId._id;
                    if (selectedStoreId !== appStoreId) {
                        setSelectedStoreId(appStoreId);
                    }
                }

                // 2. Auto-select Customer
                const customer = appointmentData.customerId;
                if (customer && customer._id) {
                    const customerOption = {
                        value: customer._id,
                        label: `${customer.name} (${customer.phoneNumber || 'N/A'})`,
                        phone: customer.phoneNumber || '',
                        data: customer,
                        subscriptionDetails: customer.subscriptionDetails || []
                    };

                    setSelectedCustomerOption(customerOption);
                    setFormData(prev => ({
                        ...prev,
                        customerId: customer._id,
                        customerName: customer.name,
                        customerPhone: customer.phoneNumber || ''
                    }));

                    fetchCustomerWallets(customer._id);
                }

                // 3. Populate Cart with Appointment Service(s) and assigned Employee(s)
                const servicesList = Array.isArray(appointmentData.serviceId)
                    ? appointmentData.serviceId
                    : (appointmentData.serviceId ? [appointmentData.serviceId] : []);

                const employeesList = Array.isArray(appointmentData.employeeId)
                    ? appointmentData.employeeId
                    : (appointmentData.employeeId ? [appointmentData.employeeId] : []);

                if (servicesList.length === 0) {
                    toast.warn("No services found in this appointment.");
                    return;
                }

                const appointmentCartItems = servicesList.map((svcObj, idx) => {
                    const serviceDoc = (typeof svcObj === "object" && svcObj !== null) ? svcObj : {};
                    const serviceId = serviceDoc._id || svcObj;
                    const serviceName = serviceDoc.serviceName || "Appointment Service";

                    const assignedEmp = employeesList[idx] || employeesList[0] || null;
                    const empId = assignedEmp?._id || (typeof assignedEmp === 'string' ? assignedEmp : null);
                    const empName = assignedEmp?.name || assignedEmp?.employeeName || (assignedEmp?.firstName ? `${assignedEmp.firstName} ${assignedEmp.lastName || ''}`.trim() : null);

                    const finalPrice = Number(serviceDoc.nonMemberShipPrice || serviceDoc.price || 0);
                    const gstPercentage = Number(serviceDoc.gstPercentage || 0);

                    return {
                        rowId: crypto.randomUUID(),
                        _id: serviceId,
                        cartId: null,
                        category: "service",
                        qty: 1,
                        productId: null,
                        serviceId: serviceId,
                        subscriptionId: null,
                        employeeId: empId,
                        employeeIds: empId ? [empId] : [],
                        employeeName: empName,
                        employee: empName,
                        name: serviceName,
                        price: finalPrice,
                        originalPrice: finalPrice,
                        mrp: null,
                        mrpHistoryId: null,
                        gstPercentage: gstPercentage,
                        discountType: "FLAT",
                        discountValue: 0,
                        manualDiscount: 0,
                        isAppointmentService: true,
                        appointmentId: appointmentData._id
                    };
                });

                setCart(appointmentCartItems);

                toast.success(`✓ Loaded appointment for ${customer?.name || "Customer"} with ${servicesList.length} service(s).`);

            } catch (err) {
                console.error("Failed to fetch appointment details for POS:", err);
                toast.error("Failed to load appointment details.");
            }
        };

        fetchAndPopulateAppointment();
    }, [appointmentId, fetchCustomerWallets, selectedStoreId, setSelectedStoreId]);

    // Pagination logic



    const [payments, setPayments] = useState([{ method: "", amount: 0, cardNumber: "" }]);

    const isAnyWalletApplied = useMemo(() => {
        let serviceTotal = 0;
        let serviceWalletDeduction = 0;

        (cart || []).forEach(item => {
            if (item.category && item.category.toLowerCase() === 'service') {
                const amount = Number(item.price || item.unitPrice || 0) * Number(item.qty || 1);
                serviceTotal += amount;
                if (item.isServiceWalletApplied) {
                    serviceWalletDeduction += amount;
                }
            }
        });

        const unallocatedServiceTotal = Math.max(0, serviceTotal - serviceWalletDeduction);
        const hasActiveCashWallet = (customerWallets || []).some(w => w.type === 'Cash' && w.status === 'ACTIVE' && (w.balance || 0) > 0);

        return cart.some(item => item.isServiceWalletApplied) ||
            (isCashWalletApplied && appliedCashWallet && Number(customWalletDeductionAmount) > 0) ||
            payments.some(p => p.method === "WALLET" && Number(p.amount) > 0);
    }, [cart, isCashWalletApplied, appliedCashWallet, customWalletDeductionAmount, payments, customerWallets]);

    const handleWalletDeductionChange = (inputVal, appliedState = true) => {
        setIsCashWalletApplied(appliedState);
        setCustomWalletDeductionAmount(inputVal);

        if (!appliedState) {
            setCustomWalletDeductionAmount(0);
        }

        const numVal = appliedState ? Math.max(0, Number(inputVal) || 0) : 0;
        const totals = getProductAndServiceTotals ? getProductAndServiceTotals() : { serviceTotal: 0 };
        const serviceWalletDeduction = (cart || [])
            .filter(i => i.isServiceWalletApplied)
            .reduce((sum, i) => sum + (Number(i.price || i.total || 0) * Number(i.qty || 1)), 0);
        const eligibleServiceAmount = Math.max(0, totals.serviceTotal - serviceWalletDeduction);
        const maxEligible = appliedCashWallet ? Math.min(appliedCashWallet.balance || 0, eligibleServiceAmount) : 0;
        const clampedDeduction = Math.min(numVal, maxEligible);

        const actualCashPayable = Math.max(0, invoiceSummary.finalAmount);
        const remainingOutofPocket = Number(Math.max(0, actualCashPayable - clampedDeduction).toFixed(2));

        setPaymentModalTotal(remainingOutofPocket);

        setPayments(prevPayments => {
            const nonWalletPayments = (prevPayments || []).filter(p => !p.isWalletRow && p.method !== "WALLET");
            const updated = [];

            if (clampedDeduction > 0 && appliedCashWallet) {
                updated.push({
                    method: "WALLET",
                    amount: clampedDeduction,
                    receivedAmount: clampedDeduction,
                    walletName: appliedCashWallet.walletPackageId?.name || appliedCashWallet.customWalletName || "Cash Wallet",
                    isWalletRow: true
                });
            }

            if (remainingOutofPocket > 0 || updated.length === 0) {
                const primaryMethod = nonWalletPayments[0]?.method || "CASH";
                const primaryCard = nonWalletPayments[0]?.cardNumber || null;
                updated.push({
                    method: primaryMethod,
                    amount: remainingOutofPocket,
                    receivedAmount: remainingOutofPocket,
                    cardNumber: primaryCard
                });
            }

            return updated;
        });
    };

    const handleToggleServiceWalletInCheckout = (checked) => {
        setIsServiceWalletUsedInCheckout(checked);

        let updatedCart = [...cart];
        if (!checked) {
            updatedCart = updatedCart.map(item => {
                if (!item.isServiceWalletApplied) return item;
                const restoredPrice = (item.unitPriceOriginal !== undefined && item.unitPriceOriginal > 0)
                    ? item.unitPriceOriginal
                    : (item.originalPrice || item.nonMemberShipPrice || item.price || 0);

                return {
                    ...item,
                    isServiceWalletApplied: false,
                    customerWalletId: null,
                    serviceWalletName: null,
                    price: restoredPrice,
                    unitPrice: restoredPrice,
                    totalPrice: restoredPrice * (item.qty || 1),
                    total: restoredPrice * (item.qty || 1)
                };
            });
            toast.info("Service Wallet redemption paused for checkout");
        } else {
            const activeServiceWallets = (customerWallets || []).filter(w => {
                if (w.type !== 'Service' || (w.status !== 'ACTIVE' && w.status !== 'Active') || w.isActive === false) return false;
                if (w.services && w.services.length > 0) {
                    return w.services.some(s => (s.remainingCount || 0) > 0);
                }
                return (w.remainingCount || 0) > 0 || (w.balance || 0) > 0;
            });

            updatedCart = updatedCart.map(item => {
                const isSvc = item.category?.toLowerCase() === 'service';
                if (!isSvc) return item;

                const cartSvcId = String(
                    item.serviceId?._id ||
                    item.serviceId?.id ||
                    (typeof item.serviceId === 'string' ? item.serviceId : '') ||
                    item.id ||
                    item._id ||
                    ''
                );
                const cartSvcName = (item.serviceName || item.name || item.title || '').toLowerCase().trim();

                const matchingWallet = activeServiceWallets.find(w => {
                    let serviceRemCount = 0;
                    let isMatch = false;

                    if (w.services && w.services.length > 0) {
                        const matchedEntry = w.services.find(s => {
                            const svcObj = s.serviceId;
                            const wSvcId = String(svcObj?._id || svcObj?.id || (typeof svcObj === 'string' ? svcObj : '') || '');
                            const wSvcName = (svcObj?.serviceName || '').toLowerCase().trim();

                            const isIdMatch = wSvcId && cartSvcId && wSvcId === cartSvcId;
                            const isNameMatch = wSvcName && cartSvcName && (
                                cartSvcName === wSvcName ||
                                cartSvcName.includes(wSvcName) ||
                                wSvcName.includes(cartSvcName)
                            );
                            return (isIdMatch || isNameMatch) && (s.remainingCount || 0) > 0;
                        });
                        if (matchedEntry) {
                            isMatch = true;
                            serviceRemCount = matchedEntry.remainingCount || 0;
                        }
                    } else {
                        const walletSvcId = String(
                            w.serviceId?._id ||
                            w.serviceId?.id ||
                            (typeof w.serviceId === 'string' ? w.serviceId : '') ||
                            w.walletPackageId?.serviceId?._id ||
                            w.walletPackageId?.serviceId?.id ||
                            (typeof w.walletPackageId?.serviceId === 'string' ? w.walletPackageId?.serviceId : '') ||
                            ''
                        );
                        const walletSvcName = (
                            w.serviceId?.serviceName ||
                            w.walletPackageId?.serviceId?.serviceName ||
                            w.walletPackageId?.name ||
                            ''
                        ).toLowerCase().trim();

                        const isIdMatch = walletSvcId && cartSvcId && walletSvcId === cartSvcId;
                        const isNameMatch = walletSvcName && cartSvcName && (
                            cartSvcName === walletSvcName ||
                            cartSvcName.includes(walletSvcName) ||
                            walletSvcName.includes(cartSvcName)
                        );

                        if (isIdMatch || isNameMatch) {
                            isMatch = true;
                            serviceRemCount = w.remainingCount || 0;
                        }
                    }

                    if (!isMatch || (serviceRemCount <= 0 && (!w.balance || w.balance <= 0))) return false;
                    return true;
                });

                if (matchingWallet) {
                    const originalPrice = (item.unitPriceOriginal !== undefined && item.unitPriceOriginal > 0)
                        ? item.unitPriceOriginal
                        : (item.price || item.unitPrice || item.nonMemberShipPrice || 0);

                    const qty = item.qty || 1;
                    return {
                        ...item,
                        isServiceWalletApplied: true,
                        customerWalletId: matchingWallet._id,
                        serviceWalletName: matchingWallet.walletPackageId?.name || matchingWallet.customWalletName || 'Service Wallet',
                        unitPriceOriginal: originalPrice,
                        unitPrice: originalPrice,
                        price: originalPrice,
                        totalPrice: originalPrice * qty,
                        total: originalPrice * qty
                    };
                }

                return item;
            });
            toast.success("✓ Service Wallet applied for checkout!");
        }

        setCart(updatedCart);

        const newSummary = computeInvoiceSummary(updatedCart);

        let cashDeduction = 0;
        if (isCashWalletApplied && appliedCashWallet) {
            const unallocatedSvcTotal = updatedCart
                .filter(i => (!i.category || String(i.category).toLowerCase() === "service") && !i.isServiceWalletApplied)
                .reduce((sum, i) => sum + (Number(i.price || i.total || 0) * Number(i.qty || 1)), 0);
            const maxEligible = Math.min(appliedCashWallet.balance || 0, unallocatedSvcTotal);
            cashDeduction = Math.min(Math.max(0, Number(customWalletDeductionAmount) || 0), maxEligible);
        }

        const remainingOutofPocket = Math.max(0, Number((newSummary.finalAmount - cashDeduction).toFixed(2)));
        setPaymentModalTotal(remainingOutofPocket);

        setPayments(prevPayments => {
            const nonWalletPayments = (prevPayments || []).filter(p => !p.isWalletRow && p.method !== "WALLET");
            const updated = [];

            if (cashDeduction > 0 && appliedCashWallet) {
                updated.push({
                    method: "WALLET",
                    amount: cashDeduction,
                    receivedAmount: cashDeduction,
                    walletName: appliedCashWallet.walletPackageId?.name || appliedCashWallet.customWalletName || "Cash Wallet",
                    isWalletRow: true
                });
            }

            if (remainingOutofPocket > 0 || updated.length === 0) {
                const primaryMethod = nonWalletPayments[0]?.method || "CASH";
                const primaryCard = nonWalletPayments[0]?.cardNumber || null;
                updated.push({
                    method: primaryMethod,
                    amount: remainingOutofPocket,
                    receivedAmount: remainingOutofPocket,
                    cardNumber: primaryCard
                });
            }

            return updated;
        });
    };

    useEffect(() => {
        if (isAnyWalletApplied) {
            if (Number(overallDiscount) > 0 || appliedCoupons.length > 0) {
                toast.info("Discounts and coupons are removed because a wallet is applied.");
            }
            setOverallDiscount(0);
            setAppliedCoupons([]);
            setCouponInput("");
        }
    }, [isAnyWalletApplied]);
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '95%', sm: 400 },
        bgcolor: '#ffffff',
        borderRadius: 12,
        boxShadow: 24,
        p: { xs: 2, sm: 4 },
        border: 0
    };

    // Auto-scroll to bottom of cart when new items are added
    useEffect(() => {
        if (cartContainerRef.current) {
            cartContainerRef.current.scrollTo({
                top: cartContainerRef.current.scrollHeight,
                behavior: 'smooth'
            });
        }
    }, [cart.length]);
    // 🔒 RESTRICT POS ACCESS TO AUTHORIZED & ASSIGNED EMPLOYEES ONLY
    useEffect(() => {
        if (!sessionToken) {
            navigate("/login");
            return;
        }

        const hasPosAccess = localStorage.getItem("hasPosAccess") === "true" || sessionStorage.getItem("hasPosAccess") === "true";

        // Roles that MUST have at least one store assigned to use POS
        const STORE_DEPENDENT_ROLES = [
            "FranchiseAdmin", "ClusterManager", "StoreAdmin", "StoreManager", "Manager", "Accountant", "Biller"
        ];

        const isUnassignedEmployee = STORE_DEPENDENT_ROLES.includes(loggedInRole) && adminStoreIds.length === 0;

        if (!hasPosAccess || isUnassignedEmployee) {
            toast.error("Access Denied: You do not have POS access assigned or are not assigned to a store.");

            // Redirect based on role
            if (loggedInRole === "StoreCreator") {
                navigate("/stores");
            } else if (loggedInRole === "Accountant") {
                navigate("/sales");
            } else {
                navigate("/dashboard");
            }
        }
    }, [loggedInRole, adminStoreIds, sessionToken, navigate]);
    const addPaymentRow = () => {
        setPayments([...payments, { method: "", amount: "", cardNumber: "" }]);
    };

    const removePaymentRow = (index) => {
        setPayments(payments.filter((_, i) => i !== index));
    };

    const handlePaymentChange = (index, field, value) => {
        const updatedPayments = [...payments];

        updatedPayments[index][field] = value;

        const totalBill =
            paymentModalTotal || invoiceSummary.finalAmount || 0;

        // 🔥 AUTO BALANCE AMOUNT FOR NEXT PAYMENT
        if (field === "method") {
            const alreadyEntered = updatedPayments.reduce(
                (sum, p, i) =>
                    i !== index ? sum + Number(p.amount || 0) : sum,
                0
            );

            const remainingAmount = Math.max(
                totalBill - alreadyEntered,
                0
            );

            updatedPayments[index].amount = remainingAmount;

            // CASH ku received amount auto set
            if (value === "CASH") {
                updatedPayments[index].receivedAmount =
                    remainingAmount;
            }
        }

        const totalEntered = updatedPayments.reduce(
            (sum, payment) => sum + Number(payment.amount || 0),
            0
        );

        updatedPayments.forEach((payment) => {
            const amount = Number(payment.amount || 0);
            const received = Number(payment.receivedAmount || 0);

            if (payment.method === "CASH") {
                payment.changeAmount =
                    received > amount
                        ? received - amount
                        : 0;
            } else {
                payment.changeAmount = 0;
            }
        });

        const extraChange =
            totalEntered > totalBill
                ? totalEntered - totalBill
                : 0;

        const cashIndex = updatedPayments.findIndex(
            (p) => p.method === "CASH"
        );

        if (cashIndex !== -1) {
            updatedPayments[cashIndex].changeAmount =
                extraChange;
        }

        setPayments(updatedPayments);
    };


    const [approvedBackDate, setApprovedBackDate] = useState(() => {
        return localStorage.getItem("approvedBackDate") || null;
    });

    const [invoiceDate, setInvoiceDate] = useState(() => {
        const savedDate = localStorage.getItem("approvedBackDate");
        if (savedDate) return savedDate;
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    });

    // ---- Back-date OTP states ----
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [otpInput, setOtpInput] = useState("");
    const [pendingDate, setPendingDate] = useState(null);
    const [otpSent, setOtpSent] = useState(false);
    const [otpLoading, setOtpLoading] = useState(false);
    const [otpVerifying, setOtpVerifying] = useState(false);

    useEffect(() => {

        if (!selectedStoreId) return;

        checkOpeningCash();

    }, [selectedStoreId]);


    const checkOpeningCash = async () => {
        const todayString = (() => {
            const d = new Date();
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        })();
        const cacheKey = `opening_cash_${selectedStoreId}_${todayString}`;
        const cachedStatus = localStorage.getItem(cacheKey);

        // Skip if already checked and completed/dismissed for today
        if (cachedStatus === "true" || cachedStatus === "dismissed") {
            return;
        }

        try {
            const res = await getData(
                "eod/opening-cash-status",
                {
                    storeId: selectedStoreId
                },
                sessionToken
            );

            console.log("Opening Cash Response", res.data);

            // // 1. Verification check: if the previous day's EOD was not closed correctly
            // if (res?.data?.isPreviousDayClosed === false) {
            //     const prevDayResult = await Swal.fire({
            //         icon: "warning",
            //         title: "Previous Day EOD Not Closed",
            //         text: "The previous day's EOD Closing was not completed. Please update the Opening Cash before proceeding.",
            //         showCancelButton: true,
            //         confirmButtonText: "Go to EOD Report",
            //         cancelButtonText: "Update Opening Cash",
            //         confirmButtonColor: "#3C0008",
            //         cancelButtonColor: "#64748b",
            //         allowOutsideClick: false
            //     });

            //     if (prevDayResult.isConfirmed) {
            //         navigate("/reports/eod");
            //         return;
            //     }
            // }

            if (res?.data?.hasOpeningCash || res?.data?.isTodayClosed) {
                localStorage.setItem(cacheKey, "true");
                return;
            }



            // 2. Only show the Swal popup if backend explicitly confirms opening cash status is false
            if (res?.data?.hasOpeningCash === false) {
                Swal.fire({
                    title: "Opening Cash",
                    html: `
                        <style>
                            .swal2-html-container {
                                overflow: visible !important;
                            }
                            .swal2-popup {
                                overflow: visible !important;
                            }
                            .info-tooltip-container {
                                position: relative;
                                display: inline-flex;
                                align-items: center;
                                justify-content: center;
                                cursor: pointer;
                                width: 20px;
                                height: 20px;
                                border: 1.5px solid #0284c7;
                                border-radius: 50%;
                                font-family: serif;
                                font-weight: bold;
                                font-style: italic;
                                color: #0284c7;
                                background-color: #f0f9ff;
                                font-size: 13px;
                            }
                            .info-tooltip-text {
                                visibility: hidden;
                                width: 260px;
                                background-color: #1e293b;
                                color: #fff;
                                text-align: left;
                                border-radius: 6px;
                                padding: 10px;
                                position: absolute;
                                z-index: 9999;
                                bottom: 130%;
                                left: -10px;
                                opacity: 0;
                                transition: opacity 0.2s ease-in-out;
                                font-size: 12px;
                                font-weight: normal;
                                font-family: sans-serif;
                                line-height: 1.4;
                                box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.3), 0 4px 6px -4px rgb(0 0 0 / 0.3);
                            }
                            .info-tooltip-text::after {
                                content: "";
                                position: absolute;
                                top: 100%;
                                left: 18px;
                                border-width: 6px;
                                border-style: solid;
                                border-color: #1e293b transparent transparent transparent;
                            }
                            .info-tooltip-container:hover .info-tooltip-text {
                                visibility: visible;
                                opacity: 1;
                            }
                        </style>
                        <div style="text-align: left; font-family: sans-serif;">
                            <div style="font-size: 14px; font-weight: 700; margin-bottom: 12px; color: #1e293b;">
                                Previous Closing Cash: <span style="color: #3C0008; font-size: 16px;">${res.data.previousClosingCash || 0}</span>
                            </div>
                            
                            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 12px; background: #f0f9ff; padding: 10px; border-radius: 8px; border: 1px solid #bae6fd;">
                                <div class="info-tooltip-container">
                                    i
                                    <span class="info-tooltip-text">
                                        The cash handling process should be followed carefully. Please double check all daily cash entries.
                                    </span>
                                </div>
                                <div style="font-size: 13px; color: #0369a1; font-weight: 500;">
                                    This is a one-time cash entry for today.
                                </div>
                            </div>
                            
                            <div style="margin-bottom: 20px; font-size: 12px; color: #b91c1c; font-weight: 600; background: #fef2f2; padding: 10px; border-radius: 8px; border: 1px solid #fecaca; line-height: 1.4;">
                                ⚠️ Once the Opening Cash is saved, it cannot be edited or modified later. Please enter the amount carefully.
                            </div>
                            
                            <label for="swal-input-cash" style="font-size: 13px; font-weight: 600; display: block; margin-bottom: 8px; color: #334155;">
                                Additional Petty Cash:
                            </label>
                            <input id="swal-input-cash" placeholder='Enter petty cash...' type="number" class="swal2-input" style="margin: 0; width: 100%; box-sizing: border-box; font-size: 14px;" placeholder="0" min="0">
                        </div>
                    `,
                    confirmButtonText: "Save & Continue",
                    showCancelButton: true,
                    cancelButtonText: "Close",
                    confirmButtonColor: "#3C0008",
                    cancelButtonColor: "#3C0008",
                    allowOutsideClick: false,
                    preConfirm: () => {
                        const inputElement = document.getElementById("swal-input-cash");
                        const val = inputElement ? inputElement.value : "";
                        if (val && Number(val) < 0) {
                            Swal.showValidationMessage("Opening cash cannot be negative");
                            return false;
                        }
                        return val;
                    }
                }).then(async result => {
                    if (result.isConfirmed) {
                        try {
                            const saveRes = await postData(
                                "eod/save-opening-cash",
                                {
                                    storeId: selectedStoreId,
                                    additionalPettyCash:
                                        Number(result.value || 0)
                                }, sessionToken
                            );

                            if (saveRes?.success !== false) {
                                localStorage.setItem(cacheKey, "true");
                            }
                        } catch (err) {
                            console.error("Failed to save opening cash:", err);
                        }
                    } else {
                        // Cache the dismissal so it doesn't pop up again for today
                        localStorage.setItem(cacheKey, "dismissed");
                    }
                });
            }
        } catch (error) {
            console.error("Failed to verify opening cash status:", error);
        }
    };


    // Today's date string (YYYY-MM-DD)
    const todayStr = (() => {
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    })();

    /** Called by BOTH date inputs — blocks past dates behind OTP */
    const handleInvoiceDateChange = (e) => {
        const selected = e.target.value;

        // 🔒 RESTRICT TODAY'S DATE DURING BACKDATE SESSION
        if (approvedBackDate && selected === todayStr) {
            Swal.fire({
                title: "Confirm Session Closure?",
                text: "Have you completed all backdated bills? To continue with backdated billing again, OTP verification will be required",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3C0008",
                cancelButtonColor: "#6c757d",
                confirmButtonText: "Yes, Close Session",
                cancelButtonText: "No, Continue Backdating"
            }).then((result) => {
                if (result.isConfirmed) {
                    handleCloseBackdateSession();
                }
            });
            return;
        }

        // Same day or no change or already unlocked session or StoreAdmin → allow directly
        if (selected >= todayStr || approvedBackDate || loggedInRole === "StoreAdmin") {
            setInvoiceDate(selected);
            if (selected < todayStr) {
                setApprovedBackDate(selected);
                localStorage.setItem("approvedBackDate", selected);
            }
            return;
        }
        // Past date → trigger OTP flow
        setPendingDate(selected);
        setOtpInput("");
        setOtpSent(false);
        setShowOtpModal(true);
    };

    /** Explicitly close the back-date session */
    const handleCloseBackdateSession = () => {
        localStorage.removeItem("approvedBackDate");
        setApprovedBackDate(null);
        setInvoiceDate(todayStr);
        toast.info("Back-dated billing session closed.");
    };

    /** Validation for StoreAdmin store selection */
    const handleStoreValidation = (e) => {
        if (loggedInRole === "StoreAdmin" && adminStoreIds.length > 1 && !selectedStoreId) {
            e.preventDefault();
            e.stopPropagation();
            toast.warning("Please select your store before proceeding");
            return false;
        }
        return true;
    };

    /** Send OTP to Store Admin */
    const handleSendBackdateOtp = async () => {
        if (!selectedStoreId) return toast.error("Please select a store first");
        setOtpLoading(true);
        try {
            const res = await postData(
                "otps/otp/send-back-bill",
                { storeId: selectedStoreId, purpose: "BACKDATE_BILLING", requestedBy: userId },
                sessionToken
            );
            if (res?.status === 200 || res?.success) {
                setOtpSent(true);
                toast.success("OTP sent to Store Admin");
            } else {
                toast.error(res?.message || "Failed to send OTP");
            }
        } catch {
            toast.error("Failed to send OTP. Please try again.");
        } finally {
            setOtpLoading(false);
        }
    };



    /** Verify OTP and unlock the back date */
    const handleVerifyBackdateOtp = async () => {
        if (!otpInput.trim()) return toast.error("Please enter the OTP");
        setOtpVerifying(true);
        try {
            const res = await postData(
                "otps/otp/verify-back-bill",
                { storeId: selectedStoreId, otp: otpInput.trim(), purpose: "BACKDATE_BILLING", requestedBy: userId },
                sessionToken
            );
            if (res?.status === 200 || res?.success) {
                setInvoiceDate(pendingDate);
                setApprovedBackDate(pendingDate); // Unlock session for future bills
                localStorage.setItem(
                    "approvedBackDate",
                    pendingDate
                );
                setShowOtpModal(false);
                setPendingDate(null);
                setOtpInput("");
                setOtpSent(false);
                toast.success("✅ OTP Verified! Back-date billing session active.");
            } else {
                toast.error(res?.message || "❌ Invalid OTP. Please try again.");
            }
        } catch {
            toast.error("OTP verification failed. Please try again.");
        } finally {
            setOtpVerifying(false);
        }
    };


    useEffect(() => {
        const savedDate =
            localStorage.getItem("approvedBackDate");

        if (savedDate) {
            setApprovedBackDate(savedDate);
            setInvoiceDate(savedDate);
        }
    }, []);


    // ----------------- Fetch Data -----------------

    const processTopSellers = (items, topCount = 5, key = "totalSoldQty") => {
        if (!items || items.length === 0) return [];
        // Sort descending by totalSoldQty
        const sorted = [...items].sort((a, b) => (b[key] || 0) - (a[key] || 0));
        // Mark top N
        return sorted.map((item, idx) => ({
            ...item,
            isTopSeller: idx < topCount
        }));
    };

    const STORE_SCOPED_ROLES = [
        "Biller",
        "StoreAdmin",
        "StoreManager",
        "ClusterManager"
    ];


    useEffect(() => {
        if (!selectedStoreId && initialStoreId) {
            setSelectedStoreId(initialStoreId);
        }
    }, [selectedStoreId, initialStoreId]);

    // ----------------- Cart Actions -----------------
    const calculateMembershipDiscount = (item, membership) => {
        if (!membership) {
            return { discount: 0, finalPrice: item.price };
        }

        const nonMemberPrice = Number(item.nonMemberShipPrice) || Number(item.price) || 0;

        // Strict check: if membershipPrice is null/undefined, use nonMemberPrice
        const hasMemberPrice = item.membershipPrice !== null && item.membershipPrice !== undefined;
        const memberPrice = hasMemberPrice ? Number(item.membershipPrice) : nonMemberPrice;

        const baseBenefit = Math.max(0, nonMemberPrice - memberPrice);

        let totalDiscount = 0;

        if (membership.subscriptionValueType === "SERVICE") {
            totalDiscount = baseBenefit;
        } else if (membership.subscriptionValueType === "PERCENTAGE") {
            const percent = Math.min(Number(membership.subscriptionValue || 0), 100);
            // Apply percentage directly on the original price
            totalDiscount = (nonMemberPrice * percent) / 100;
        }

        const finalPrice = Math.max(nonMemberPrice - totalDiscount, 0);

        return {
            discount: Number(totalDiscount.toFixed(2)),
            finalPrice: Number(finalPrice.toFixed(2)),
        };
    };

    // ✅ Separate cart items
    const normalItems = cart.filter(
        item => item.category === "product" || item.category === "service"
    );

    const membershipItems = cart.filter(
        item => item.category === "membership"
    );



    const addToCart = async (item, type, selectedMrpOption = null) => {
        setShowPrintButton(false);

        try {
            if (!userId) return toast.error("No logged-in employee found");
            if (!selectedStoreId) return toast.error("Please select a store");

            if (formData.transactionType !== "SELF" && !selectedCustomerOption) {
                return toast.error("Please select a customer before adding items to cart");
            }

            /* 🔹 MULTI-MRP CHECK FOR PRODUCTS */
            if (type === "Product") {
                let fullProduct = products.find(
                    p => String(p._id || p.productId) === String(item._id || item.productId)
                ) || item;

                // 🔸 Fetch real-time fresh product stock & mrpHistory from backend API
                const token = localStorage.getItem("Token");
                const searchName = item.title || item.label || item.productName || item.data?.title || "";
                if (searchName && selectedStoreId && token) {
                    try {
                        const freshRes = await getData(
                            `inventories/products/${selectedStoreId}`,
                            { page: 1, limit: 10, search: searchName },
                            token
                        );
                        const pData = Array.isArray(freshRes?.data) ? freshRes.data[0] : freshRes?.data;
                        const rawProducts = pData?.paginatedResults || (Array.isArray(freshRes?.data) ? freshRes.data : []);
                        const foundFresh = rawProducts.find(
                            p => String(p._id || p.productId) === String(item._id || item.productId)
                        );
                        if (foundFresh) {
                            fullProduct = foundFresh;
                            setProducts(prev => {
                                const existingIndex = prev.findIndex(p => String(p._id || p.productId) === String(foundFresh._id || foundFresh.productId));
                                if (existingIndex === -1) return [...prev, foundFresh];
                                const updated = [...prev];
                                updated[existingIndex] = foundFresh;
                                return updated;
                            });
                        }
                    } catch (freshErr) {
                        console.error("Failed to fetch fresh product stock:", freshErr);
                    }
                }

                // 🚫 BLOCK IF TOTAL PRODUCT STOCK IS 0
                const totalStock = Number(fullProduct.inStock || fullProduct.stock || 0);
                if (totalStock <= 0) {
                    return toast.error(`🚫 Cannot add to cart: "${fullProduct.title || fullProduct.name || item.label || 'Product'}" is OUT OF STOCK.`);
                }

                if (selectedMrpOption) {
                    const selectedMrpStock = Number(selectedMrpOption.stock || 0);
                    if (selectedMrpStock <= 0) {
                        return toast.error(`🚫 Cannot add to cart: Price option (₹${selectedMrpOption.mrp}) is OUT OF STOCK.`);
                    }
                }

                const mrpHistory = Array.isArray(fullProduct.mrpHistory) ? fullProduct.mrpHistory : [];

                if (mrpHistory.length > 1 && !selectedMrpOption) {
                    const mrpMap = {};
                    mrpHistory.forEach(entry => {
                        if (entry.mrp !== undefined && entry.mrp !== null) {
                            const mrpKey = String(entry.mrp);
                            if (!mrpMap[mrpKey]) {
                                mrpMap[mrpKey] = {
                                    _id: entry._id,
                                    mrp: Number(entry.mrp),
                                    stock: Number(entry.stock || 0),
                                    effectiveDate: entry.effectiveDate
                                };
                            } else {
                                mrpMap[mrpKey].stock += Number(entry.stock || 0);
                            }
                        }
                    });

                    const mrpOptions = Object.values(mrpMap);
                    if (mrpOptions.length > 1) {
                        setMrpSelectionModal({
                            open: true,
                            product: fullProduct,
                            options: mrpOptions,
                            type: "Product"
                        });
                        return;
                    }
                }

                // 🚫 CHECK CURRENT CART QUANTITY vs AVAILABLE STOCK
                const targetId = String(fullProduct._id || fullProduct.productId || item._id || item.productId);
                const existingInCart = cart.find(c =>
                    c.category === "product" &&
                    String(c.productId || c._id) === targetId &&
                    (!selectedMrpOption || Number(c.mrp) === Number(selectedMrpOption.mrp))
                );
                if (existingInCart) {
                    const maxStock = selectedMrpOption ? Number(selectedMrpOption.stock || 0) : totalStock;
                    if (Number(existingInCart.qty || 1) >= maxStock) {
                        return toast.error(`🚫 Cannot add more: Stock limit reached (${maxStock} available).`);
                    }
                }
            }

            /* 🔹 CART API PAYLOAD */
            if (type === "Membership") {
                if (!selectedCustomerOption) {
                    return toast.error("Please select a customer before purchasing membership");
                }
                if (hasExistingActiveMembership) {
                    return toast.error("❌ Operation Blocked: Customer already has an active membership. Cannot purchase another one until the current one expires.");
                }
                const hasMembershipInCart = cart.some(i => i.category === "membership" || i.category === "Membership");
                if (hasMembershipInCart) {
                    return toast.error("Only one membership can be added to the cart at a time.");
                }
            }
            const payload = {
                storeId: selectedStoreId,
                billBy: userId,
                customerId: selectedCustomerOption?.value || null,
                items: [{
                    productId: type === "Product" ? item._id || item.productId : null,
                    serviceId: type === "Service" ? item._id : null,
                    subscriptionId: type === "Membership" ? item._id : null,
                    category: type.toLowerCase(),
                    qty: 1,
                }],
            };

            const response = await idbPostData("carts/", payload);
            const cartData = response?.data;
            console.log("payload", payload);
            console.log("cartData", cartData);
            if (!cartData) return toast.error("Failed to add item");

            setCart(prev => {
                const updated = [...prev];
                if (!cartId) setCartId(cartData._id);

                cartData.items.forEach(ci => {
                    const isProduct = ci.category === "product";
                    const isService = ci.category === "service";
                    const isMembership = ci.category === "membership";

                    /* 🔹 CORRECT LOOKUPS (With Fallback to passed item) */
                    const matchedProduct = isProduct
                        ? products.find(
                            p =>
                                String(p._id) === String(ci.productId) ||
                                String(p.productId) === String(ci.productId)
                        )
                        : null;
                    const product = isProduct
                        ? { ...matchedProduct, ...item }
                        : {};

                    const service = isService
                        ? services.find(s => String(s._id) === String(ci.serviceId))
                        || (String(item._id) === String(ci.serviceId) ? item : {})
                        : {};

                    const subs = isMembership
                        ? memberships.find(m => String(m._id) === String(ci.subscriptionId))
                        || (String(item._id) === String(ci.subscriptionId) ? item : {})
                        : {};

                    /* 🔹 FINAL PRICE & GST */
                    let finalPrice = 0;
                    let gstPercentage = 0;
                    let chosenMrp = null;
                    let chosenMrpHistoryId = null;

                    if (isProduct) {
                        if (selectedMrpOption) {
                            chosenMrp = Number(selectedMrpOption.mrp);
                            chosenMrpHistoryId = selectedMrpOption._id || null;
                        } else {
                            chosenMrp = Number(item.sellingPrice || item.mrp || product.sellingPrice || product.mrp || 0);
                        }
                        finalPrice = chosenMrp;
                        gstPercentage = Number(product.gstPercentage || item.gstPercentage || 0);
                    }

                    if (isService) {
                        finalPrice = Number(service.nonMemberShipPrice || 0);
                        gstPercentage = Number(service.gstPercentage || 0);
                    }

                    if (isMembership) {
                        finalPrice = Number(subs.priceOfMembership || 0);
                        gstPercentage = Number(subs.gstPercentage || 0);
                    }


                    if (isMembership) {
                        finalPrice = Number(subs.priceOfMembership || 0);
                        gstPercentage = Number(subs.gstPercentage || 0);
                    }

                    /* 🔹 GST SPLIT */


                    /* 🔹 AUTO-APPLY MEMBERSHIP if active */
                    let membershipProps = {};
                    if (isMembershipApplied && activeMembership && isService) {
                        const mPriceVal = (service.memberShipPrice !== undefined && service.memberShipPrice !== null && service.memberShipPrice !== "")
                            ? Number(service.memberShipPrice)
                            : null;

                        const isEligible = activeMembership.subscriptionValueType === "PERCENTAGE" || mPriceVal !== null;

                        if (isEligible) {
                            let calcPrice = finalPrice;
                            let calcDisc = 0;

                            if (activeMembership.subscriptionValueType === "PERCENTAGE") {
                                calcDisc = (calcPrice * Number(activeMembership.subscriptionValue || 0)) / 100;
                                calcPrice = calcPrice - calcDisc;
                            } else {
                                calcPrice = mPriceVal;
                                calcDisc = finalPrice - calcPrice;
                            }

                            membershipProps = {
                                membershipApplied: true,
                                membershipName: activeMembership.subscriptionName,
                                membershipDiscount: calcDisc,
                                priceAfterMembership: calcPrice,
                                discountValue: 0,
                                discountType: "PERCENTAGE"
                            };
                        }
                    }

                    /* 🔒 PREVENT DUPLICATE SAME PRODUCT + SAME EMPLOYEE */
                    if (isProduct) {
                        const selectedEmployeeId =
                            item.employeeId ||
                            item.employee?._id ||
                            null;

                        const duplicateEmployee = updated.find(existingItem =>
                            existingItem.category === ci.category &&
                            String(existingItem.productId) === String(ci.productId) &&
                            String(existingItem.employeeId) === String(selectedEmployeeId)
                        );

                        if (duplicateEmployee && selectedEmployeeId) {
                            toast.error(
                                `The same employee cannot be assigned to the same product multiple times. Kindly update the quantity instead.`
                            );
                            return;
                        }
                    }

                    /* 🔹 CART ITEM */
                    updated.push({
                        rowId: crypto.randomUUID(),
                        _id: ci._id,
                        cartId: cartData._id,
                        category: ci.category,
                        qty: 1,

                        productId: isProduct ? ci.productId : null,
                        serviceId: isService ? ci.serviceId : null,
                        subscriptionId: isMembership ? ci.subscriptionId : null,
                        employeeId:
                            item.employeeId ||
                            item.employee?._id ||
                            null,
                        employeeIds:
                            item.employeeIds ||
                            (item.employeeId || item.employee?._id ? [item.employeeId || item.employee?._id] : []),
                        employeeName:
                            item.employeeName ||
                            (item.employee
                                ? typeof item.employee === "object"
                                    ? `${item.employee.firstName || ""} ${item.employee.lastName || ""}`.trim() || item.employee.name
                                    : item.employee
                                : null) ||
                            null,
                        employee:
                            item.employeeName ||
                            (item.employee
                                ? typeof item.employee === "object"
                                    ? `${item.employee.firstName || ""} ${item.employee.lastName || ""}`.trim() || item.employee.name
                                    : item.employee
                                : null) ||
                            null,
                        name:
                            product.title ||
                            service.serviceName ||
                            subs.subscriptionName ||
                            "Item",

                        /* 💰 PRICE (GST ADDED) */
                        price: finalPrice,
                        originalPrice: finalPrice,
                        mrp: isProduct ? (chosenMrp || finalPrice) : null,
                        mrpHistoryId: isProduct ? chosenMrpHistoryId : null,
                        gstPercentage,                       // 5
                        nonMemberShipPrice: Number(service.nonMemberShipPrice || 0),
                        membershipPrice: (service.memberShipPrice !== undefined && service.memberShipPrice !== null && service.memberShipPrice !== "")
                            ? Number(service.memberShipPrice)
                            : null,

                        discountType: "PERCENTAGE",
                        discountValue: 0,

                        duration: service.duration || null,

                        ...membershipProps,

                        /* MEMBERSHIP META */
                        subscriptionName: subs.subscriptionName,
                        subscriptionValueType: subs.subscriptionValueType,
                        priceOfMembership: subs.priceOfMembership,
                        subscriptionValue: subs.subscriptionValue,
                        subscriptionCycle: subs.subscriptionCycle,
                        validTill: subs.subscriptionEndDate,
                        inStock: isProduct ? product.inStock : null,
                    });

                });

                return updated;
            });


        } catch (err) {
            console.error("❌ addToCart Error:", err);
            toast.error("Something went wrong while adding item");
        }
    };

    const updateCartItemQty = async (itemId, newQty) => {
        if (!cartId) return;
        try {
            await idbPutData(`carts/cart/${cartId}`, { itemId, qty: newQty });
        } catch (error) {
            console.error("❌ Failed to update qty:", error.message);
        }
    };

    const handleEmployeeChange = (rowId, employee) => {
        setCart(prev => {
            const currentItem = prev.find(
                item => item.rowId === rowId
            );

            if (!currentItem) return prev;

            if (currentItem.category === "service") {
                // employee is an array of selected options
                const selectedEmployees = Array.isArray(employee) ? employee : (employee ? [employee] : []);
                const selectedEmployeeIds = selectedEmployees.map(emp => emp.value || emp._id).filter(Boolean);
                const employeeNames = selectedEmployees.map(emp => emp.label || emp.employeeName || emp.name || "").join(", ");

                return prev.map(item =>
                    item.rowId === rowId
                        ? {
                            ...item,
                            employeeId: selectedEmployeeIds[0] || null,
                            employeeIds: selectedEmployeeIds,
                            employeeName: employeeNames,
                            employee: employeeNames
                        }
                        : item
                );
            } else {
                // Single select (product or membership)
                const selectedEmployeeId = employee?._id || employee?.value || null;
                const employeeName = employee?.employeeName || employee?.name || employee?.label || "";

                const duplicateExists = selectedEmployeeId && prev.some(item =>
                    item.rowId !== rowId && // ignore current row
                    item.category === currentItem.category &&
                    String(item[currentItem.category === "product" ? "productId" : "serviceId"]) === String(currentItem[currentItem.category === "product" ? "productId" : "serviceId"]) &&
                    String(item.employeeId) === String(selectedEmployeeId)
                );

                if (duplicateExists) {
                    toast.error(
                        "You cannot choose the same employee for the same item. Please update the quantity instead."
                    );
                    return prev;
                }

                return prev.map(item =>
                    item.rowId === rowId
                        ? {
                            ...item,
                            employeeId: selectedEmployeeId,
                            employeeIds: selectedEmployeeId ? [selectedEmployeeId] : [],
                            employeeName: employeeName,
                            employee: employeeName
                        }
                        : item
                );
            }
        });
    };


    const calculateGST = (amount, gstRate, gstType) => {
        const price = Number(amount) || 0;
        const rate = Number(gstRate) || 0;

        if (gstType === "Inclusive") {
            const taxable = price / (1 + rate / 100);
            const gst = price - taxable;

            return {
                taxable,
                gst,
                cgst: gst / 2,
                sgst: gst / 2,
                final: price
            };
        }

        // Exclusive
        const gst = (price * rate) / 100;
        return {
            taxable: price,
            gst,
            cgst: gst / 2,
            sgst: gst / 2,
            final: price + gst
        };
    };


    const incQty = (i) => {
        setCart(prev => {
            const copy = [...prev];
            const item = copy[i];

            // 🔹 STOCK CHECK FOR PRODUCTS
            if (item.category === "product") {
                const stockAvailable = Number(item.inStock || 0);
                if (item.qty >= stockAvailable) {
                    toast.error(`❌ Stock Limit Reached! Only ${stockAvailable} units of "${item.name}" available.`);
                    return prev;
                }
            }

            copy[i].qty += 1;
            updateCartItemQty(copy[i]._id, copy[i].qty);
            return copy;
        });
    };

    const decQty = (i) => {
        const item = cart[i];
        if (!item) return;

        if (item.qty <= 1) {
            removeItem(item.rowId);
        } else {
            const newQty = item.qty - 1;
            setCart(prev => {
                const copy = [...prev];
                copy[i].qty = newQty;
                return copy;
            });
            updateCartItemQty(item._id, newQty);
        }
    };

    const removeItem = async (itemRowId) => {
        try {
            // Step 1: Remove in UI
            const updatedItems = cart.filter(i => i.rowId !== itemRowId);
            setCart(updatedItems);

            // 🔹 FIX: Reset Membership if no items or no services left
            const hasServices = updatedItems.some(i => i.category === "service");
            if (updatedItems.length === 0 || (!hasServices && isMembershipApplied)) {
                setIsMembershipApplied(false);
            }

            // Step 2: Handle Smart Coupon Removal
            if (updatedItems.length === 0) {
                setAppliedCoupons([]);
                setCouponInput("");
            } else {
                const hasProducts = updatedItems.some(i => i.category === "product");
                const hasServices = updatedItems.some(i => i.category === "service");

                setAppliedCoupons(prev => {
                    const filtered = prev.filter(coupon => {
                        const type = String(coupon.appliedOn).toLowerCase();
                        if (type === "product" && !hasProducts) return false;
                        if (type === "service" && !hasServices) return false;
                        return true;
                    });

                    if (filtered.length !== prev.length) {
                        toast.info("Coupons updated based on remaining items");
                    }
                    return filtered;
                });
            }

            // Step 3: Sync with IndexedDB
            if (cartId) {
                const res = await idbGetData("carts", cartId);
                const currentCart = res?.data;

                if (currentCart && !Array.isArray(currentCart) && currentCart.items) {
                    currentCart.items = currentCart.items.filter(i => i.rowId !== itemRowId);
                    await idbPutData("carts", currentCart);
                }
            }

            toast.success("Item removed From Cart");
        } catch (err) {
            console.error(err);
            toast.error("Failed to remove item");
        }
    };

    const clearCart = async () => {
        setSelectedCustomerOption(null);
        setFormData(prev => ({
            ...prev,
            transactionType: "SALE"
        }));
        setCart([]);
        setCartId("");
        setPayments([]);
        setAppliedCoupons([]);
        setCouponInput("");
        setInvoiceDate(approvedBackDate || todayStr);
        setGstRate(0);
        setGstType("GST");
        setOverallDiscount(0);
        setOverallDiscountType("PERCENTAGE");
        setMiscellaneousCharges(0);
        setMiscReason("");
        setPendingDate(null);
        setOtpInput("");
        setOtpSent(false);
        setShowOtpModal(false);
        setOtpLoading(false);
        setOtpVerifying(false);
        setActiveMembership(null);
        await clearPosDraft();
    };

    const [isSendingWhatsApp, setIsSendingWhatsApp] = useState(false);

    const handleShareTVFMWhatsApp = async (invoice) => {
        if (!invoice) return;
        if (isSendingWhatsApp) {
            toast.warn("WhatsApp dispatch is already in progress. Please wait.");
            return;
        }

        const customerName = invoice.customerId?.name || "Customer";
        let customerPhone = invoice.customerId?.phoneNumber || "";

        let cleanPhone = customerPhone.replace(/\D/g, "");
        if (cleanPhone.length === 10) {
            cleanPhone = `91${cleanPhone}`;
        }

        const executeDirectMetaSend = async (targetPhone) => {
            setIsSendingWhatsApp(true);
            const toastId = toast.info("Sending bill via WhatsApp...", { autoClose: false });
            try {
                const token = localStorage.getItem("Token");
                const res = await postData(`invoices/${invoice._id}/send-whatsapp`, { customerPhone: targetPhone, customerName }, token);
                toast.dismiss(toastId);

                if (res?.status === 200 && res?.data?.success) {
                    toast.success("Bill sent successfully via WhatsApp.");
                } else {
                    const errMsg = res?.data?.error || res?.data?.message || res?.message || "Failed to send bill via WhatsApp. Please try again.";
                    toast.error(errMsg);
                }
            } catch (err) {
                toast.dismiss(toastId);
                console.error("WhatsApp dispatch error:", err);
                toast.error("Failed to send bill via WhatsApp. Please try again.");
            } finally {
                setIsSendingWhatsApp(false);
            }
        };

        if (cleanPhone && cleanPhone.replace(/\D/g, "").length >= 10) {
            await executeDirectMetaSend(cleanPhone);
        } else {
            Swal.fire({
                title: 'Share via WhatsApp',
                text: 'Enter WhatsApp Phone Number with Country Code (e.g., 919876543210):',
                input: 'text',
                inputValue: cleanPhone || '91',
                showCancelButton: true,
                confirmButtonText: 'Send via WhatsApp',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#25D366',
                inputValidator: (value) => {
                    if (!value || value.replace(/\D/g, "").length < 10) {
                        return 'Please enter a valid phone number with country code (e.g., 919876543210)';
                    }
                }
            }).then(async (result) => {
                if (result.isConfirmed && result.value) {
                    let targetPhone = result.value.replace(/\D/g, "");
                    if (targetPhone.length === 10) targetPhone = `91${targetPhone}`;
                    await executeDirectMetaSend(targetPhone);
                }
            });
        }
    };

    const handleShareOldWhatsApp = (invoice) => {
        if (!invoice) return;
        const customerPhone = invoice.customerId?.phoneNumber || "";
        let cleanPhone = customerPhone.replace(/\D/g, "");
        if (cleanPhone.length === 10) {
            cleanPhone = `91${cleanPhone}`;
        }
        
        const storeName = invoice.storeId?.storeName || invoice.storeId?.branchName || "Store";
        const branchName = invoice.storeId?.branchName || "";
        const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
        let billDownloadLink = invoice.pdfUrl || invoice.billDownloadLink || `${baseUrl}/invoices/${invoice._id}/download`;
        
        // WhatsApp does not render "localhost" as a clickable link.
        // Convert to 127.0.0.1 for local testing to ensure the link is clickable.
        if (billDownloadLink.includes("localhost")) {
            billDownloadLink = billDownloadLink.replace("localhost", "127.0.0.1");
        }

        const formattedMsg = formatWhatsAppMessage({ storeName, branchName, billDownloadLink });
        const encodedMessage = encodeURIComponent(formattedMsg);
        
        if (cleanPhone && cleanPhone.length >= 10) {
            window.open(`https://wa.me/${cleanPhone}?text=${encodedMessage}`, '_blank');
        } else {
            Swal.fire({
                title: 'Share via WhatsApp',
                text: 'Enter WhatsApp Phone Number with Country Code (e.g., 919876543210):',
                input: 'text',
                inputValue: '91',
                showCancelButton: true,
                confirmButtonText: 'Open WhatsApp',
                confirmButtonColor: '#25D366',
                inputValidator: (value) => {
                    if (!value || value.replace(/\D/g, "").length < 10) {
                        return 'Please enter a valid phone number with country code';
                    }
                }
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    let enteredPhone = result.value.replace(/\D/g, "");
                    if (enteredPhone.length === 10) enteredPhone = `91${enteredPhone}`;
                    window.open(`https://wa.me/${enteredPhone}?text=${encodedMessage}`, '_blank');
                }
            });
        }
    };

    const printInvoice = (invoice) => {
        if (!invoice) {
            alert("Nothing to print");
            return;
        }

        const grandTotal = Number(invoice.grandTotal || invoice.finalAmount || 0);
        const tenderAmount = Array.isArray(invoice.paymentMode)
            ? invoice.paymentMode.reduce((sum, p) => sum + Number(p.amount || 0), 0)
            : Number(invoice.paymentMode?.amount || grandTotal);
        const changeAmount = Math.max(0, tenderAmount - grandTotal);

        const html = generateInvoiceHTML(invoice, currentStore);
        const win = window.open("", "PRINT_WINDOW", "width=900,height=700");

        if (!win) {
            toast.error("Please allow popup windows");
            return;
        }

        win.document.open();
        win.document.write(html);
        win.document.close();

        win.onload = () => {
            setTimeout(() => {
                win.focus();
                win.print();
            }, 500);
        };

        win.onafterprint = () => {
            if (changeAmount > 0) {
                setChangeToReturn(changeAmount);
                setShowChangeModal(true);
            }

            setShowPrintButton(false);
            setLastInvoice(null);

            win.close();

            setTimeout(() => {
                window.focus();
            }, 300);
        };

        if (changeAmount > 0) {
            setChangeToReturn(changeAmount);
            setShowChangeModal(true);
        }

        setShowPrintButton(false);
        setLastInvoice(null);
    };

    const computeInvoiceSummary = (cartToUse = cart) => {
        const isStoreVerified = currentStore?.gstData?.status === "VERIFIED";

        /* ================= MEMBERSHIP BILLING ================= */
        if (formData.transactionType === "MEMBERSHIP") {
            const membershipItem = cartToUse.find(i => i.category === "membership");
            if (!membershipItem) return emptySummary();

            const basePrice = Number(membershipItem.price || 0);
            const rate = Number(membershipItem.gstPercentage || 0);

            let taxable = 0;
            let totalGST = 0;
            let finalAmt = 0;

            if (gstType === "Exclusive" && isStoreVerified) {
                taxable = basePrice;
                totalGST = (basePrice * rate) / 100;
                finalAmt = taxable + totalGST;
            } else if (!isStoreVerified) {
                taxable = basePrice;
                totalGST = 0;
                finalAmt = basePrice;
            } else {
                // Inclusive & Verified
                taxable = basePrice / (1 + rate / 100);
                totalGST = basePrice - taxable;
                finalAmt = basePrice;
            }

            return {
                processedItems: [{
                    productId: null,
                    serviceId: null,
                    subscriptionId: membershipItem.subscriptionId,
                    category: "membership",
                    qty: 1,
                    price: basePrice,
                    discountType: "FLAT",
                    discountValue: 0,
                    total: basePrice,
                    employeeId: membershipItem.employeeId || null,
                    taxableAmount: taxable,
                    gstAmount: totalGST,
                    finalInclusive: finalAmt,
                    gstPercentage: rate
                }],
                totalProductQty: 0,
                totalServiceQty: 0,
                totalProductAmount: 0,
                totalServiceAmount: finalAmt,
                totalAmount: finalAmt,
                membershipDiscountAmount: 0,
                overallDiscountAmount: 0,
                couponDiscountAmount: 0,
                taxableAmount: taxable,
                totalGST: totalGST,
                sgst: totalGST / 2,
                cgst: totalGST / 2,
                finalAmount: finalAmt,
                productTaxable: 0,
                serviceTaxable: 0
            };
        }

        /* ================= NORMAL BILLING ================= */

        let totalProductAmount = 0;
        let totalServiceAmount = 0;
        let membershipDiscountAmount = 0;
        let overallDiscountAmount = 0;
        let totalBaseBenefit = 0;

        const processedItems = cartToUse.map(it => {
            const base = Number(it.price || 0) * Number(it.qty || 1);

            const manualDiscount =
                it.discountType === "PERCENTAGE"
                    ? (base * Number(it.discountValue || 0)) / 100
                    : Number(it.discountValue || 0);

            const baseBenefit = it.category === "service" && it.membershipPrice !== null && it.membershipPrice !== undefined
                ? Math.max(0, (Number(it.nonMemberShipPrice || 0) - Number(it.membershipPrice || 0)) * Number(it.qty || 1))
                : 0;

            totalBaseBenefit += baseBenefit;

            return {
                rowId: it.rowId,
                productId: it.category === "product" ? it.productId : null,
                serviceId: it.category === "service" ? it.serviceId : null,
                subscriptionId: null,
                category: it.category,
                qty: it.qty,
                price: it.price,
                unitPriceOriginal: it.unitPriceOriginal || it.price,
                mrp: it.mrp || it.price,
                mrpHistoryId: it.mrpHistoryId || null,
                nonMemberShipPrice: it.nonMemberShipPrice,
                membershipPrice: it.membershipPrice,
                discountType: it.discountType,
                discountValue: it.discountValue,
                manualDiscount,
                baseMemberBenefit: baseBenefit,
                gstPercentage: Number(it.gstPercentage || 0),
                total: Number((base - manualDiscount).toFixed(2)),
                employeeId: it.employeeId || null,
                employeeIds: it.employeeIds || (it.employeeId ? [it.employeeId] : []),
                membershipApplied: it.membershipApplied || false,
                membershipName: it.membershipName || null,
                isServiceWalletApplied: it.isServiceWalletApplied || false,
                customerWalletId: it.customerWalletId || null,
                serviceWalletName: it.serviceWalletName || null,
                walletCoveredAmount: it.isServiceWalletApplied ? Number((base - manualDiscount).toFixed(2)) : 0,
                customerPayableAmount: it.isServiceWalletApplied ? 0 : Number((base - manualDiscount).toFixed(2)),
                membershipDiscount: 0,
                overallDiscount: 0,
                couponDiscount: 0,
                taxableAmount: 0,
                gstAmount: 0,
                finalInclusive: 0
            };
        });

        /* ---------- PRODUCT & SERVICE TOTAL ---------- */
        processedItems.forEach(i => {
            if (i.category === "product") totalProductAmount += i.total;
            if (i.category === "service") totalServiceAmount += i.total;
        });

        const subTotal = totalProductAmount + totalServiceAmount;

        const miscChargesVal = Number(miscellaneousCharges) || 0;
        processedItems.forEach(i => {
            if (i.category === "service") {
                i.miscChargeShare = totalServiceAmount > 0
                    ? (miscChargesVal * i.total) / totalServiceAmount
                    : 0;
            } else {
                i.miscChargeShare = 0;
            }
        });

        /* ---------- MEMBERSHIP DISCOUNT ---------- */
        if (isMembershipApplied && activeMembership) {
            processedItems.forEach(item => {
                if (item.category === "service" && item.membershipApplied) {
                    const nonMemberPrice = Number(item.nonMemberShipPrice) || Number(item.price) || 0;
                    const hasMemberPrice = item.membershipPrice !== null && item.membershipPrice !== undefined;
                    const memberPrice = hasMemberPrice ? Number(item.membershipPrice) : nonMemberPrice;

                    if (activeMembership.subscriptionValueType === "PERCENTAGE") {
                        const percent = Number(activeMembership.subscriptionValue || 0);
                        // Apply percentage directly on the original price
                        item.membershipDiscount = (nonMemberPrice * item.qty * percent) / 100;
                    } else if (activeMembership.subscriptionValueType === "SERVICE") {
                        item.membershipDiscount = item.baseMemberBenefit;
                    }

                    membershipDiscountAmount += item.membershipDiscount;
                }
            });
        }

        const afterMembership = Math.max(subTotal - membershipDiscountAmount, 0);

        /* ---------- OVERALL DISCOUNT ---------- */
        overallDiscountAmount =
            overallDiscountType === "PERCENTAGE"
                ? (afterMembership * Math.min(Number(overallDiscount || 0), 100)) / 100
                : Math.min(Number(overallDiscount || 0), afterMembership);

        /* ---------- COUPON DISCOUNT ---------- */
        const couponDiscountAmount = calculateTotalCouponDiscount(totalProductAmount, totalServiceAmount);

        /* ---------- FINAL BEFORE ROUND (No longer needed here, moved to end) ---------- */


        /* ---------- GST CALCULATION ---------- */
        processedItems.forEach(item => {
            // share of overall discount
            const itemShare = subTotal > 0 ? (item.total / subTotal) : 0;
            const itemOverallDiscount = overallDiscountAmount * itemShare;

            // share of coupon discount
            let itemCouponDiscount = 0;
            appliedCoupons.forEach(coupon => {
                const val = Number(coupon.discountAmount || 0);
                const type = String(coupon.appliedOn || "both").toLowerCase();

                // We treat 'discountAmount' as a flat value for distribution because 
                // the backend already calculates the absolute benefit based on the current total.
                if (type === "both" || (type === "product" && item.category === "product") || (type === "service" && item.category === "service")) {
                    const targetTotal = type === "product" ? totalProductAmount : (type === "service" ? totalServiceAmount : subTotal);
                    itemCouponDiscount += targetTotal > 0 ? (item.total / targetTotal) * val : 0;
                }
            });

            item.overallDiscount = itemOverallDiscount;
            item.couponDiscount = itemCouponDiscount;

            // TAXABLE BASE = Gross - Manual - Membership - Share of Overall - Share of Coupon + Share of Misc Charges
            const gross = Number(item.price || 0) * Number(item.qty || 1);
            const netAmountForTax = Math.max(0, gross - item.manualDiscount - item.membershipDiscount - itemOverallDiscount - itemCouponDiscount + (item.miscChargeShare || 0));

            const effectiveGstType = item.category === "product" ? "Inclusive" : gstType;
            let itTaxable = 0;
            let itGst = 0;
            let itFinal = 0;

            if (item.isServiceWalletApplied) {
                // Service Wallet covered items generate NO GST and NO customer payable amount
                itTaxable = 0;
                itGst = 0;
                itFinal = 0;
            } else if (effectiveGstType === "Exclusive" && isStoreVerified) {
                itTaxable = netAmountForTax;
                itGst = (netAmountForTax * item.gstPercentage) / 100;
                itFinal = itTaxable + itGst;
            } else if (!isStoreVerified) {
                itTaxable = netAmountForTax;
                itGst = 0;
                itFinal = netAmountForTax;
            } else {
                // Inclusive
                itTaxable = netAmountForTax / (1 + (item.gstPercentage / 100));
                itGst = netAmountForTax - itTaxable;
                itFinal = netAmountForTax;
            }

            item.walletCoveredAmount = item.isServiceWalletApplied ? Number(netAmountForTax.toFixed(2)) : 0;
            item.customerPayableAmount = item.isServiceWalletApplied ? 0 : Number(itFinal.toFixed(2));
            item.taxableAmount = Number(itTaxable.toFixed(4));
            item.gstAmount = Number(itGst.toFixed(4));
            item.finalInclusive = Number(itFinal.toFixed(4));

            item.displayTaxable = item.taxableAmount;
            item.displayInclusive = item.finalInclusive;
        });

        /* ---------- TOTALS CALCULATION ---------- */
        const productTaxable = processedItems.filter(i => i.category === "product").reduce((s, i) => s + i.taxableAmount, 0);
        const serviceTaxable = processedItems.filter(i => i.category === "service").reduce((s, i) => s + i.taxableAmount, 0);
        const productGST = processedItems.filter(i => i.category === "product").reduce((s, i) => s + i.gstAmount, 0);
        const serviceGST = processedItems.filter(i => i.category === "service").reduce((s, i) => s + i.gstAmount, 0);

        const totalTaxable = productTaxable + serviceTaxable;
        const totalGST = productGST + serviceGST;

        let totalManualDiscount = 0;
        processedItems.forEach(i => { totalManualDiscount += i.manualDiscount; });

        // The exact sum of what the customer is paying for every item (after overall/coupon distribution)
        const exactTotal = processedItems.reduce((s, i) => s + i.finalInclusive, 0);

        // Final Display Amounts
        const baseFinal = Math.max(0, exactTotal);
        const finalAmount = Math.round(baseFinal);
        const roundOff = Number((finalAmount - baseFinal).toFixed(2));

        // Top Price rows (Base price before ANY benefits/discounts)
        const displayProductPrice = processedItems
            .filter(i => i.category === "product")
            .reduce((s, i) => s + i.total, 0);

        const displayServicePrice = processedItems
            .filter(i => i.category === "service")
            .reduce((s, i) => s + i.total, 0);

        // Bottom Amount rows (Full final amount including all taxes and summary discounts)
        const displayProductAmount = processedItems
            .filter(i => i.category === "product")
            .reduce((s, i) => s + i.finalInclusive, 0);

        const displayServiceAmount = processedItems
            .filter(i => i.category === "service")
            .reduce((s, i) => s + i.finalInclusive, 0);

        // Tax Grouping Logic
        const getTaxGroups = (cat) => {
            const groups = {};
            processedItems.filter(i => i.category === cat && !i.isServiceWalletApplied && i.gstAmount > 0).forEach(it => {
                const r = it.gstPercentage;
                if (!groups[r]) {
                    groups[r] = { rate: r, taxable: 0, gst: 0, cgst: 0, sgst: 0 };
                }
                groups[r].taxable += it.taxableAmount;
                groups[r].gst += it.gstAmount;
                groups[r].cgst += it.gstAmount / 2;
                groups[r].sgst += it.gstAmount / 2;
            });
            // Convert to fixed decimals for display
            return Object.values(groups).map(g => ({
                ...g,
                taxable: Number(g.taxable.toFixed(2)),
                gst: Number(g.gst.toFixed(2)),
                cgst: Number(g.cgst.toFixed(2)),
                sgst: Number(g.sgst.toFixed(2))
            }));
        };

        const productTaxGroups = getTaxGroups("product");
        const serviceTaxGroups = getTaxGroups("service");

        const serviceWalletCoveredAmount = processedItems
            .filter(i => i.isServiceWalletApplied)
            .reduce((s, i) => s + (i.walletCoveredAmount || i.total || 0), 0);

        return {
            serviceWalletCoveredAmount,
            processedItems,
            totalProductQty: processedItems.filter(i => i.category === "product").reduce((s, i) => s + i.qty, 0),
            totalServiceQty: processedItems.filter(i => i.category === "service").reduce((s, i) => s + i.qty, 0),
            totalProductPrice: displayProductPrice,
            totalServicePrice: displayServicePrice,
            totalProductAmount: displayProductAmount,
            totalServiceAmount: displayServiceAmount,
            totalAmount: displayProductPrice + displayServicePrice, // Subtotal for summary rows
            miscellaneousCharges: Number(miscellaneousCharges) || 0,
            membershipDiscountAmount,
            totalBaseBenefit,
            totalManualDiscount,
            overallDiscountAmount,
            couponDiscountAmount,
            taxableAmount: totalTaxable,
            productTaxable,
            serviceTaxable,
            productGST,
            serviceGST,
            productTaxGroups,
            serviceTaxGroups,
            totalGST: Number(totalGST.toFixed(2)),
            sgst: Number((totalGST / 2).toFixed(2)),
            cgst: Number((totalGST / 2).toFixed(2)),
            finalAmount,
            roundOff
        };
    };


    /* helper */
    const emptySummary = () => ({
        processedItems: [],
        totalProductQty: 0,
        totalServiceQty: 0,
        totalProductAmount: 0,
        totalServiceAmount: 0,
        totalAmount: 0,
        membershipDiscountAmount: 0, // Added for consistency
        overallDiscountAmount: 0,
        couponDiscountAmount: 0,
        taxableAmount: 0, // 🔥 FIXED: Added missing field
        totalGST: 0,
        sgst: 0,
        cgst: 0,
        finalAmount: 0,
        productTaxable: 0,
        serviceTaxable: 0,
        productGST: 0, // Added for consistency
        serviceGST: 0, // Added for consistency
        productTaxGroups: [], // Added for consistency
        serviceTaxGroups: [] // Added for consistency
    });

    const handleSaveInvoice = async () => {
        try {
            if (cart.length === 0) {
                return toast.error("Cart is empty");
            }

            if (formData.transactionType !== "SELF" && !selectedCustomerOption) {
                return toast.error("Please select a customer");
            }

            /* ---------------- REAL-TIME STOCK VALIDATION BEFORE BILLING ---------------- */
            const productCartItems = cart.filter(item => item.category === "product" || item.category === "Product");
            if (productCartItems.length > 0) {
                const token = localStorage.getItem("Token");
                for (const cartItem of productCartItems) {
                    const reqQty = Number(cartItem.qty || 1);
                    const searchName = cartItem.name || cartItem.title || cartItem.productName || "";
                    let currentStock = Number(cartItem.inStock || cartItem.stock || 0);

                    try {
                        if (searchName && selectedStoreId && token) {
                            const freshRes = await getData(
                                `inventories/products/${selectedStoreId}`,
                                { page: 1, limit: 10, search: searchName },
                                token
                            );
                            const pData = Array.isArray(freshRes?.data) ? freshRes.data[0] : freshRes?.data;
                            const rawProducts = pData?.paginatedResults || (Array.isArray(freshRes?.data) ? freshRes.data : []);
                            const foundFresh = rawProducts.find(
                                p => String(p._id || p.productId) === String(cartItem.productId || cartItem._id)
                            );
                            if (foundFresh) {
                                if (cartItem.mrpHistoryId && Array.isArray(foundFresh.mrpHistory)) {
                                    const mrpEntry = foundFresh.mrpHistory.find(m => String(m._id) === String(cartItem.mrpHistoryId));
                                    if (mrpEntry) {
                                        currentStock = Number(mrpEntry.stock || 0);
                                    } else if (cartItem.mrp !== undefined && cartItem.mrp !== null) {
                                        const mrpEntries = foundFresh.mrpHistory.filter(m => Number(m.mrp) === Number(cartItem.mrp));
                                        currentStock = mrpEntries.reduce((s, m) => s + Number(m.stock || 0), 0);
                                    } else {
                                        currentStock = Number(foundFresh.inStock || 0);
                                    }
                                } else if (cartItem.mrp !== undefined && cartItem.mrp !== null && Array.isArray(foundFresh.mrpHistory)) {
                                    const mrpEntries = foundFresh.mrpHistory.filter(m => Number(m.mrp) === Number(cartItem.mrp));
                                    currentStock = mrpEntries.reduce((s, m) => s + Number(m.stock || 0), 0);
                                } else {
                                    currentStock = Number(foundFresh.inStock || 0);
                                }
                            }
                        }
                    } catch (stockErr) {
                        console.error("Error verifying stock before billing:", stockErr);
                    }

                    if (currentStock <= 0) {
                        return toast.error(`🚫 Billing Blocked: "${cartItem.name || 'Product'}" is OUT OF STOCK. Please remove it from the cart.`);
                    }
                    if (reqQty > currentStock) {
                        return toast.error(`🚫 Billing Blocked: Insufficient stock for "${cartItem.name || 'Product'}". Requested: ${reqQty}, Available: ${currentStock}. Please adjust quantity.`);
                    }
                }
            }

            const summary = invoiceSummary;

            if (Number(summary.miscellaneousCharges || 0) > 0 && !miscReason?.trim()) {
                return toast.error("Please enter a reason for the miscellaneous charges.");
            }

            const store = currentStore || stores.find(s => s._id === selectedStoreId);

            /* ---------------- PAYMENT VALIDATION ---------------- */
            if (formData.transactionType !== "SELF") {
                const hasInvalidMethod = payments.some(p => Number(p.amount) > 0 && !p.method);
                if (hasInvalidMethod) {
                    return toast.error("Please select a payment method for all entries.");
                }

                // Calculate total out-of-pocket expected for customer
                const serviceWalletCovered = summary.serviceWalletCoveredAmount || (summary.processedItems?.filter(i => i.isServiceWalletApplied).reduce((s, i) => s + (i.walletCoveredAmount || i.total), 0) || 0);

                const cashWalletDeduction = (isCashWalletApplied && appliedCashWallet)
                    ? Math.min(
                        Math.max(0, Number(customWalletDeductionAmount) || 0),
                        appliedCashWallet.balance || 0,
                        summary.processedItems
                            .filter(i => (i.category === "service" || i.category === "Service") && !i.isServiceWalletApplied)
                            .reduce((sum, i) => sum + (Number(i.price || i.total || 0) * Number(i.qty || 1)), 0)
                    )
                    : 0;

                const expectedPayable = Math.max(0, Number((summary.finalAmount - cashWalletDeduction).toFixed(2)));

                const customerPayments = payments.filter(p => !p.isWalletRow && p.method !== "WALLET");
                const customerPaid = customerPayments.reduce(
                    (sum, p) => sum + (Number(p.amount) || 0),
                    0
                );

                const isCashPayment = customerPayments.some(p => p.method === "CASH");

                if (isCashPayment) {
                    if (customerPaid < expectedPayable) {
                        return toast.error("Insufficient payment. Please enter the full amount.");
                    }
                } else {
                    if (Math.abs(customerPaid - expectedPayable) > 0.01) {
                        return toast.error("Please settle the full payment before generating invoice.");
                    }
                }
            }

            /* ---------------- BUILD PAYLOAD ---------------- */
            const payload = {
                storeId: selectedStoreId,
                storeName: store?.storeName || null,

                transactionType: formData.transactionType,
                billBy: userId,

                customerId:
                    formData.transactionType === "SELF"
                        ? null
                        : selectedCustomerOption?.value || null,

                /* ITEMS */
                items: summary.processedItems,

                totalProductQty: summary.totalProductQty,
                totalServiceQty: summary.totalServiceQty,

                totalProductAmount: Number(summary.totalProductAmount.toFixed(2)),
                totalServiceAmount: Number(summary.totalServiceAmount.toFixed(2)),

                totalAmount: Number(summary.totalAmount.toFixed(2)),
                miscellaneousCharges: Number(summary.miscellaneousCharges) || 0,
                reason: miscReason || null,

                /* DISCOUNTS */
                overallDiscount: Number(summary.overallDiscountAmount.toFixed(2)),

                /* MEMBERSHIP (NEW ✅) */
                isMembershipApplied: isMembershipApplied,
                membershipId: isMembershipApplied
                    ? activeMembership?._id
                    : null,
                membershipName: isMembershipApplied
                    ? activeMembership?.subscriptionName
                    : null,
                membershipDiscount: Number(
                    summary.membershipDiscountAmount?.toFixed(2) || 0
                ),

                /* COUPON */
                couponCode: appliedCoupons.map(c => c.code).join(", "),
                coupons: appliedCoupons.map(c => ({
                    code: c.code,
                    discountType: c.discountType,
                    discountAmount: c.discountAmount,
                    appliedOn: c.appliedOn
                })),
                couponDiscount: Number(summary.couponDiscountAmount.toFixed(2)),

                /* WALLETS */
                appliedWallets: (() => {
                    const wallets = [];
                    cart.forEach(item => {
                        if (item.isServiceWalletApplied && item.customerWalletId) {
                            const itemVal = Number(item.price || item.total || 0) * Number(item.qty || 1);
                            const matchedW = (customerWallets || []).find(w => String(w._id) === String(item.customerWalletId));
                            const bCount = Number(matchedW?.baseCount || matchedW?.services?.[0]?.baseCount || 0);
                            const eCount = Number(matchedW?.additionalCount || matchedW?.extraCount || matchedW?.services?.[0]?.additionalCount || 0);
                            const totCount = matchedW?.totalCount ||
                                matchedW?.totalServiceCount ||
                                matchedW?.services?.[0]?.totalCount ||
                                (bCount > 0 ? (bCount + eCount) : 0) ||
                                item.totalCount ||
                                1;
                            const qtyRedeemed = Number(item.qty || 1);
                            const initialRem = Number(matchedW?.remainingCount ?? matchedW?.services?.[0]?.remainingCount ?? item.remainingCount ?? totCount);
                            const remAfterBill = Math.max(0, initialRem - qtyRedeemed);
                            const usedAfterBill = Number(matchedW?.usedCount ?? matchedW?.services?.[0]?.usedCount ?? 0) + qtyRedeemed;

                            wallets.push({
                                walletId: item.customerWalletId,
                                type: "Service",
                                usageCount: qtyRedeemed,
                                amountUsed: itemVal,
                                walletName: item.serviceWalletName || matchedW?.customWalletName || matchedW?.walletPackageId?.name || "Service Wallet",
                                serviceName: item.serviceId?.serviceName || item.name || matchedW?.serviceId?.serviceName || matchedW?.services?.[0]?.serviceId?.serviceName || matchedW?.services?.map(s => s.serviceId?.serviceName || s.serviceName).filter(Boolean).join(', ') || "Service",
                                baseCount: bCount,
                                extraCount: eCount,
                                totalCount: totCount,
                                remainingCount: remAfterBill,
                                usedCount: usedAfterBill,
                                services: matchedW?.services || [],
                                validityDays: matchedW?.validityDays || matchedW?.walletPackageId?.validityDays || item.validityDays || 365,
                                expiryDate: matchedW?.expiryDate || item.walletExpiry,
                                rechargeDate: matchedW?.createdAt || matchedW?.transactionDate || item.rechargeDate,
                                packageAmount: matchedW?.price || matchedW?.totalAmount || matchedW?.amountPaid || item.packageAmount || 0
                            });
                        }
                    });
                    if (isCashWalletApplied && appliedCashWallet) {
                        const curBal = Number(appliedCashWallet.balance || appliedCashWallet.totalCredited || 0);
                        const serviceTotals = summary.processedItems
                            .filter(i => (!i.category || String(i.category).toLowerCase() === "service") && !i.isServiceWalletApplied)
                            .reduce((sum, i) => sum + (Number(i.price || i.total || 0) * Number(i.qty || 1)), 0);
                        const maxDeduction = Math.min(curBal, serviceTotals);
                        const cashDeduction = Math.min(Math.max(0, Number(customWalletDeductionAmount) || 0), maxDeduction);
                        if (cashDeduction > 0) {
                            const remBal = Math.max(0, curBal - cashDeduction);
                            wallets.push({
                                walletId: appliedCashWallet._id,
                                type: "Cash",
                                amountUsed: cashDeduction,
                                walletName: appliedCashWallet.customWalletName || appliedCashWallet.walletPackageId?.name || "Cash Wallet",
                                rechargeAmount: Number(appliedCashWallet.amountPaid || appliedCashWallet.price || appliedCashWallet.totalAmount || 0),
                                walletCredit: Number(appliedCashWallet.walletCredit || appliedCashWallet.creditedAmount || 0),
                                totalCredited: Number(appliedCashWallet.totalCredited || appliedCashWallet.creditedAmount || curBal),
                                currentBalance: curBal,
                                previousWalletBalance: curBal,
                                remainingBalance: remBal,
                                validityDays: appliedCashWallet.validityDays || appliedCashWallet.walletPackageId?.validityDays || 365,
                                rechargeValidityDays: appliedCashWallet.rechargeValidityDays || appliedCashWallet.validityDays || 365,
                                expiryDate: appliedCashWallet.expiryDate,
                                rechargeDate: appliedCashWallet.createdAt || appliedCashWallet.transactionDate
                            });
                        }
                    }
                    return wallets;
                })(),
                cashWalletDeduction: (() => {
                    if (!isCashWalletApplied || !appliedCashWallet) return 0;
                    const curBal = Number(appliedCashWallet.balance || appliedCashWallet.totalCredited || 0);
                    const serviceTotals = summary.processedItems
                        .filter(i => (!i.category || String(i.category).toLowerCase() === "service") && !i.isServiceWalletApplied)
                        .reduce((sum, i) => sum + (Number(i.price || i.total || 0) * Number(i.qty || 1)), 0);
                    return Math.min(Math.max(0, Number(customWalletDeductionAmount) || 0), curBal, serviceTotals);
                })(),
                cashWalletPreviousBalance: isCashWalletApplied && appliedCashWallet ? Number(appliedCashWallet.balance || appliedCashWallet.totalCredited || 0) : 0,
                cashWalletRemainingBalance: (() => {
                    if (!isCashWalletApplied || !appliedCashWallet) return 0;
                    const curBal = Number(appliedCashWallet.balance || appliedCashWallet.totalCredited || 0);
                    const serviceTotals = summary.processedItems
                        .filter(i => (!i.category || String(i.category).toLowerCase() === "service") && !i.isServiceWalletApplied)
                        .reduce((sum, i) => sum + (Number(i.price || i.total || 0) * Number(i.qty || 1)), 0);
                    const actualDeduction = Math.min(Math.max(0, Number(customWalletDeductionAmount) || 0), curBal, serviceTotals);
                    return Math.max(0, curBal - actualDeduction);
                })(),


                /* GST */
                totalGST: Number(summary.totalGST.toFixed(2)),
                sgst: Number(summary.sgst.toFixed(2)),
                cgst: Number(summary.cgst.toFixed(2)),
                taxableAmount: summary.taxableAmount,

                /* TOTALS */
                finalAmount: summary.finalAmount,
                grandTotal: summary.finalAmount,
                roundOff: summary.roundOff,

                gstType,
                gstRate,

                /* PAYMENTS */
                paymentMode: payments
                    .filter(p => p.method && Number(p.amount) > 0)
                    .map(p => ({
                        method: p.method,
                        amount: Number(p.amount),
                        receivedAmount: Number(p.receivedAmount || p.amount),
                        cardNumber: p.cardNumber || null
                    })),

                invoiceDate: invoiceDate || dayjs().format("YYYY-MM-DD"),
                otpVerificationId: walletOtpVerificationId,
                appointmentId: loadedAppointmentId || appointmentId || null
            };

            const hasWalletPayment = (payload.appliedWallets && payload.appliedWallets.length > 0) ||
                (payload.cashWalletDeduction && payload.cashWalletDeduction > 0) ||
                (payload.paymentMode && payload.paymentMode.some(p => p.method === "WALLET"));

            if (hasWalletPayment && (!isWalletOtpVerified || !walletOtpVerificationId)) {
                return toast.error("Wallet billing requires successful OTP verification. Please click SEND OTP before generating invoice.");
            }

            const token = localStorage.getItem("Token");
            const response = await postData("invoices/", payload, token);

            if (response?.status === 200) {

                const completeInvoice = {
                    ...payload,
                    ...(response.data || {}),
                    appliedWallets: response.data?.appliedWallets?.length ? response.data.appliedWallets : payload.appliedWallets,
                    cashWalletDeduction: response.data?.cashWalletDeduction ?? payload.cashWalletDeduction,
                    paymentMode: response.data?.paymentMode?.length ? response.data.paymentMode : payload.paymentMode,
                    items: response.data?.items?.length ? response.data.items : payload.items
                };

                setLastInvoice(completeInvoice);

                Swal.fire({
                    title: "Invoice Created Successfully",
                    html: `
                        <p style="margin-bottom: 20px;">Would you like to print or share the bill?</p>
                        <div style="display: flex; flex-direction: column; gap: 10px;">
                            <button id="custom-print" class="swal2-confirm swal2-styled" style="width: 100%; margin: 0; background-color: #3C0008;">Print Bill</button>
                            <button id="custom-wa-old" class="swal2-confirm swal2-styled" style="width: 100%; margin: 0; background-color: #25D366;">Share via WhatsApp</button>
                            <button id="custom-wa-tvfm" class="swal2-confirm swal2-styled" style="width: 100%; margin: 0; background-color: #128C7E;">Share via TVFM Meta WhatsApp</button>
                            <button id="custom-skip" class="swal2-cancel swal2-styled" style="width: 100%; margin: 0; background-color: #6c757d;">Skip</button>
                        </div>
                    `,
                    showConfirmButton: false,
                    showCancelButton: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        document.getElementById('custom-print').addEventListener('click', () => {
                            Swal.close();
                            printInvoice(completeInvoice);
                        });
                        document.getElementById('custom-wa-old').addEventListener('click', () => {
                            Swal.close();
                            handleShareOldWhatsApp(completeInvoice);
                        });
                        document.getElementById('custom-wa-tvfm').addEventListener('click', () => {
                            Swal.close();
                            handleShareTVFMWhatsApp(completeInvoice);
                        });
                        document.getElementById('custom-skip').addEventListener('click', () => {
                            Swal.close();
                        });
                    }
                });

                // Reset POS
                setCart([]);
                setCartId("");
                setProducts([]);
                setServices([]);
                setMemberships([]);
                setPosRefreshKey(prev => prev + 1);

                setSelectedCustomerOption(null);
                setCustomerSearch("");

                setAppliedCoupons([]);
                setPayments([{ method: "", amount: "" }]);

                setOverallDiscount(0);
                setMiscellaneousCharges(0);
                setMiscReason("");

                setIsMembershipApplied(false);
                setActiveMembership(null);
                setIsCashWalletApplied(false);
                setAppliedCashWallet(null);
                setCustomWalletDeductionAmount(0);

                setGstRate(0);

                setFormData(prev => ({
                    ...prev,
                    transactionType: "SALE"
                }));

                setInvoiceDate(
                    approvedBackDate || todayStr
                );

                setCustomerRefreshKey(prev => prev + 1);

                setShowPaymentModal(false);

                await clearPosDraft();
            }

        } catch (err) {
            console.error("Invoice Save Error:", err);
            toast.error("Failed to create invoice");
        }
    };

    // -----------------Coupon-----------------------

    const getProductAndServiceTotals = () => {
        let productTotal = 0;
        let serviceTotal = 0;

        normalItems.forEach(item => {
            const amount = Number(item.price || 0) * Number(item.qty || 1);

            if (item.category === "product") {
                productTotal += amount;
            }

            if (item.category === "service") {
                serviceTotal += amount;
            }
        });

        return {
            productTotal,
            serviceTotal
        };
    };

    const calculateTotalCouponDiscount = (pTotal = 0, sTotal = 0) => {
        // The backend already returns the absolute pre-calculated discount value in 'discountAmount'
        // regardless of whether it was a percentage or flat coupon.
        return appliedCoupons.reduce((sum, coupon) => {
            return sum + Number(coupon.discountAmount || 0);
        }, 0);
    };


    const applyCoupon = async () => {
        if (!couponInput.trim()) {
            return toast.error("Please enter a coupon code");
        }

        if (!selectedStoreId) {
            return toast.error("Please select store");
        }

        // ❌ Prevent duplicate coupon
        if (appliedCoupons.some(c => c.code === couponInput.toUpperCase())) {
            return toast.error("Coupon already applied");
        }

        try {
            const { productTotal, serviceTotal } = getProductAndServiceTotals();

            // ❌ No items at all
            if (productTotal === 0 && serviceTotal === 0) {
                return toast.error("Add items to cart before applying coupon");
            }

            const payload = {
                storeId: selectedStoreId,
                couponCode: couponInput.trim().toUpperCase(),
                productTotal,
                serviceTotal
            };

            const token = localStorage.getItem("Token");
            const res = await postData("coupons/coupon/validate", payload, token);

            if (!res?.success) {
                return toast.error(res.message || "Invalid coupon");
            }

            const { appliedOn: rawAppliedOn, discountType: rawType, discountAmount: rawAmount, usedCount, remainingCount } = res.data;
            const appliedOn = String(rawAppliedOn || "both").toLowerCase();
            const discountType = String(rawType || "fixed").toLowerCase();
            const discVal = Number(rawAmount || 0);

            if (appliedOn === "product" && productTotal <= 0) {
                return toast.error(
                    "❌ This coupon is valid only for PRODUCTS. Add products to apply."
                );
            }

            if (appliedOn === "service" && serviceTotal <= 0) {
                return toast.error(
                    "❌ This coupon is valid only for SERVICES. Add services to apply."
                );
            }
            if (
                appliedOn === "both" &&
                productTotal <= 0 &&
                serviceTotal <= 0
            ) {
                return toast.error(
                    "❌ This coupon requires products or services in cart"
                );
            }

            // 🚨 VALIDATION: Prevent coupon value from exceeding subtotal (Flat only)
            const isFixed = discountType === "fixed";


            if (isFixed) {
                if (appliedOn === "product" && discVal > productTotal) {
                    return toast.error(`❌ Coupon value (${discVal}) exceeds Product Total (${productTotal.toFixed(2)})`);
                }
                if (appliedOn === "service" && discVal > serviceTotal) {
                    return toast.error(`❌ Coupon value (${discVal}) exceeds Service Total (${serviceTotal.toFixed(2)})`);
                }
                if (appliedOn === "both" && discVal > (productTotal + serviceTotal)) {
                    const total = productTotal + serviceTotal;
                    return toast.error(`❌ Coupon value (${discVal}) exceeds Total Cart Amount (${total.toFixed(2)})`);
                }
            }

            /* ✅ APPLY COUPON */
            setAppliedCoupons(prev => [
                ...prev,
                {
                    code: payload.couponCode,
                    discountType: isFixed ? "FIXED" : "PERCENTAGE",
                    discountAmount: discVal,
                    appliedOn: appliedOn,
                    usedCount,
                    remainingCount
                }
            ]);

            setCouponInput("");
            toast.success(`Coupon ${payload.couponCode} applied successfully`);

        } catch (error) {
            console.error("Coupon apply error:", error);
            toast.error("Failed to apply coupon");
        }
    };





    // ----------------- UI Helpers -----------------

    // Total products & services count



    useEffect(() => {
        (async () => {
            const draft = await getPosDraft();
            if (!draft || Array.isArray(draft)) return;

            const initialCart = (draft.cart || []).map(item => ({
                ...item,
                employeeIds: item.employeeIds || (item.employeeId ? [item.employeeId] : [])
            }));
            setCart(initialCart);
            setCartId(draft.cartId || "");
            setSelectedCustomerOption(draft.selectedCustomerOption || null);
            setCustomerSearch(
                draft.selectedCustomerOption
                    ? `${draft.selectedCustomerOption.label} (${draft.selectedCustomerOption.phone || ""})`
                    : draft.customerSearch || ""
            );
            setInvoiceDate(draft.approvedBackDate || localStorage.getItem("approvedBackDate") || todayStr);

            setFormData(prev => ({
                ...prev,
                transactionType: draft.transactionType || "SALE"
            }));

            setPayments(draft.payments || [{ method: "", amount: 0 }]);
            setOverallDiscount(draft.overallDiscount || 0);
            setOverallDiscountType(draft.overallDiscountType || "PERCENTAGE");
            setGstType(draft.gstType || "Inclusive");
            setGstRate(draft.gstRate || "");
            setActiveTab(draft.activeTab || "services");
            setIsMembershipApplied(draft.isMembershipApplied || false);
            setApprovedBackDate(draft.approvedBackDate || localStorage.getItem("approvedBackDate") || null);
            setSelectedStoreId(draft.selectedStoreId || selectedStoreId);
        })();
    }, []);

    const visibleTabs = (() => {
        if (formData.transactionType === "SELF") return ["products"];
        if (formData.transactionType === "MEMBERSHIP") return ["membership"];
        if (formData.transactionType === "SALE") return ["services", "products"];
    })();

    useEffect(() => {
        if (formData.transactionType === "SELF") {
            setActiveTab("products");
            setPosSearchType("PRODUCT");
        } else if (formData.transactionType === "MEMBERSHIP") {
            setActiveTab("membership");
            setPosSearchType("MEMBERSHIP");

            // Auto-fetch memberships if we have a store and token
            if (selectedStoreId && sessionToken) {
                const fetchInitMemberships = async () => {
                    try {
                        const res = await getData(
                            "subscriptions/subscriptions",
                            { storeId: selectedStoreId, page: 1, limit: 50 },
                            sessionToken
                        );
                        const list = res?.data?.results || res?.data || [];
                        setMemberships(list);
                    } catch (err) {
                        console.error("Failed to pre-fetch memberships:", err);
                    }
                };
                fetchInitMemberships();
            }
        } else if (formData.transactionType === "SALE") {
            // ONLY force to services if we are NOT already on a valid SALE tab (services or products)
            if (activeTab !== "services" && activeTab !== "products") {
                setActiveTab("services");
            }
            setPosSearchType("SERVICE");
        }
    }, [formData.transactionType, selectedStoreId, sessionToken]);

    const invoiceSummary = useMemo(() => {
        return computeInvoiceSummary();
    }, [
        cart,
        overallDiscount,
        overallDiscountType,
        miscellaneousCharges,
        appliedCoupons,
        gstType,
        activeMembership,
        isMembershipApplied,
        currentStore,
        formData.transactionType,
    ]);

    const resetCartState = () => {
        // Reset CART contents but preserve CUSTOMER selection
        setCart([]);
        setCartId(null);

        setOverallDiscount(0);
        setOverallDiscountType("PERCENTAGE");
        setMiscellaneousCharges(0);
        setMiscReason("");

        setGstType("Inclusive");
        setGstRate("");
        setPayments([{ method: "", amount: "" }]);
        setShowPrintButton(false);
        setShowPaymentModal(false);

        // Reset Membership & Coupons
        setIsMembershipApplied(false);
        setActiveMembership(null);
        setAppliedCoupons([]);
        setCouponInput("");

        // Note: selectedCustomerOption and formData.transactionType are preserved
    };

    // Track previous type to avoid unnecessary resets
    const prevTransactionType = React.useRef(formData.transactionType);

    useEffect(() => {
        // Only reset items if the transaction type actually changed (e.g. SALE -> MEMBERSHIP)
        if (prevTransactionType.current !== formData.transactionType) {
            resetCartState();

            // Force Inclusive for Membership by default
            if (formData.transactionType === "MEMBERSHIP") {
                setGstType("Inclusive");
            }

            prevTransactionType.current = formData.transactionType;
        }
    }, [formData.transactionType]);


    useEffect(() => {
        if (!selectedCustomerOption) {
            setActiveMembership(null);
            setHasExistingActiveMembership(false);
            return;
        }

        // Robustly find subscription details (check multiple possible fields)
        const subs = selectedCustomerOption.subscriptionDetails ||
            selectedCustomerOption.data?.subscriptionDetails ||
            selectedCustomerOption.memberships ||
            selectedCustomerOption.data?.memberships ||
            selectedCustomerOption.subscriptions ||
            selectedCustomerOption.data?.subscriptions ||
            [];

        const now = new Date();
        const active = subs.find(s => {
            if (!s.subscriptionStartDate || !s.subscriptionEndDate) return false;

            const startDate = new Date(s.subscriptionStartDate);
            const endDate = new Date(s.subscriptionEndDate);
            // Ensure end date includes the full day
            endDate.setHours(23, 59, 59, 999);

            // Flexible check for isActive (supports true, "true", "Active", etc.)
            const isActive = s.isActive === true ||
                String(s.isActive).toLowerCase() === "true" ||
                String(s.isActive).toLowerCase() === "active";

            return startDate <= now && endDate >= now && isActive;
        });

        if (formData.transactionType === "MEMBERSHIP") {
            if (active) {
                setHasExistingActiveMembership(true);
                toast.warning(`⚠️ Customer already has an active membership: ${active.subscriptionName}. It expires on ${new Date(active.subscriptionEndDate).toLocaleDateString()}.`);
            } else {
                setHasExistingActiveMembership(false);
            }
            setActiveMembership(null);
        } else {
            if (active) {
                setHasExistingActiveMembership(true);
                setActiveMembership(active);
                toast.info(`🎟️ Active Membership Found: ${active.subscriptionName}.`);
            } else {
                setHasExistingActiveMembership(false);
                setActiveMembership(null);

                // 🚨 Check for Expired Membership (Most recent first)
                const expired = [...subs]
                    .sort((a, b) => new Date(b.subscriptionEndDate) - new Date(a.subscriptionEndDate))
                    .find(s => {
                        if (!s.subscriptionEndDate) return false;
                        const endDate = new Date(s.subscriptionEndDate);
                        endDate.setHours(23, 59, 59, 999);
                        return endDate < now; // It expired in the past
                    });
                if (expired) {
                    toast.warning(`⚠️ Membership Expired: ${expired.subscriptionName} expired on ${new Date(expired.subscriptionEndDate).toLocaleDateString()}.`);
                }
            }
        }
    }, [selectedCustomerOption, formData.transactionType]);

    /* ✅ Fetch active Customer Wallets on customer selection */
    useEffect(() => {
        const custId = selectedCustomerOption?.value || selectedCustomerOption?._id;
        if (custId) {
            fetchCustomerWallets(custId);
        } else {
            setCustomerWallets([]);
            setIsCashWalletApplied(false);
            setAppliedCashWallet(null);
            setCustomWalletDeductionAmount(0);
        }
    }, [selectedCustomerOption, fetchCustomerWallets]);


    useEffect(() => {
        if ((loggedInRole === "StoreAdmin" || loggedInRole === "StoreManager" || loggedInRole === "Biller") && adminStoreIds.length === 1) {
            const storeId = adminStoreIds[0];
            setSelectedStoreId(storeId);
            // 🔒 Prevent override by drafts or dropdowns
            sessionStorage.setItem("selectedStoreId", storeId);
        }
    }, [loggedInRole, adminStoreIds]);

    // 🏪 Fetch all stores when StoreAdmin has multiple stores
    useEffect(() => {
        if (adminStoreIds.length > 1 && sessionToken) {
            const fetchAdminStores = async () => {
                try {
                    const results = await Promise.all(
                        adminStoreIds.map(id => getData(`stores/store/${id}`, {}, sessionToken))
                    );
                    const fetched = results
                        .filter(r => r?.status === 200 && r?.data)
                        .map(r => r.data);
                    setStores(fetched);
                } catch (err) {
                    console.error("Failed to fetch admin stores", err);
                }
            };
            fetchAdminStores();
        }
    }, [adminStoreIds.length, sessionToken]);

    const applyMembership = () => {
        if (!activeMembership) return;

        const serviceItems = cart.filter(item => item.category === "service");

        // ✅ PRODUCT-ONLY BILL → DO NOTHING
        if (serviceItems.length === 0) {
            toast.error(
                "Membership benefits apply only to services."
            );
            return;
        }

        // 🚨 CHECK IF ANY SERVICES ARE ELIGIBLE
        const eligibleItems = serviceItems.filter(item =>
            activeMembership.subscriptionValueType === "PERCENTAGE" ||
            (item.membershipPrice !== null && item.membershipPrice !== undefined)
        );

        if (eligibleItems.length === 0) {
            toast.error("No eligible services found in cart for this membership.");
            return;
        }

        // ✅ APPLY MEMBERSHIP SELECTIVELY
        setCart(prev =>
            prev.map(item => {
                if (item.category !== "service") return item;

                // Eligibility check:
                // 1. Percentage memberships apply to ALL services.
                // 2. Service-based memberships apply only if membershipPrice exists.
                const isEligible = activeMembership.subscriptionValueType === "PERCENTAGE" ||
                    (item.membershipPrice !== null && item.membershipPrice !== undefined);

                if (!isEligible) return item;

                const { discount, finalPrice } =
                    calculateMembershipDiscount(item, activeMembership);

                return {
                    ...item,
                    membershipApplied: true,
                    membershipName: activeMembership.subscriptionName,
                    membershipDiscount: discount,
                    priceAfterMembership: finalPrice,
                };
            })
        );

        setIsMembershipApplied(true);
    };

    const removeMembership = () => {
        setCart(prev =>
            prev.map(item => ({
                ...item,
                membershipApplied: false,
                membershipName: null,
            }))
        );

        setIsMembershipApplied(false);
    };


    const applyItemDiscount = (originalPrice, discountType, discountValue) => {
        const price = Number(originalPrice) || 0;
        const value = Number(discountValue) || 0;

        let discountAmount = 0;

        if (discountType === "PERCENTAGE") {
            discountAmount = (price * value) / 100;
        } else if (discountType === "FLAT") {
            discountAmount = value;
        }

        return Math.max(price - discountAmount, 0);
    };

    const updateItemDiscount = (rowId, field, value) => {
        setCart(prev =>
            prev.map(item => {
                if (item.rowId !== rowId) return item;

                const baseTotal = Number(item.price || 0) * Number(item.qty || 1);
                let checkValue = field === "discountValue" ? Number(value) : Number(item.discountValue);
                let checkType = field === "discountType" ? value : item.discountType;

                if (checkType === "PERCENTAGE" && checkValue > 100) {
                    toast.error("❌ Discount percentage cannot exceed 100%");
                    return item;
                }

                if (checkType === "FLAT" && checkValue > baseTotal) {
                    toast.error(`❌ Discount amount cannot exceed item total (${baseTotal.toFixed(2)})`);
                    return item;
                }

                const updatedItem = {
                    ...item,
                    [field]: field === "discountValue"
                        ? (value === "" ? 0 : value)
                        : value
                };

                return updatedItem;
            })
        );
    };

    const updateItemPrice = (rowId, value) => {
        setCart(prev =>
            prev.map(item => {
                if (item.rowId !== rowId) return item;

                const numVal = value === "" ? 0 : Number(value);

                return {
                    ...item,
                    price: value,
                    nonMemberShipPrice: item.category === "service" ? numVal : item.nonMemberShipPrice,
                    priceOfMembership: item.category === "membership" ? numVal : item.priceOfMembership
                };
            })
        );
    };

    const loadCustomers = useCallback(async (inputValue, loadedOptions, { page }) => {
        try {
            const trimmedInput = (inputValue || "").trim();
            const res = await getData(
                "customers/customers",
                {
                    page,
                    limit: 10,
                    name: trimmedInput,
                    phoneNumber: trimmedInput,
                    email: trimmedInput,
                    storeId: selectedStoreId
                },
                sessionToken
            );

            // Robust check for different response structures
            const pageData = Array.isArray(res?.data) ? res.data[0] : res?.data;
            const customers = pageData?.paginatedResults || (Array.isArray(res?.data) ? res.data : []);

            const options = customers.map(cus => ({
                value: cus._id,
                label: `${cus.name} (${cus.phoneNumber})`,
                phone: cus.phoneNumber,
                data: cus,
                subscriptionDetails: cus.subscriptionDetails || []
            }));

            return {
                options,
                hasMore: pageData?.currentPage < pageData?.totalPages,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Customer Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    }, [selectedStoreId, sessionToken]);

    const loadEmployees = useCallback(async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "users/users",
                {
                    page,
                    limit: 10,
                    search: inputValue,
                    storeId: selectedStoreId,
                    isActive: true,
                },
                sessionToken
            );

            const pageData = Array.isArray(res?.data) ? res.data[0] : res?.data;
            const activeEmployees = pageData?.paginatedResults || (Array.isArray(res?.data) ? res.data : []);

            const options = activeEmployees.map(emp => {
                const fullName = `${emp.firstName || ""} ${emp.lastName || ""}`.trim() || emp.name || "";
                return {
                    value: emp._id,
                    label: fullName,
                    data: emp
                };
            });

            return {
                options,
                hasMore: (pageData?.currentPage || 0) < (pageData?.totalPages || 0),
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Employee Fetch Failed", err);
            return {
                options: [],
                hasMore: false,
                additional: { page }
            }
        }
    }, [selectedStoreId, sessionToken]);

    const loadProductAndServices = useCallback(async (inputValue, loadedOptions, { page }) => {
        try {
            const token = localStorage.getItem("Token");
            if (!selectedStoreId) return { options: [], hasMore: false };

            const transactionType = formData.transactionType;
            let productList = [];
            let serviceList = [];
            let membershipList = [];

            // Tracking original lengths for pagination (hasMore)
            let rawProductCount = 0;
            let rawServiceCount = 0;
            let rawMembershipCount = 0;

            // 🔹 Fetch Products (For SALE and SELF)
            if (transactionType === "SELF" || (transactionType === "SALE" && posSearchType === "PRODUCT")) {
                const productRes = await getData(
                    `inventories/products/${selectedStoreId}`,
                    { page, limit: 10, search: inputValue },
                    token
                );
                // Robust check for products
                const pData = Array.isArray(productRes?.data) ? productRes.data[0] : productRes?.data;
                const rawProducts = pData?.paginatedResults || (Array.isArray(productRes?.data) ? productRes.data : []);
                rawProductCount = rawProducts.length;

                // 🔸 Filter: Only show products with stock greater than 0
                productList = rawProducts.filter(p => Number(p.inStock || 0) > 0);
            }

            // 🔹 Fetch Services (For SALE only)
            if (transactionType === "SALE" && posSearchType === "SERVICE") {
                const serviceRes = await getData(
                    "services/services",
                    { storeId: selectedStoreId, page, limit: 100, serviceName: inputValue, isActive: true },
                    token
                );
                const sData = Array.isArray(serviceRes?.data) ? serviceRes.data[0] : serviceRes?.data;
                const rawServices = sData?.paginatedResults || (Array.isArray(serviceRes?.data) ? serviceRes.data : []);
                const activeServices = rawServices.filter(s => s.isActive !== false && s.serviceStatus !== "Inactive");
                rawServiceCount = activeServices.length;
                serviceList = activeServices;
            }

            // 🔹 Fetch Memberships (For MEMBERSHIP only)
            if (transactionType === "MEMBERSHIP") {
                const membershipRes = await getData(
                    "subscriptions/subscriptions",
                    {
                        storeId: selectedStoreId,
                        page,
                        limit: 50,
                        search: inputValue,
                        subscriptionValueType: membershipFilterType
                    },
                    token
                );
                const rawMemberships = membershipRes?.data?.results || membershipRes?.data || [];
                rawMembershipCount = rawMemberships.length;

                // 🔹 Robust Frontend Filtering (Fallback + Case-Insensitive)
                membershipList = rawMemberships.filter(m => {
                    const type = (m.subscriptionValueType || m.subscriptionType || "").toString().trim().toUpperCase();
                    return type === membershipFilterType.toUpperCase();
                });
            }

            const options = [
                ...productList
                    .map(p => ({
                        value: p._id || p.productId,
                        label: p.title,
                        price: p.sellingPrice,
                        data: p,
                        type: "Product"
                    })),
                ...serviceList.map(s => ({
                    value: s._id,
                    label: s.serviceName,
                    price: s.nonMemberShipPrice,
                    data: s,
                    type: "Service"
                })),
                ...membershipList.map(m => ({
                    value: m._id,
                    label: m.subscriptionName,
                    price: m.priceOfMembership,
                    code: m.subscriptionCode,
                    data: m,
                    type: "Membership"
                }))
            ];

            return {
                options,
                hasMore: rawProductCount === 10 || rawServiceCount === 10 || rawMembershipCount === 10,
                additional: { page: page + 1 }
            };
        } catch (err) {
            console.error("Search Error:", err);
            return { options: [], hasMore: false };
        }
    }, [selectedStoreId, formData.transactionType, posSearchType, sessionToken, membershipFilterType]);

    const handleProductSearchSelect = (option) => {
        if (!option) return;
        const { type, data } = option;

        // Ensure item exists in our local list for lookup in addToCart state update
        if (type === "Product") {
            setProducts(prev => {
                const existingIndex = prev.findIndex(p => String(p._id || p.productId) === String(data._id || data.productId));
                if (existingIndex === -1) {
                    return [...prev, data];
                }
                const updated = [...prev];
                updated[existingIndex] = { ...updated[existingIndex], ...data };
                return updated;
            });
        } else if (type === "Service") {
            setServices(prev => {
                if (!prev.find(s => s._id === data._id)) {
                    return [...prev, data];
                }
                return prev;
            });
        } else if (type === "Membership") {
            setMemberships(prev => {
                if (!prev.find(m => m._id === data._id)) {
                    return [...prev, data];
                }
                return prev;
            });
        }

        addToCart(data, type);
    };

    const compactSelectStyles = {
        container: (base) => ({
            ...base,
            width: "100%",
        }),
        control: (base, state) => ({
            ...base,
            minHeight: "40px",
            height: state.isMulti || state.selectProps?.isMulti ? "auto" : "40px",
            fontSize: "13px",
            borderRadius: "8px",
            border: "1px solid #cbd5e1",
            boxShadow: "none",
            backgroundColor: "#fff",
            width: "100%",
            "&:hover": { border: "1px solid #94a3b8" }
        }),
        valueContainer: (base, state) => ({
            ...base,
            padding: "2px 6px",
            minHeight: "36px",
            height: state.isMulti || state.selectProps?.isMulti ? "auto" : "36px",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap"
        }),
        singleValue: (base) => ({
            ...base,
            color: "#3C0008",
            fontWeight: "600",
            fontSize: "13px",
            margin: 0
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: "#f9f1f2",
            borderRadius: "6px",
            margin: "2px",
            border: "1px solid #3c000820"
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: "#3C0008",
            fontSize: "11px",
            fontWeight: "600",
            padding: "2px 6px"
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: "#3C0008",
            opacity: 0.6,
            ":hover": {
                backgroundColor: "#3C0008",
                color: "#ffffff",
                borderRadius: "0 6px 6px 0",
                opacity: 1
            }
        }),
        option: (base, state) => ({
            ...base,
            fontSize: "13px",
            fontWeight: "600",
            padding: "8px 12px",
            color: state.isSelected ? "#ffffff" : "#3C0008",
            backgroundColor: state.isSelected ? "#3C0008" : state.isFocused ? "#f9f1f2" : "#ffffff",
            cursor: "pointer"
        }),
        input: (base) => ({
            ...base,
            fontSize: "13px",
            fontWeight: "500",
            color: "#3C0008",
            margin: "0",
            padding: "0"
        }),
        indicatorsContainer: (base, state) => ({
            ...base,
            height: state.isMulti || state.selectProps?.isMulti ? "auto" : "40px",
        }),
        dropdownIndicator: (base) => ({
            ...base,
            padding: "2px",
        }),
        clearIndicator: (base) => ({
            ...base,
            padding: "2px",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#94a3b8",
            fontSize: "12px",
        }),
    };

    const controlPanelSelectStyles = {
        control: (base) => ({
            ...base,
            minHeight: "52px",
            height: "52px",
            fontSize: "14px",
            borderRadius: "var(--radius-md)",
            border: "1px solid #e2e8f0",
            boxShadow: "var(--shadow-soft)",
            backgroundColor: "#fff",
            "&:hover": { border: "1px solid #cbd5e1" }
        }),
        valueContainer: (base) => ({
            ...base,
            padding: "0 16px",
            height: "52px",
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: "52px",
        }),
        input: (base) => ({
            ...base,
            margin: "0",
            padding: "0",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#94a3b8",
        }),
        singleValue: (base) => ({
            ...base,
            color: "#1e293b",
            fontWeight: "600",
        }),
    };

    const formatOptionLabel = ({ label, type, price, code }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: type === "Product" ? "#eff6ff" : type === "Service" ? "#ecfdf5" : "#f5f3ff"
                }}>
                    <Icon
                        icon={
                            type === "Product" ? "solar:box-bold-duotone" :
                                type === "Service" ? "solar:scissors-bold-duotone" :
                                    "solar:card-bold-duotone"
                        }
                        style={{
                            color: type === "Product" ? "#3b82f6" : type === "Service" ? "#10b981" : "#8b5cf6",
                            fontSize: '18px'
                        }}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontWeight: 700, color: '#1e293b', fontSize: '13px' }}>{label}</span>
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontWeight: 800, color: '#3C0008', fontSize: '14px' }}>{price}</span>
            </div>
        </div>
    );


    // ================= UI ONLY (NO LOGIC CHANGE) =================
    const { productTotal, serviceTotal = 0 } = getProductAndServiceTotals();

    const couponBaseAmount =
        appliedCoupons?.appliedOn === "product"
            ? productTotal
            : appliedCoupons?.appliedOn === "service"
                ? serviceTotal
                : appliedCoupons?.appliedOn === "both"
                    ? productTotal + serviceTotal
                    : 0;

    const handleProceedPayment = () => {

        const missingEmployeeItems = cart.filter(
            (item) =>
                (item.category === "product" ||
                    item.category === "service" ||
                    item.category === "membership") &&
                !item.employeeId
        );

        if (missingEmployeeItems.length > 0) {
            toast.error(
                "Employee selection is mandatory for Product, Service, and Membership billing. Kindly select an employee before proceeding with the payment."
            );
            return;
        }

        const activeServiceWallets = (customerWallets || []).filter(w => {
            if (w.type !== 'Service' || (w.status !== 'ACTIVE' && w.status !== 'Active') || w.isActive === false) return false;
            if (w.services && w.services.length > 0) {
                return w.services.some(s => (s.remainingCount || 0) > 0);
            }
            return (w.remainingCount || 0) > 0 || (w.balance || 0) > 0;
        });

        const hasAppliedServiceWalletItems = cart.some(item => item.isServiceWalletApplied);
        const hasEligibleServiceWallet = activeServiceWallets.length > 0 && cart.some(item => {
            const isSvc = item.category?.toLowerCase() === 'service';
            if (!isSvc) return false;
            const cartSvcId = String(item.serviceId?._id || item.serviceId?.id || (typeof item.serviceId === 'string' ? item.serviceId : '') || item.id || item._id || '');
            const cartSvcName = (item.serviceName || item.name || item.title || '').toLowerCase().trim();

            return activeServiceWallets.some(w => {
                if (w.services && w.services.length > 0) {
                    return w.services.some(s => {
                        const sId = String(s.serviceId?._id || s.serviceId?.id || (typeof s.serviceId === 'string' ? s.serviceId : '') || '');
                        const sName = (s.serviceId?.serviceName || s.serviceName || '').toLowerCase().trim();
                        return (sId && cartSvcId && sId === cartSvcId) || (sName && cartSvcName && (sName === cartSvcName || sName.includes(cartSvcName) || cartSvcName.includes(sName)));
                    });
                } else {
                    const wSvcId = String(w.serviceId?._id || w.serviceId?.id || (typeof w.serviceId === 'string' ? w.serviceId : '') || w.walletPackageId?.serviceId?._id || w.walletPackageId?.serviceId?.id || '');
                    const wSvcName = (w.serviceId?.serviceName || w.walletPackageId?.serviceId?.serviceName || w.walletPackageId?.name || '').toLowerCase().trim();
                    return (wSvcId && cartSvcId && wSvcId === cartSvcId) || (wSvcName && cartSvcName && (wSvcName === cartSvcName || wSvcName.includes(cartSvcName) || cartSvcName.includes(wSvcName)));
                }
            });
        });

        setIsServiceWalletUsedInCheckout(hasAppliedServiceWalletItems);

        const finalPayable = invoiceSummary.finalAmount;

        // 💰 SERVICE WALLET & CASH WALLET PAYMENT REDEMPTION ALLOCATION
        const actualCashPayable = Math.max(0, invoiceSummary.finalAmount);

        // Calculate unallocated service total (services not covered by any Service Wallet)
        const unallocatedServiceTotal = (cart || [])
            .filter(i => (!i.category || String(i.category).toLowerCase() === "service" || String(i.type).toLowerCase() === "service") && !i.isServiceWalletApplied)
            .reduce((sum, i) => sum + (Number(i.price || i.total || 0) * Number(i.qty || 1)), 0);

        // 🧠 AUTOMATICALLY DETECT CASH WALLET FOR UNALLOCATED SERVICE SEGMENT IF ACTIVE WALLET EXISTS
        const activeCashWallet = (customerWallets || []).find(w => w.type === 'Cash' && w.status === 'ACTIVE' && (w.balance || 0) > 0);

        setIsCashWalletApplied(false);
        setCustomWalletDeductionAmount(0);

        if (activeCashWallet && unallocatedServiceTotal > 0) {
            setAppliedCashWallet(activeCashWallet);
        } else {
            setAppliedCashWallet(null);
        }

        setPaymentModalTotal(actualCashPayable);

        setPayments([
            {
                method: "CASH",
                amount: actualCashPayable,
                receivedAmount: actualCashPayable
            }
        ]);

        setIsWalletOtpVerified(false);
        setWalletOtpVerificationId(null);
        setWalletOtpInput("");
        setWalletOtpError("");

        setShowPaymentModal(true);
    };


    return (
        <div className="pos-container">

            <div className="pos-main">
                {/* ================= COLUMN 1: CONTROLS ================= */}
                <aside className="control-panel">
                    {/* -------- STORE SELECTOR (multi-store StoreAdmin only) -------- */}
                    {loggedInRole === "StoreAdmin" && adminStoreIds.length > 1 && (
                        <div className="header-row" style={{ marginBottom: '10px' }}>
                            <div className="input-group full-width">
                                <label className="input-label" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <span style={{
                                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                        width: '18px', height: '18px', borderRadius: '50%',
                                        background: '#3C0008', color: '#fff', fontSize: '10px', fontWeight: 800
                                    }}>🏪</span>
                                    Select Store <span className="required">*</span>
                                </label>
                                <select
                                    value={selectedStoreId || ""}
                                    onChange={(e) => {
                                        const id = e.target.value;
                                        setSelectedStoreId(id);
                                        // Reset cart & customer when store changes
                                        setCart([]);
                                        setCartId("");
                                        setSelectedCustomerOption(null);
                                        setAppliedCoupons([]);
                                        setPayments([]);
                                        setOverallDiscount(0);
                                        setActiveMembership(null);
                                        setIsMembershipApplied(false);
                                        // Force re-init of customer & product search dropdowns
                                        setCustomerRefreshKey(prev => prev + 1);
                                        setCurrentPage(1);
                                        setSearchText("");
                                    }}
                                    style={{
                                        width: '100%',
                                        padding: '10px 14px',
                                        borderRadius: '10px',
                                        border: selectedStoreId ? '1.5px solid #3C0008' : '1.5px solid #e2e8f0',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: selectedStoreId ? '#3C0008' : '#94a3b8',
                                        background: selectedStoreId ? 'rgba(60,0,8,0.04)' : '#fff',
                                        cursor: 'pointer',
                                        outline: 'none'
                                    }}
                                >
                                    <option value="">— Select a Store —</option>
                                    {stores.map(store => (
                                        <option key={store._id} value={store._id}>
                                            {store.storeName}
                                            {store.address ? ` · ${store.address}` : ''}
                                        </option>
                                    ))}
                                </select>
                                {!selectedStoreId && (
                                    <div style={{
                                        marginTop: '5px', fontSize: '11px', color: '#b91c1c',
                                        fontWeight: 600, display: 'flex', alignItems: 'center', gap: '4px'
                                    }}>
                                        ⚠ Please select a store to begin billing
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* -------- TRANSACTION TYPE & DATE ROW -------- */}
                    <div className="header-row" onMouseDownCapture={handleStoreValidation}>
                        <div className="input-group">
                            <label className="input-label">Transaction Type <span className="required">*</span></label>
                            <div className="transaction-toggle-group">
                                <button
                                    type="button"
                                    className={`transaction-toggle-btn ${formData.transactionType === "SALE" ? "active" : ""}`}
                                    onClick={() => {
                                        setFormData((prev) => ({ ...prev, transactionType: "SALE" }));
                                    }}
                                >
                                    SALE
                                </button>
                                <button
                                    type="button"
                                    className={`transaction-toggle-btn ${formData.transactionType === "SELF" ? "active" : ""}`}
                                    onClick={() => {
                                        setFormData((prev) => ({ ...prev, transactionType: "SELF" }));
                                    }}
                                >
                                    SELF
                                </button>
                                <button
                                    type="button"
                                    className={`transaction-toggle-btn ${formData.transactionType === "MEMBERSHIP" ? "active" : ""}`}
                                    onClick={() => {
                                        setFormData((prev) => ({ ...prev, transactionType: "MEMBERSHIP" }));
                                    }}
                                >
                                    MEMBERSHIP
                                </button>
                            </div>
                        </div>

                        <div className="input-group date-width">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <label>Invoice Date</label>
                                {approvedBackDate && loggedInRole !== "StoreAdmin" && (
                                    <button
                                        onClick={handleCloseBackdateSession}
                                        style={{
                                            fontSize: '9px',
                                            padding: '2px 6px',
                                            borderRadius: '4px',
                                            background: '#ef4444',
                                            color: '#fff',
                                            border: 'none',
                                            cursor: 'pointer',
                                            fontWeight: 700,
                                            marginBottom: '4px'
                                        }}
                                    >
                                        Close Back Date Bill
                                    </button>
                                )}
                            </div>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type="date"
                                    ref={dateInputRef}
                                    value={invoiceDate}
                                    max={todayStr}
                                    onChange={handleInvoiceDateChange}
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        opacity: 0.01,
                                        cursor: 'pointer',
                                        zIndex: 10
                                    }}
                                />

                                <div
                                    className="custom-date-input"
                                    onClick={() => {
                                        dateInputRef.current?.focus();
                                        dateInputRef.current?.click();
                                    }}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        width: '100%',
                                        height: '52px',
                                        padding: '10px 16px',
                                        border: '1px solid',
                                        borderColor:
                                            invoiceDate < todayStr
                                                ? '#f87171'
                                                : 'rgba(25, 29, 39, 0.2)',
                                        borderRadius: '8px',
                                        backgroundColor:
                                            approvedBackDate && invoiceDate < todayStr
                                                ? '#fef2f2'
                                                : '#fff',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        color: 'var(--text-main)',
                                        boxShadow: 'var(--shadow-soft)'
                                    }}
                                >
                                    <span>
                                        {invoiceDate
                                            ? invoiceDate.split('-').reverse().join('-')
                                            : 'Select Date'}
                                    </span>

                                    <Icon
                                        icon="mdi:calendar"
                                        style={{
                                            fontSize: '18px',
                                            opacity: 0.6
                                        }}
                                    />
                                </div>

                                {approvedBackDate &&
                                    invoiceDate < todayStr &&
                                    loggedInRole !== "StoreAdmin" && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                right: '8px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                color: '#ef4444',
                                                display: 'flex',
                                                alignItems: 'center',
                                                pointerEvents: 'none',
                                                zIndex: 11
                                            }}
                                        >
                                            <Icon icon="solar:lock-unlocked-bold-duotone" />
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>

                    {/* -------- CUSTOMER ROW -------- */}
                    {formData.transactionType !== "SELF" && (
                        <div className="header-row" onMouseDownCapture={handleStoreValidation}>
                            <div className="input-group full-width">
                                <label>Customer</label>
                                <CustomerSelect
                                    key={customerRefreshKey}
                                    value={selectedCustomerOption}   // ✅ EXACT OPTION OBJECT
                                    onChange={(option) => {
                                        if (!option) {
                                            resetCartState();
                                            setSelectedCustomerOption(null);
                                            setFormData((prev) => ({
                                                ...prev,
                                                customerId: "",
                                                customerName: "",
                                                customerPhone: "",
                                            }));
                                            return;
                                        }

                                        if (selectedCustomerOption?.value !== option.value) {
                                            resetCartState();
                                        }

                                        // ✅ STORE OPTION AS-IS
                                        setSelectedCustomerOption(option);

                                        // ✅ USE option.data FOR BUSINESS LOGIC
                                        setFormData((prev) => ({
                                            ...prev,
                                            customerId: option.value,
                                            customerName: option.data?.name || "",
                                            customerPhone: option.data?.phoneNumber || "",
                                        }));

                                        setShowCustomerPopup(true);
                                    }}
                                    loadCustomers={loadCustomers}
                                    onAddCustomer={(typedVal) => {
                                        setAddCustomerPhone(typedVal || "");
                                        setIsAddCustomer(true);
                                    }}
                                    styles={controlPanelSelectStyles}
                                />
                                {selectedCustomerOption && (() => {
                                    const activeCashW = (customerWallets || []).find(w => w.type === 'Cash' && w.status === 'ACTIVE' && w.isActive !== false);
                                    const activeSvcW = (customerWallets || []).find(w => w.type === 'Service' && w.status === 'ACTIVE' && w.isActive !== false);
                                    if (!activeCashW && !activeSvcW) return null;
                                    return (
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '6px' }}>
                                            {activeSvcW && (
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#e0e7ff', border: '1px solid #c7d2fe', borderRadius: '8px', padding: '6px 12px' }}>
                                                    <div style={{ fontSize: '12px', fontWeight: 600, color: '#3730a3', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        <span>🏷️ Service Wallet:</span>
                                                        <strong style={{ color: '#4338ca', fontSize: '13px' }}>{activeSvcW.remainingCount} Usages</strong>
                                                    </div>
                                                </div>
                                            )}
                                            {activeCashW && (
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#fefce8', border: '1px solid #fef08a', borderRadius: '8px', padding: '6px 12px' }}>
                                                    <div style={{ fontSize: '12px', fontWeight: 600, color: '#713f12', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        <span>💰 Cash Wallet:</span>
                                                        <strong style={{ color: '#16a34a', fontSize: '13px' }}>₹{Number(activeCashW.balance || 0).toFixed(2)}</strong>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })()}
                            </div>
                        </div>
                    )}



                    <div className="search-wrapper" onMouseDownCapture={handleStoreValidation}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            <label className="input-label" style={{ margin: 0 }}>
                                {formData.transactionType === "SALE"
                                    ? "Search Items"
                                    : formData.transactionType === "SELF"
                                        ? "Product Search"
                                        : formData.transactionType === "MEMBERSHIP"
                                            ? "Membership Search"
                                            : "Product Search"}
                            </label>
                            {formData.transactionType === "SALE" && (
                                <div style={{ display: 'flex', background: '#f1f5f9', padding: '2px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                    <button
                                        onClick={() => setPosSearchType("SERVICE")}
                                        style={{
                                            padding: '4px 12px',
                                            borderRadius: '6px',
                                            fontSize: '10px',
                                            fontWeight: 800,
                                            border: 'none',
                                            cursor: 'pointer',
                                            background: posSearchType === "SERVICE" ? "#3C0008" : "transparent",
                                            color: posSearchType === "SERVICE" ? "#fff" : "#64748b",
                                            transition: 'all 0.2s',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        Service
                                    </button>
                                    <button
                                        onClick={() => setPosSearchType("PRODUCT")}
                                        style={{
                                            padding: '4px 12px',
                                            borderRadius: '6px',
                                            fontSize: '10px',
                                            fontWeight: 800,
                                            border: 'none',
                                            cursor: 'pointer',
                                            background: posSearchType === "PRODUCT" ? "#3C0008" : "transparent",
                                            color: posSearchType === "PRODUCT" ? "#fff" : "#64748b",
                                            transition: 'all 0.2s',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        Product
                                    </button>
                                </div>
                            )}
                        </div>

                        {formData.transactionType === "MEMBERSHIP" && (
                            <div style={{ display: 'flex', background: '#f8fafc', padding: '4px', borderRadius: '10px', border: '1px solid #e2e8f0', marginBottom: '12px' }}>
                                <button
                                    onClick={() => setMembershipFilterType("SERVICE")}
                                    style={{
                                        flex: 1,
                                        padding: '8px 16px',
                                        borderRadius: '8px',
                                        fontSize: '11px',
                                        fontWeight: 800,
                                        border: 'none',
                                        cursor: 'pointer',
                                        background: membershipFilterType === "SERVICE" ? "#3C0008" : "transparent",
                                        color: membershipFilterType === "SERVICE" ? "#fff" : "#64748b",
                                        transition: 'all 0.2s',
                                        textTransform: 'uppercase',
                                        boxShadow: membershipFilterType === "SERVICE" ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
                                    }}
                                >
                                    Service
                                </button>
                                <button
                                    onClick={() => setMembershipFilterType("PERCENTAGE")}
                                    style={{
                                        flex: 1,
                                        padding: '8px 16px',
                                        borderRadius: '8px',
                                        fontSize: '11px',
                                        fontWeight: 800,
                                        border: 'none',
                                        cursor: 'pointer',
                                        background: membershipFilterType === "PERCENTAGE" ? "#3C0008" : "transparent",
                                        color: membershipFilterType === "PERCENTAGE" ? "#fff" : "#64748b",
                                        transition: 'all 0.2s',
                                        textTransform: 'uppercase',
                                        boxShadow: membershipFilterType === "PERCENTAGE" ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
                                    }}
                                >
                                    Percentage
                                </button>
                            </div>
                        )}

                        <div className="search-container-box">
                            <AsyncPaginate
                                key={`${formData.transactionType}-${selectedStoreId}-${posSearchType}-${membershipFilterType}-${posRefreshKey}`}
                                className="full-width"
                                placeholder={
                                    formData.transactionType === "SELF"
                                        ? "Search products..."
                                        : formData.transactionType === "MEMBERSHIP"
                                            ? "Search memberships..."
                                            : posSearchType === "PRODUCT"
                                                ? "Search products..."
                                                : "Search services..."
                                }
                                value={null}
                                loadOptions={loadProductAndServices}
                                onChange={handleProductSearchSelect}
                                onInputChange={(val) => {
                                    setSearchText(val);
                                    setCurrentPage(1);
                                }}
                                additional={{ page: 1 }}
                                formatOptionLabel={formatOptionLabel}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                styles={{
                                    ...controlPanelSelectStyles,
                                    control: (base) => ({
                                        ...controlPanelSelectStyles.control(base),
                                        paddingLeft: '35px'
                                    }),
                                    valueContainer: (base) => ({
                                        ...controlPanelSelectStyles.valueContainer(base),
                                        padding: "0"
                                    }),
                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                            />
                            <Icon icon="mdi:magnify" className="search-icon-pos" />
                        </div>
                    </div>

                    <div className="footer-buttons">
                        <button className="home-nav-btn-alt" onClick={() => {
                            const path = loggedInRole === "Biller" ? '/appointments' : '/dashboard';
                            navigate(path);

                            setTimeout(() => {
                                window.location.reload();
                            }, 100);
                        }}>
                            <Icon icon="heroicons:home-20-solid" />
                            <span>Back to Home</span>
                        </button>
                        <button className="clear-cart-button" onClick={clearCart}>
                            Clear Cart
                        </button>
                    </div>
                </aside>

                {/* ================= COLUMN 2: ACTIVE CART (CARDS) ================= */}
                <section className="selection-panel">
                    <div className="panel-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <h3 style={{ margin: 0 }}>Shopping Cart</h3>
                            <span className="item-count-badge">{cart.length} Items</span>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            {selectedCustomerOption && (customerWallets || []).filter(w => w.status === 'ACTIVE' && w.isActive !== false).length > 0 && (
                                <Button
                                    size="small"
                                    variant="contained"
                                    startIcon={<Icon icon="solar:wallet-money-bold-duotone" width="16" />}
                                    onClick={() => setShowActiveWalletsModal(true)}
                                    sx={{
                                        background: '#16a34a',
                                        color: '#fff',
                                        textTransform: 'none',
                                        fontWeight: 700,
                                        fontSize: '11px',
                                        padding: '4px 10px',
                                        borderRadius: '6px',
                                        boxShadow: '0 2px 6px rgba(22, 163, 74, 0.25)',
                                        '&:hover': { background: '#15803d' }
                                    }}
                                >
                                    💰 Wallet ({(customerWallets || []).filter(w => w.status === 'ACTIVE' && w.isActive !== false).length})
                                </Button>
                            )}
                            <Button
                                size="small"
                                variant="outlined"
                                startIcon={<Icon icon="solar:history-bold-duotone" width="16" />}
                                onClick={() => {
                                    if (!selectedCustomerOption) {
                                        toast.warning("Please select a customer first to view wallet history.");
                                        return;
                                    }
                                    const custId = selectedCustomerOption.value || selectedCustomerOption._id;
                                    fetchCustomerWalletHistory(custId);
                                    setShowWalletHistoryModal(true);
                                }}
                                sx={{
                                    borderColor: '#3C0008',
                                    color: '#3C0008',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    fontSize: '11px',
                                    padding: '4px 10px',
                                    borderRadius: '6px',
                                    '&:hover': { background: '#f9f1f2', borderColor: '#3C0008' }
                                }}
                            >
                                📜 Wallet History
                            </Button>
                            {(() => {
                                return (
                                    <Button
                                        size="small"
                                        variant="contained"
                                        startIcon={<Icon icon="solar:wallet-money-bold-duotone" width="16" />}
                                        onClick={() => {
                                            if (!selectedCustomerOption) {
                                                toast.warning("Please select a customer first to purchase or create a wallet.");
                                                return;
                                            }
                                            fetchAvailableServicesForWallet();
                                            fetchAvailableWalletPackages();
                                            setShowBuyWalletModal(true);
                                        }}
                                        sx={{
                                            background: '#3C0008',
                                            color: '#fff',
                                            textTransform: 'none',
                                            fontWeight: 700,
                                            fontSize: '11px',
                                            padding: '4px 12px',
                                            borderRadius: '6px',
                                            boxShadow: '0 2px 6px rgba(60, 0, 8, 0.2)',
                                            '&:hover': {
                                                background: '#5c000c'
                                            }
                                        }}
                                    >
                                        + Buy / Create Wallet
                                    </Button>
                                );
                            })()}
                        </div>
                    </div>
                    <div className="cart-items-container" ref={cartContainerRef}>
                        {cart.length === 0 ? (
                            <div className="cart-empty-state">
                                <Icon icon="mdi:cart-outline" className="icon" />
                                <h3>Your cart is empty</h3>
                                <p>Search for items on the left to add them here</p>
                            </div>
                        ) : (
                            <table class="pos-cart-table">
                                <thead>
                                    <tr>
                                        <th className="th-sn">S.No</th>
                                        <th className="th-item">Item Details</th>
                                        <th className="th-staff">Staff</th>
                                        <th className="th-qty">Qty</th>
                                        <th className="th-price">Price</th>
                                        <th className="th-discount">Discount</th>
                                        <th className="th-total">Total</th>
                                        <th className="th-action">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {normalItems.map((item, index) => {
                                        const cartIndex = cart.findIndex(c => c.rowId === item.rowId);
                                        const summary = computeInvoiceSummary();
                                        const pItem = summary.processedItems.find(p => p.rowId === item.rowId);
                                        const qty = Number(item.qty || 1);

                                        return (
                                            <tr key={item.rowId} className={`cart-table-row ${item.category}-bg-light`}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <div className="item-info">
                                                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                                                            <div className="item-name" title={item.name} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 700 }}>{item.name}</div>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '2px', flexWrap: 'wrap' }}>
                                                                <span className="item-cat" style={{
                                                                    fontSize: '9px',
                                                                    color: item.category === "product" ? "#3b82f6" : "#10b981",
                                                                    fontWeight: 800,
                                                                    textTransform: 'uppercase'
                                                                }}>{item.category}</span>
                                                                {item.isAppointmentService && (
                                                                    <span
                                                                        style={{
                                                                            background: '#fef3c7',
                                                                            color: '#92400e',
                                                                            border: '1px solid #fde68a',
                                                                            fontSize: '9px',
                                                                            fontWeight: 800,
                                                                            padding: '1px 6px',
                                                                            borderRadius: '4px',
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            gap: '2px'
                                                                        }}
                                                                    >
                                                                        ✓ Appointment Service
                                                                    </span>
                                                                )}
                                                                {(() => {
                                                                    if (item.isServiceWalletApplied) {
                                                                        return (
                                                                            <span
                                                                                onClick={() => toggleServiceWalletForCartRow(item.rowId)}
                                                                                title="Click to unapply Service Wallet"
                                                                                style={{
                                                                                    background: '#dcfce7',
                                                                                    color: '#15803d',
                                                                                    border: '1px solid #86efac',
                                                                                    fontSize: '9px',
                                                                                    fontWeight: 700,
                                                                                    padding: '1px 6px',
                                                                                    borderRadius: '4px',
                                                                                    display: 'inline-flex',
                                                                                    alignItems: 'center',
                                                                                    gap: '2px',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            >
                                                                                ✓ Wallet Applied ✕
                                                                            </span>
                                                                        );
                                                                    }

                                                                    const matchingWallet = item.category === "service" && (customerWallets || []).find(w => {
                                                                        if (w.type !== 'Service' || (w.status !== 'ACTIVE' && w.status !== 'Active') || w.isActive === false) return false;
                                                                        const cartSvcId = String(item.serviceId?._id || item.serviceId?.id || (typeof item.serviceId === 'string' ? item.serviceId : '') || item.id || item._id || '');
                                                                        const cartSvcName = (item.serviceName || item.name || item.title || '').toLowerCase().trim();

                                                                        if (w.services && w.services.length > 0) {
                                                                            return w.services.some(s => {
                                                                                const svcObj = s.serviceId;
                                                                                const wSvcId = String(svcObj?._id || svcObj?.id || (typeof svcObj === 'string' ? svcObj : '') || '');
                                                                                const wSvcName = (svcObj?.serviceName || '').toLowerCase().trim();
                                                                                const isIdMatch = wSvcId && cartSvcId && wSvcId === cartSvcId;
                                                                                const isNameMatch = wSvcName && cartSvcName && (cartSvcName === wSvcName || cartSvcName.includes(wSvcName) || wSvcName.includes(cartSvcName));
                                                                                return (isIdMatch || isNameMatch) && (s.remainingCount || 0) > 0;
                                                                            });
                                                                        } else {
                                                                            const walletSvcId = String(w.serviceId?._id || w.serviceId?.id || (typeof w.serviceId === 'string' ? w.serviceId : '') || w.walletPackageId?.serviceId?._id || '');
                                                                            const walletSvcName = (w.serviceId?.serviceName || w.walletPackageId?.serviceId?.serviceName || w.walletPackageId?.name || '').toLowerCase().trim();
                                                                            const isIdMatch = walletSvcId && cartSvcId && walletSvcId === cartSvcId;
                                                                            const isNameMatch = walletSvcName && cartSvcName && (cartSvcName === walletSvcName || cartSvcName.includes(walletSvcName) || walletSvcName.includes(cartSvcName));
                                                                            return (isIdMatch || isNameMatch) && (w.remainingCount || 0) > 0;
                                                                        }
                                                                    });

                                                                    if (matchingWallet) {
                                                                        return (
                                                                            <span
                                                                                onClick={() => applyServiceWalletToCart(matchingWallet)}
                                                                                title="Click to apply Service Wallet"
                                                                                style={{
                                                                                    background: '#eff6ff',
                                                                                    color: '#2563eb',
                                                                                    border: '1px solid #bfdbfe',
                                                                                    fontSize: '9px',
                                                                                    fontWeight: 700,
                                                                                    padding: '1px 6px',
                                                                                    borderRadius: '4px',
                                                                                    display: 'inline-flex',
                                                                                    alignItems: 'center',
                                                                                    gap: '2px',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            >
                                                                                + Apply Wallet
                                                                            </span>
                                                                        );
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    {(item.category === 'service' || item.category === 'product') && (
                                                        <div className="table-staff-select">
                                                            <EmployeeSelect
                                                                isMulti={item.category === 'service'}
                                                                value={
                                                                    item.category === 'service'
                                                                        ? (item.employeeIds && item.employeeIds.length > 0
                                                                            ? (Array.isArray(item.employeeIds)
                                                                                ? item.employeeIds.map((id, idx) => {
                                                                                    const names = (item.employeeName || item.employee || "").split(", ");
                                                                                    const rawId = typeof id === 'object' && id?._id ? id._id : id;
                                                                                    return {
                                                                                        value: rawId,
                                                                                        label: names[idx] || (typeof id === 'object' && id?.name ? id.name : "Staff")
                                                                                    };
                                                                                })
                                                                                : [])
                                                                            : (item.employeeId
                                                                                ? [{ value: item.employeeId, label: item.employeeName || item.employee }]
                                                                                : []))
                                                                        : (item.employeeId
                                                                            ? { value: item.employeeId, label: item.employeeName || item.employee }
                                                                            : null)
                                                                }
                                                                loadEmployees={loadEmployees}
                                                                styles={compactSelectStyles}
                                                                placeholder="Staff"
                                                                onChange={(employee) => {
                                                                    handleEmployeeChange(item.rowId, employee);
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    <div className="table-qty-box">
                                                        <button className="qty-btn" onClick={() => decQty(cartIndex)}>
                                                            <Icon icon="mdi:minus" />
                                                        </button>
                                                        <span className="qty-val">{qty}</span>
                                                        <button
                                                            className="qty-btn"
                                                            onClick={() => incQty(cartIndex)}
                                                            disabled={item.inStock > 0 && qty >= item.inStock}
                                                        >
                                                            <Icon icon="mdi:plus" />
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="table-price-input"
                                                        value={item.price ?? ""}
                                                        disabled={item.isServiceWalletApplied}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (/^\d*\.?\d*$/.test(val)) {
                                                                updateItemPrice(item.rowId, val);
                                                            }
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    {formData.transactionType !== "SELF" && (
                                                        <div className="table-discount-group">
                                                            <div className="table-discount-group">
                                                                <button
                                                                    type="button"
                                                                    className={`discount-toggle-btn ${item.discountType === "PERCENTAGE" ? "active" : ""}`}
                                                                    disabled={item.isServiceWalletApplied}
                                                                    onClick={() => updateItemDiscount(item.rowId, "discountType", "PERCENTAGE")}
                                                                >
                                                                    %
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className={`discount-toggle-btn ${item.discountType === "FLAT" ? "active" : ""}`}
                                                                    disabled={item.isServiceWalletApplied}
                                                                    onClick={() => updateItemDiscount(item.rowId, "discountType", "FLAT")}
                                                                >
                                                                    ₹
                                                                </button>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                value={item.discountValue || ""}
                                                                placeholder="0"
                                                                disabled={item.isServiceWalletApplied}
                                                                onChange={(e) => {
                                                                    const val = e.target.value;
                                                                    if (/^\d*\.?\d*$/.test(val)) {
                                                                        updateItemDiscount(item.rowId, "discountValue", val);
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    {item.isServiceWalletApplied ? (
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                                            <span style={{ textDecoration: 'line-through', color: '#94a3b8', fontSize: '11px' }}>
                                                                ₹{(applyItemDiscount(item.price, item.discountType, item.discountValue) * item.qty).toFixed(2)}
                                                            </span>
                                                            <strong style={{ color: '#16a34a', fontSize: '12px' }}>
                                                                WALLET (₹0.00)
                                                            </strong>
                                                        </div>
                                                    ) : (
                                                        `₹${(applyItemDiscount(item.price, item.discountType, item.discountValue) * item.qty).toFixed(2)}`
                                                    )}
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    <button className="table-remove-btn" onClick={() => removeItem(item.rowId)}>
                                                        <Icon icon="mdi:trash-can-outline" />
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}

                                    {/* 🔹 MEMBERSHIP ITEMS */}
                                    {isMembershipBilling && membershipItems.map((m, mIdx) => (
                                        <tr key={m.rowId} className="cart-table-row membership-bg-light">
                                            <td>{normalItems.length + mIdx + 1}</td>
                                            <td>
                                                <div className="item-info">
                                                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                                                        <span className="item-name" title={m.subscriptionName} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 700 }}>{m.subscriptionName}</span>
                                                        <span className="item-cat" style={{
                                                            fontSize: '9px',
                                                            color: "#8b5cf6",
                                                            fontWeight: 800,
                                                            textTransform: 'uppercase'
                                                        }}>Membership</span>
                                                        <div className="membership-details" style={{ fontSize: '10px', color: '#64748b' }}>
                                                            <span>Cycle: {m.subscriptionCycle}</span>
                                                            <span style={{ marginLeft: '8px' }}>Exp: {new Date(m.validTill).toLocaleDateString('en-GB')}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="table-staff-select">
                                                    <EmployeeSelect
                                                        isMulti={m.category === 'service'}
                                                        value={
                                                            m.category === 'service'
                                                                ? (m.employeeIds && m.employeeIds.length > 0
                                                                    ? (Array.isArray(m.employeeIds)
                                                                        ? m.employeeIds.map((id, idx) => {
                                                                            const names = (m.employeeName || m.employee || "").split(", ");
                                                                            const rawId = typeof id === 'object' && id?._id ? id._id : id;
                                                                            return {
                                                                                value: rawId,
                                                                                label: names[idx] || (typeof id === 'object' && id?.name ? id.name : "Staff")
                                                                            };
                                                                        })
                                                                        : [])
                                                                    : (m.employeeId
                                                                        ? [{ value: m.employeeId, label: m.employeeName || m.employee }]
                                                                        : []))
                                                                : (m.employeeId
                                                                    ? { value: m.employeeId, label: m.employeeName || m.employee }
                                                                    : null)
                                                        }
                                                        loadEmployees={loadEmployees}
                                                        styles={compactSelectStyles}
                                                        placeholder="Staff"
                                                        onChange={(employee) => {
                                                            handleEmployeeChange(m.rowId, employee);
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                            <td>1</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="table-price-input"
                                                    value={m.price ?? ""}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (/^\d*\.?\d*$/.test(val)) {
                                                            updateItemPrice(m.rowId, val);
                                                        }
                                                    }}
                                                />
                                            </td>
                                            <td>—</td>
                                            <td className="row-total">{Number(m.priceOfMembership || 0).toFixed(2)}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                <button className="table-remove-btn" onClick={() => removeItem(m.rowId)}>
                                                    <Icon icon="mdi:trash-can-outline" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </section>

                {/* ================= COLUMN 3: SUMMARY ================= */}
                <aside className="cart-panel">
                    <div className="cart-container" style={{ display: 'none' }}>
                        {/* Hidden Redundant Table */}
                    </div>
                    {!isMembershipBilling && (() => {
                        const summary = computeInvoiceSummary();
                        const {
                            totalGST,
                            cgst: totalCGST,
                            sgst: totalSGST,
                            finalAmount,
                            membershipDiscountAmount,
                            overallDiscountAmount,
                            couponDiscountAmount,
                            taxableAmount,
                            totalSubtotalInclusive,
                            totalProductPrice,
                            totalServicePrice,
                            totalProductAmount,
                            totalServiceAmount,
                            productTaxable,
                            serviceTaxable,
                        } = summary;

                        return (
                            <>
                                {/* ================= MEMBERSHIP ACTION BAR ================= */}
                                {activeMembership && formData.transactionType !== "SELF" && (
                                    <div className="membership-info-bar">
                                        <div>
                                            <strong>🎟 Membership:</strong>{" "}
                                            {activeMembership.subscriptionName}
                                            <span style={{ marginLeft: "8px", color: "#666" }}>
                                                (
                                                {activeMembership.subscriptionValueType === "PERCENTAGE"
                                                    ? `${activeMembership.subscriptionValue}% OFF`
                                                    : "SERVICE BASED"}
                                                {isMembershipApplied && ` : -${membershipDiscountAmount.toFixed(2)}`}
                                                )
                                            </span>
                                        </div>

                                        {!isMembershipApplied ? (
                                            <button
                                                className="add-Product-button"
                                                onClick={applyMembership}
                                            >
                                                Apply Membership
                                            </button>
                                        ) : (
                                            <button
                                                className="add-Product-button"
                                                onClick={removeMembership}
                                            >
                                                ❌ Remove Membership
                                            </button>
                                        )}
                                    </div>
                                )}

                                {/* ================= BILL SUMMARY ================= */}
                                <div className="bill-summary">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                                        <h3 style={{ margin: 0 }}>Bill Summary</h3>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            {approvedBackDate && loggedInRole !== "StoreAdmin" && (
                                                <button
                                                    onClick={handleCloseBackdateSession}
                                                    style={{
                                                        fontSize: '9px',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px',
                                                        background: '#ef4444',
                                                        color: '#fff',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                        fontWeight: 700
                                                    }}
                                                >
                                                    Close Back Date Bill
                                                </button>
                                            )}
                                            <div style={{ position: 'relative' }}>
                                                <input
                                                    type="date"
                                                    ref={dateInputRef2}
                                                    value={invoiceDate}
                                                    max={todayStr}
                                                    onChange={handleInvoiceDateChange}
                                                    style={{
                                                        position: 'absolute',
                                                        opacity: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        top: 0,
                                                        left: 0,
                                                        pointerEvents: 'none'
                                                    }}
                                                />
                                                <div
                                                    className="custom-date-pill"
                                                    onClick={() => dateInputRef2.current?.showPicker()}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '4px',
                                                        fontSize: '11px',
                                                        fontWeight: '800',
                                                        color: invoiceDate < todayStr ? '#b91c1c' : '#3C0008',
                                                        background: (approvedBackDate && invoiceDate < todayStr) ? 'rgba(185,28,28,0.1)' : 'rgba(60, 0, 8, 0.1)',
                                                        padding: '4px 8px',
                                                        borderRadius: '6px',
                                                        border: invoiceDate < todayStr ? '1px solid rgba(185,28,28,0.35)' : '1px solid rgba(60, 0, 8, 0.2)',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    <span>{invoiceDate ? invoiceDate.split('-').reverse().join('-') : 'Date'}</span>
                                                    <Icon icon="mdi:calendar-edit" style={{ fontSize: '14px' }} />
                                                </div>
                                            </div>

                                            {invoiceDate < todayStr && !approvedBackDate && loggedInRole !== "StoreAdmin" && (
                                                <span style={{
                                                    fontSize: '10px',
                                                    fontWeight: 700,
                                                    color: '#b91c1c',
                                                    background: 'rgba(185,28,28,0.1)',
                                                    padding: '2px 6px',
                                                    borderRadius: '4px',
                                                    border: '1px solid rgba(185,28,28,0.25)',
                                                    whiteSpace: 'nowrap'
                                                }}>⚠ Back-date</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="summary-stack">


                                        {/* APPLIED ITEMS LIST */}
                                        <div className="summary-columns" style={{ marginBottom: '16px' }}>
                                            <div className="summary-col">
                                                <div className="row">
                                                    <span>Total Product Price</span>
                                                    <span>{totalProductPrice.toFixed(2)}</span>
                                                </div>
                                                {formData.transactionType !== "SELF" && (
                                                    <div className="row">
                                                        <span>Total Service Price</span>
                                                        <div style={{ textAlign: "right" }}>
                                                            <span>{totalServicePrice.toFixed(2)}</span>
                                                            {isMembershipApplied && membershipDiscountAmount > 0 && (
                                                                <div style={{ fontSize: "11px", color: "#3C0008", fontWeight: 700 }}>
                                                                    Member Rate: {(totalServicePrice - membershipDiscountAmount).toFixed(2)}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="summary-col">
                                                {summary.serviceWalletCoveredAmount > 0 && (
                                                    <div className="row">
                                                        <span>Service Wallet (Covered)</span>
                                                        <span style={{ color: "#34d399", fontWeight: 700 }}>-{summary.serviceWalletCoveredAmount.toFixed(2)}</span>
                                                    </div>
                                                )}
                                                {isMembershipApplied && activeMembership && formData.transactionType !== "SELF" && (
                                                    <div className="row">
                                                        <span>Membership Savings</span>
                                                        <span style={{ color: "#34d399" }}>-{membershipDiscountAmount.toFixed(2)}</span>
                                                    </div>
                                                )}
                                                {summary.totalManualDiscount > 0 && (
                                                    <div className="row">
                                                        <span>Item Discounts</span>
                                                        <span style={{ color: "#34d399" }}>-{summary.totalManualDiscount.toFixed(2)}</span>
                                                    </div>
                                                )}
                                                {couponDiscountAmount > 0 && (
                                                    <div className="row">
                                                        <span>Coupon Discount</span>
                                                        <span style={{ color: "#34d399" }}>-{couponDiscountAmount.toFixed(2)}</span>
                                                    </div>
                                                )}
                                                {overallDiscountAmount > 0 && (
                                                    <div className="row">
                                                        <span>Overall Discount</span>
                                                        <span style={{ color: "#34d399" }}>-{overallDiscountAmount.toFixed(2)}</span>
                                                    </div>
                                                )}
                                                {Number(miscellaneousCharges) > 0 && (
                                                    <div className="row">
                                                        <span>Misc Charges</span>
                                                        <span style={{ color: "#fbbf24" }}>+{Number(miscellaneousCharges).toFixed(2)}</span>
                                                    </div>
                                                )}
                                                {currentStore?.gstData?.status === "VERIFIED" && (
                                                    <div className="row gst-row">
                                                        <span>GST (Inc/Exc)</span>
                                                        <div className="gst-toggle-group">
                                                            <button
                                                                type="button"
                                                                className={`gst-toggle-btn ${gstType === "Inclusive" ? "active" : ""}`}
                                                                onClick={() => setGstType("Inclusive")}
                                                            >
                                                                Inclusive
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className={`gst-toggle-btn ${gstType === "Exclusive" ? "active" : ""}`}
                                                                onClick={() => setGstType("Exclusive")}
                                                            >
                                                                Exclusive
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* TOP SECTION: Overall Discount & Coupons */}
                                        {formData.transactionType !== "SELF" && (
                                            <div className="discount-coupon-header-bar" style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '16px', background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
                                                <div className="summary-row" style={{ marginBottom: 0 }}>
                                                    <span style={{ fontSize: '12px', fontWeight: 800 }}>Overall Disc</span>
                                                    <div className="discount-control-group">
                                                        <button
                                                            type="button"
                                                            disabled={isAnyWalletApplied}
                                                            className={`discount-toggle-btn ${overallDiscountType === "PERCENTAGE" ? "active" : ""}`}
                                                            onClick={() => {
                                                                const newType = "PERCENTAGE";
                                                                setOverallDiscountType(newType);
                                                                const s = computeInvoiceSummary();
                                                                const afterMembership = Math.max(s.totalProductAmount + s.totalServiceAmount - s.membershipDiscountAmount, 0);
                                                                const maxFlat = Number(afterMembership.toFixed(2));
                                                                const currentVal = Number(overallDiscount || 0);
                                                                if (currentVal > 100) setOverallDiscount(100);
                                                            }}
                                                        >
                                                            %
                                                        </button>
                                                        <button
                                                            type="button"
                                                            disabled={isAnyWalletApplied}
                                                            className={`discount-toggle-btn ${overallDiscountType === "FLAT" ? "active" : ""}`}
                                                            onClick={() => {
                                                                const newType = "FLAT";
                                                                setOverallDiscountType(newType);
                                                                const s = computeInvoiceSummary();
                                                                const afterMembership = Math.max(s.totalProductAmount + s.totalServiceAmount - s.membershipDiscountAmount, 0);
                                                                const maxFlat = Number(afterMembership.toFixed(2));
                                                                const currentVal = Number(overallDiscount || 0);
                                                                if (currentVal > maxFlat) setOverallDiscount(maxFlat.toFixed(2));
                                                            }}
                                                        >
                                                            ₹
                                                        </button>
                                                        <input
                                                            type="text"
                                                            disabled={isAnyWalletApplied}
                                                            value={overallDiscount || ""}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                if (/^\d*\.?\d*$/.test(val)) {
                                                                    const numVal = Number(val);
                                                                    const s = computeInvoiceSummary();
                                                                    const subTotal = Math.max(s.totalProductAmount + s.totalServiceAmount - s.membershipDiscountAmount, 0);
                                                                    const maxFlat = Number(subTotal.toFixed(2));
                                                                    if (overallDiscountType === "PERCENTAGE" && numVal > 100) { setOverallDiscount(100); return; }
                                                                    if (overallDiscountType === "FLAT" && numVal > maxFlat) { setOverallDiscount(maxFlat); return; }
                                                                    setOverallDiscount(val);
                                                                }
                                                            }}
                                                            placeholder="0"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="summary-row" style={{ marginBottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <span style={{ fontSize: '12px', fontWeight: 800 }}>Misc Charges (₹)</span>
                                                    <input
                                                        type="text"
                                                        value={miscellaneousCharges || ""}
                                                        disabled={cart.filter(i => i.category === "service").length === 0}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (/^\d*\.?\d*$/.test(val)) {
                                                                setMiscellaneousCharges(val);
                                                                if (Number(val) === 0) setMiscReason("");
                                                            }
                                                        }}
                                                        placeholder="0"
                                                        style={{
                                                            width: '80px',
                                                            background: 'rgba(255,255,255,0.05)',
                                                            border: '1px solid rgba(255,255,255,0.1)',
                                                            borderRadius: '6px',
                                                            color: 'white',
                                                            padding: '6px 10px',
                                                            fontSize: '13px',
                                                            textAlign: 'right',
                                                            outline: 'none'
                                                        }}
                                                    />
                                                </div>

                                                {Number(miscellaneousCharges) > 0 && (
                                                    <div className="summary-row" style={{ marginBottom: 0, display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'stretch' }}>
                                                        <span style={{ fontSize: '11px', fontWeight: 600, color: '#94a3b8', textAlign: 'left' }}>Reason for Misc Charges *</span>
                                                        <input
                                                            type="text"
                                                            value={miscReason || ""}
                                                            onChange={(e) => setMiscReason(e.target.value)}
                                                            placeholder="Enter reason..."
                                                            style={{
                                                                background: 'rgba(255,255,255,0.05)',
                                                                border: '1px solid rgba(255,255,255,0.1)',
                                                                borderRadius: '6px',
                                                                color: 'white',
                                                                padding: '6px 10px',
                                                                fontSize: '12px',
                                                                outline: 'none'
                                                            }}
                                                        />
                                                    </div>
                                                )}

                                                <div className="coupon-section-wrapper" style={{ margin: 0, padding: 0, background: 'none', border: 'none' }}>
                                                    <div className="coupon-input-group">
                                                        <input
                                                            type="text"
                                                            disabled={isAnyWalletApplied}
                                                            value={couponInput}
                                                            onChange={(e) => setCouponInput(e.target.value)}
                                                            placeholder="Enter coupon"
                                                            className="coupon-input"
                                                        />
                                                        <button className="coupon-apply-btn" disabled={isAnyWalletApplied} onClick={applyCoupon}>APPLY</button>
                                                    </div>

                                                    {isAnyWalletApplied && (
                                                        <div style={{ color: '#ef4444', fontSize: '10px', marginTop: '8px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '4px', background: 'rgba(239,68,68,0.1)', padding: '6px', borderRadius: '6px' }}>
                                                            <Icon icon="solar:info-circle-bold-duotone" width="14" height="14" />
                                                            <span>Discounts disabled for wallet payments.</span>
                                                        </div>
                                                    )}

                                                    {availableCoupons.length > 0 && (
                                                        <div className="view-coupons-trigger" onClick={() => !isAnyWalletApplied && setShowCouponModal(true)} style={{ marginTop: '8px', height: '32px', fontSize: '11px', opacity: isAnyWalletApplied ? 0.5 : 1, cursor: isAnyWalletApplied ? 'not-allowed' : 'pointer' }}>
                                                            <Icon icon="mdi:ticket-percent-outline" />
                                                            <span>View Available Coupons ({availableCoupons.length})</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {appliedCoupons.length > 0 && (
                                            <div className="applied-coupons-container" style={{ marginBottom: '16px' }}>
                                                {appliedCoupons.map((c, idx) => (
                                                    <div key={idx} className="summary-row" style={{ background: 'rgba(52,211,153,0.1)', padding: '8px 12px', borderRadius: '8px', border: '1px solid rgba(52,211,153,0.2)', marginBottom: '8px' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <span style={{ fontSize: "13px", fontWeight: 700 }}>🎟 {c.code}</span>
                                                        </div>
                                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                            <span style={{ color: "#34d399", fontWeight: 800 }}>-{Number(c.discountAmount).toFixed(2)}</span>
                                                            <button className="delete-btn" onClick={() => setAppliedCoupons(prev => prev.filter(x => x.code !== c.code))}>&times;</button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    {currentStore?.gstData?.status === "VERIFIED" && (
                                        <div className="tax-breakdown-container">
                                            <div className="tax-column">
                                                <div className="tax-section">
                                                    <div className="tax-header">Product Section</div>
                                                    {summary.productTaxGroups.map((group, idx) => (
                                                        <div key={idx} className="tax-subgroup" style={{ marginBottom: "12px" }}>
                                                            <div style={{ fontSize: "11px", fontWeight: 700, color: "#3C0008", marginBottom: "4px" }}>
                                                                GST @ {group.rate}%
                                                            </div>
                                                            <div className="row">
                                                                <span>Taxable</span>
                                                                <span>{group.taxable.toFixed(2)}</span>
                                                            </div>
                                                            <div className="row">
                                                                <span>CGST ({group.rate / 2}%)</span>
                                                                <span>{group.cgst.toFixed(2)}</span>
                                                            </div>
                                                            <div className="row">
                                                                <span>SGST ({group.rate / 2}%)</span>
                                                                <span>{group.sgst.toFixed(2)}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <div className="row" style={{ borderTop: "1px dashed rgba(255,255,255,0.1)", paddingTop: "4px", marginTop: "4px" }}>
                                                        <span>Total Product Amount</span>
                                                        <span>{summary.totalProductAmount.toFixed(2)}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {formData.transactionType !== "SELF" && (
                                                <div className="tax-column">
                                                    <div className="tax-section">
                                                        <div className="tax-header">Service Section</div>
                                                        {summary.serviceTaxGroups.map((group, idx) => (
                                                            <div key={idx} className="tax-subgroup" style={{ marginBottom: "12px" }}>
                                                                <div style={{ fontSize: "11px", fontWeight: 700, color: "#3C0008", marginBottom: "4px" }}>
                                                                    GST @ {group.rate}%
                                                                </div>
                                                                <div className="row">
                                                                    <span>Taxable</span>
                                                                    <span>{group.taxable.toFixed(2)}</span>
                                                                </div>
                                                                <div className="row">
                                                                    <span>CGST ({group.rate / 2}%)</span>
                                                                    <span>{group.cgst.toFixed(2)}</span>
                                                                </div>
                                                                <div className="row">
                                                                    <span>SGST ({group.rate / 2}%)</span>
                                                                    <span>{group.sgst.toFixed(2)}</span>
                                                                </div>
                                                            </div>
                                                        ))}
                                                        <div className="row" style={{ borderTop: "1px dashed rgba(255,255,255,0.1)", paddingTop: "4px", marginTop: "4px" }}>
                                                            <span>Total Service Amount</span>
                                                            <span>{summary.totalServiceAmount.toFixed(2)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    <div className="row total">
                                        <span>Final Amount</span>
                                        <span>{finalAmount.toFixed(2)}</span>
                                    </div>

                                    <div className="payment-actions-container" style={{ marginTop: '12px' }}>
                                        {formData.transactionType === "SELF" ? (
                                            <button
                                                className="btn"
                                                style={{
                                                    width: '100%',
                                                    background: 'linear-gradient(135deg, #3C0008 0%, #a52a2a 100%)',
                                                    padding: '12px',
                                                    fontWeight: 800,
                                                    boxShadow: '0 10px 15px -3px rgba(60, 0, 8, 0.3)'
                                                }}
                                                onClick={handleSaveInvoice}
                                            >
                                                Generate Invoice ({finalAmount.toFixed(2)})
                                            </button>
                                        ) : (
                                            <button
                                                className="btn"
                                                style={{
                                                    width: '100%',
                                                    background: 'linear-gradient(135deg, #3C0008 0%, #a52a2a 100%)',
                                                    padding: '12px',
                                                    fontWeight: 800,
                                                    boxShadow: '0 10px 15px -3px rgba(60, 0, 8, 0.3)'
                                                }}
                                                onClick={handleProceedPayment}
                                            >
                                                Proceed to Pay ({finalAmount.toFixed(2)})
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </>
                        );
                    })()}




                    {isMembershipBilling && (() => {
                        const summary = computeInvoiceSummary();
                        const {
                            totalGST: membershipGST,
                            taxableAmount: membershipTaxable,
                            finalAmount: membershipTotal
                        } = summary;

                        return (
                            <div className="bill-summary">
                                <h3>Membership Summary</h3>

                                <div className="row">
                                    <span>Total Amount</span>
                                    <span>{membershipTotal.toFixed(2)}</span>
                                </div>

                                {currentStore?.gstData?.status === "VERIFIED" && (
                                    <div className="row">
                                        <span>GST Type (Inclusive/Exclusive)</span>
                                        <div className="gst-toggle-group">
                                            <button
                                                type="button"
                                                className={`gst-toggle-btn ${gstType === "Inclusive" ? "active" : ""}`}
                                                onClick={() => setGstType("Inclusive")}
                                            >
                                                Inclusive
                                            </button>
                                            <button
                                                type="button"
                                                className={`gst-toggle-btn ${gstType === "Exclusive" ? "active" : ""}`}
                                                onClick={() => setGstType("Exclusive")}
                                            >
                                                Exclusive
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {currentStore?.gstData?.status === "VERIFIED" && (
                                    <div className="tax-breakdown">
                                        <div className="row">
                                            <span>Taxable Amount</span>
                                            <span>{membershipTaxable.toFixed(2)}</span>
                                        </div>
                                        <div className="row">
                                            <span>CGST {gstType === "Inclusive" ? "(Included)" : "(Added)"}</span>
                                            <span>{(membershipGST / 2).toFixed(2)}</span>
                                        </div>

                                        <div className="row">
                                            <span>SGST {gstType === "Inclusive" ? "(Included)" : "(Added)"}</span>
                                            <span>{(membershipGST / 2).toFixed(2)}</span>
                                        </div>
                                    </div>
                                )}

                                <div className="row total">
                                    <span>Final Amount</span>
                                    <span>{membershipTotal.toFixed(2)}</span>
                                </div>

                                <div className="payment-actions-container" style={{ marginTop: '12px' }}>
                                    <button
                                        className="btn"
                                        style={{ width: '100%', background: 'linear-gradient(135deg, #3C0008 0%, #a52a2a 100%)', padding: '12px', fontWeight: 800 }}
                                        onClick={handleProceedPayment}
                                    >
                                        Proceed to Pay ({membershipTotal.toFixed(2)})
                                    </button>
                                </div>
                            </div>
                        );
                    })()}

                </aside >
            </div >

            <Modal open={isAddCustomer} onClose={() => setIsAddCustomer(false)}>
                <Box sx={{ ...modalStyle, width: { xs: '95%', sm: 800 }, maxHeight: "90vh", overflowY: "auto", p: { xs: 2, sm: 4 } }}>
                    <AddCustomerForm
                        initialStoreId={selectedStoreId}
                        initialPhoneNumber={addCustomerPhone}
                        onSuccess={async (newCus) => {
                            setIsAddCustomer(false);
                            setCustomerRefreshKey(prev => prev + 1);

                            if (newCus) {
                                let newCusData = Array.isArray(newCus) ? newCus[0] : newCus;
                                try {
                                    const token = localStorage.getItem("Token");
                                    const cusId = newCusData._id || newCusData.id;
                                    if (cusId) {
                                        const res = await getData(`customers/customer/${cusId}`, {}, token);
                                        if (res?.data) {
                                            newCusData = Array.isArray(res.data) ? res.data[0] : res.data;
                                        }
                                    }
                                } catch (err) {
                                    console.error("Failed to fetch full newly created customer", err);
                                }

                                const option = {
                                    value: newCusData._id || newCusData.id,
                                    label: `${newCusData.name} (${newCusData.phoneNumber || ""})`,
                                    phone: newCusData.phoneNumber,
                                    email: newCusData.email,
                                    subscriptionDetails: newCusData.subscriptionDetails || [],
                                    data: newCusData
                                };

                                resetCartState();
                                setSelectedCustomerOption(option);
                                setCustomerSearch(`${option.label}`);
                                setFormData((prev) => ({
                                    ...prev,
                                    customerId: option.value,
                                    customerName: newCusData.name || "",
                                    customerPhone: newCusData.phoneNumber || "",
                                }));
                            }
                        }}
                        onCancel={() => setIsAddCustomer(false)}
                    />
                </Box>
            </Modal>

            {/* ✅ Customer Details Popup */}
            {
                selectedCustomerOption && (
                    <CustomerDetailsPopup
                        open={showCustomerPopup}
                        onClose={() => setShowCustomerPopup(false)}
                        customer={selectedCustomerOption.data || selectedCustomerOption}
                    />
                )
            }

            {/* ✅ Change/Balance Modal */}
            <Modal open={showChangeModal} onClose={() => setShowChangeModal(false)}>
                <Box sx={{ ...modalStyle, textAlign: 'center' }}>
                    <div style={{ padding: '20px' }}>
                        <Icon icon="mdi:cash-multiple" width={60} height={60} style={{ color: '#3C0008', marginBottom: '16px' }} />
                        <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1a1e27', marginBottom: '8px' }}>Change to Return</h2>
                        <div style={{
                            fontSize: '48px',
                            fontWeight: 'bold',
                            color: '#3C0008',
                            background: '#f9f1f2',
                            padding: '20px',
                            borderRadius: '16px',
                            marginBottom: '24px'
                        }}>
                            {changeToReturn.toFixed(2)}
                        </div>
                        <button
                            className="btn"
                            style={{ width: '100%', background: '#3C0008', color: 'white' }}
                            onClick={() => {
                                setShowChangeModal(false);
                                window.location.reload();
                            }}
                        >
                            Got it
                        </button>
                    </div>
                </Box>
            </Modal>

            {/* 💰 ACTIVE CUSTOMER WALLETS POPUP MODAL */}
            <Modal open={showActiveWalletsModal} onClose={() => setShowActiveWalletsModal(false)}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: 480 },
                    bgcolor: 'background.paper',
                    borderRadius: 3,
                    boxShadow: 24,
                    p: 3
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 700, fontSize: '16px', color: '#16a34a' }}>
                            <Icon icon="solar:wallet-money-bold-duotone" width="22" height="22" />
                            <span>Customer Active Wallets</span>
                        </div>
                        <IconButton size="small" onClick={() => setShowActiveWalletsModal(false)}>
                            <Icon icon="mdi:close" width="20" height="20" />
                        </IconButton>
                    </div>

                    <Typography variant="body2" sx={{ color: '#64748b', mb: 2 }}>
                        Customer: <strong>{selectedCustomerOption?.label || selectedCustomerOption?.data?.name || 'Customer'}</strong>
                    </Typography>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', maxHeight: '65vh', overflowY: 'auto' }}>
                        {/* SERVICE WALLETS */}
                        {(customerWallets || []).filter(w => w.type === 'Service' && w.status === 'ACTIVE' && w.isActive !== false).length > 0 && (
                            <div>
                                <div style={{ fontSize: '13px', fontWeight: 700, color: '#3730a3', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <Icon icon="solar:ticket-bold-duotone" width="16" />
                                    <span>Service Wallets</span>
                                </div>
                                {(customerWallets || []).filter(w => w.type === 'Service' && w.status === 'ACTIVE' && w.isActive !== false).map(w => {
                                    const svcName = w.serviceId?.serviceName || w.customWalletName || w.walletPackageId?.name || 'Service Wallet';
                                    const expiryDate = w.expiryDate ? new Date(w.expiryDate).toLocaleDateString('en-GB') : 'N/A';
                                    const isAppliedToCart = cart.some(c => c.isServiceWalletApplied && c.customerWalletId === w._id);

                                    return (
                                        <div key={w._id} style={{
                                            background: '#f0fdf4',
                                            border: '1px solid #bbf7d0',
                                            borderRadius: '10px',
                                            padding: '12px',
                                            marginBottom: '8px'
                                        }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div style={{ fontWeight: 700, fontSize: '13px', color: '#14532d' }}>
                                                    🏷️ {svcName}
                                                </div>
                                                <span style={{ background: '#dcfce7', color: '#15803d', padding: '2px 8px', borderRadius: '4px', fontSize: '10px', fontWeight: 800 }}>
                                                    ACTIVE
                                                </span>
                                            </div>
                                            {w.services && w.services.length > 0 ? (
                                                <div style={{ marginTop: '8px', fontSize: '12px' }}>
                                                    {w.services.map((s, idx) => (
                                                        <div key={s._id || idx} style={{ background: '#ffffff', padding: '8px', borderRadius: '6px', border: '1px solid #bbf7d0', marginBottom: '6px' }}>
                                                            <div style={{ fontWeight: 700, color: '#14532d', fontSize: '12.5px', marginBottom: '4px' }}>
                                                                • {s.serviceId?.serviceName || 'Service'}
                                                            </div>
                                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px', fontSize: '11px', color: '#166534' }}>
                                                                <div>Base Usage: <strong>{s.baseCount || s.totalCount || 0}</strong></div>
                                                                <div>Additional: <strong>{s.additionalCount || 0}</strong></div>
                                                                <div>Total Available: <strong>{s.totalCount || 0}</strong></div>
                                                                <div>Used: <strong>{s.usedCount || 0}</strong></div>
                                                                <div style={{ gridColumn: 'span 2', color: (s.remainingCount || 0) > 0 ? '#15803d' : '#ef4444', fontWeight: 700, fontSize: '12px', marginTop: '2px' }}>
                                                                    Remaining: {s.remainingCount || 0} / {s.totalCount || 0}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px', fontSize: '12px', color: '#166534', marginTop: '8px' }}>
                                                    <div>Remaining: <strong style={{ color: '#15803d', fontSize: '13px' }}>{w.remainingCount} / {w.totalCount} Usages</strong></div>
                                                    <div>Valid Until: <strong>{expiryDate}</strong></div>
                                                </div>
                                            )}

                                            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'flex-end' }}>
                                                <Button
                                                    size="small"
                                                    variant={isAppliedToCart ? "outlined" : "contained"}
                                                    color={isAppliedToCart ? "error" : "success"}
                                                    onClick={() => {
                                                        applyServiceWalletToCart(w);
                                                        setShowActiveWalletsModal(false);
                                                    }}
                                                    sx={{
                                                        fontSize: '11px',
                                                        fontWeight: 700,
                                                        borderRadius: '6px',
                                                        textTransform: 'none'
                                                    }}
                                                >
                                                    {isAppliedToCart ? "✓ Wallet Applied (Click to Remove)" : "Apply Wallet to Cart"}
                                                </Button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* CASH WALLETS */}
                        {(customerWallets || []).filter(w => w.type === 'Cash' && w.status === 'ACTIVE' && w.isActive !== false).length > 0 && (
                            <div>
                                <div style={{ fontSize: '13px', fontWeight: 700, color: '#854d0e', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px', marginTop: '4px' }}>
                                    <Icon icon="solar:wallet-money-bold-duotone" width="16" />
                                    <span>Cash / Price Wallets</span>
                                </div>
                                {(customerWallets || []).filter(w => w.type === 'Cash' && w.status === 'ACTIVE' && w.isActive !== false).map(w => {
                                    const walletName = w.customWalletName || w.walletPackageId?.name || 'Cash Wallet';
                                    const expiryDate = w.expiryDate ? new Date(w.expiryDate).toLocaleDateString('en-GB') : 'N/A';
                                    const usedAmount = Math.max(0, (w.totalCredited || 0) - (w.balance || 0));

                                    return (
                                        <div key={w._id} style={{
                                            background: '#fefce8',
                                            border: '1px solid #fef08a',
                                            borderRadius: '10px',
                                            padding: '12px',
                                            marginBottom: '8px'
                                        }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div style={{ fontWeight: 700, fontSize: '13px', color: '#713f12' }}>
                                                    💳 {walletName}
                                                </div>
                                                <span style={{ background: '#fef08a', color: '#854d0e', padding: '2px 8px', borderRadius: '4px', fontSize: '10px', fontWeight: 800 }}>
                                                    ACTIVE
                                                </span>
                                            </div>
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px', fontSize: '12px', color: '#854d0e', marginTop: '8px' }}>
                                                <div>Available Balance: <strong style={{ color: '#16a34a', fontSize: '14px' }}>₹{Number(w.balance || 0).toFixed(2)}</strong></div>
                                                <div>Total Credited: <strong>₹{Number(w.totalCredited || 0).toFixed(2)}</strong></div>
                                                <div>Used Amount: <strong>₹{Number(usedAmount).toFixed(2)}</strong></div>
                                                <div>Valid Until: <strong>{expiryDate}</strong></div>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                                                <Button
                                                    size="small"
                                                    variant="contained"
                                                    startIcon={<Icon icon="solar:wallet-money-bold-duotone" width="16" />}
                                                    onClick={() => {
                                                        setShowActiveWalletsModal(false);
                                                        fetchAvailableServicesForWallet();
                                                        fetchAvailableWalletPackages();
                                                        setWalletModalTab("Cash");
                                                        setCashWalletSubTab("Recharge");
                                                        setCashWalletForm(prev => ({
                                                            ...prev,
                                                            selectedWalletForRecharge: w._id,
                                                            customerPays: '',
                                                            creditedAmount: ''
                                                        }));
                                                        setShowBuyWalletModal(true);
                                                    }}
                                                    sx={{
                                                        background: '#3C0008',
                                                        color: '#fff',
                                                        fontWeight: 700,
                                                        fontSize: '11px',
                                                        textTransform: 'none',
                                                        padding: '4px 10px',
                                                        borderRadius: '6px',
                                                        '&:hover': { background: '#5c000c' }
                                                    }}
                                                >
                                                    + Recharge Wallet
                                                </Button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </Box>
            </Modal>

            {/* 📜 POS CUSTOMER WALLET HISTORY MODAL */}
            <Modal open={showWalletHistoryModal} onClose={() => setShowWalletHistoryModal(false)}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '95%', sm: 1188 },
                    maxHeight: '90vh',
                    bgcolor: 'background.paper',
                    borderRadius: 3,
                    boxShadow: 24,
                    p: 0,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <div style={{ padding: '16px 20px', background: '#3C0008', color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 700, fontSize: '16px' }}>
                            <Icon icon="solar:history-bold-duotone" width="22" height="22" />
                            <span>Customer Wallet History</span>
                        </div>
                        <IconButton size="small" onClick={() => setShowWalletHistoryModal(false)} sx={{ color: '#fff' }}>
                            <Icon icon="mdi:close" width="20" height="20" />
                        </IconButton>
                    </div>

                    <div style={{ padding: '14px 20px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                            <div style={{ fontSize: '14px', fontWeight: 700, color: '#0f172a' }}>
                                Customer: <strong>{selectedCustomerOption?.label || selectedCustomerOption?.data?.name || 'Selected Customer'}</strong>
                            </div>
                            <div style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>
                                Phone: {selectedCustomerOption?.data?.phoneNumber || formData.customerPhone || 'N/A'}
                            </div>
                        </div>
                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={<Icon icon="mdi:refresh" />}
                            onClick={() => {
                                const custId = selectedCustomerOption?.value || selectedCustomerOption?._id;
                                if (custId) fetchCustomerWalletHistory(custId);
                            }}
                            sx={{ textTransform: 'none', fontSize: '12px', fontWeight: 600 }}
                        >
                            Refresh History
                        </Button>
                    </div>

                    <div style={{ padding: '16px 20px', overflowY: 'auto', flex: 1 }}>
                        {walletHistoryLoading ? (
                            <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
                                ⏳ Loading wallet transaction history...
                            </div>
                        ) : customerWalletHistory.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '40px', color: '#64748b', background: '#f8fafc', borderRadius: '12px', border: '1px dashed #cbd5e1' }}>
                                <Icon icon="solar:file-remove-bold-duotone" width="40" height="40" style={{ color: '#94a3b8', marginBottom: '8px' }} />
                                <div style={{ fontWeight: 600, fontSize: '14px', color: '#334155' }}>No Wallet Transactions Found</div>
                                <div style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>
                                    This customer does not have any wallet purchases, recharges, or usage transactions yet.
                                </div>
                            </div>
                        ) : (
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{ background: '#f1f5f9', color: '#334155', textAlign: 'left' }}>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #cbd5e1' }}>Date & Time</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #cbd5e1' }}>Type</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #cbd5e1' }}>Action</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #cbd5e1' }}>Wallet / Service</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #cbd5e1' }}>Purchase Amount</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #cbd5e1' }}>Prev Balance</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #cbd5e1' }}>Usage / Amount</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #cbd5e1' }}>New Balance</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #cbd5e1' }}>Staff / User</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #cbd5e1' }}>Bill Ref</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #cbd5e1' }}>Payment</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #cbd5e1' }}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {customerWalletHistory
                                            .filter(item => {
                                                if (!selectedCustomerOption) return true;
                                                const currentCustId = String(selectedCustomerOption.value || selectedCustomerOption._id || selectedCustomerOption.data?._id || '');
                                                const itemCustId = String(item.customerId?._id || item.customerId?.id || (typeof item.customerId === 'string' ? item.customerId : '') || '');
                                                return !currentCustId || !itemCustId || itemCustId === currentCustId;
                                            })
                                            .map((item, idx) => {
                                                const isPurchase = item.transactionType === 'Purchase';
                                                const isRecharge = item.transactionType === 'Recharge';
                                                const purchaseAmtVal = (isPurchase || isRecharge)
                                                    ? Number(item.amountPaid ?? item.totalAmount ?? item.price ?? item.walletId?.amountPaid ?? item.walletId?.walletPackageId?.price ?? 0)
                                                    : 0;

                                                return (
                                                    <tr key={item._id || idx} style={{ borderBottom: '1px solid #f1f5f9', background: idx % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                                                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', color: '#475569' }}>
                                                            {item.transactionDate ? new Date(item.transactionDate).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-'}
                                                        </td>
                                                        <td style={{ padding: '10px 12px' }}>
                                                            <span style={{
                                                                padding: '2px 8px',
                                                                borderRadius: '4px',
                                                                fontSize: '10px',
                                                                fontWeight: 800,
                                                                background: item.walletType === 'Service' ? '#e0e7ff' : '#fef3c7',
                                                                color: item.walletType === 'Service' ? '#3730a3' : '#92400e'
                                                            }}>
                                                                {item.walletType || 'Wallet'}
                                                            </span>
                                                        </td>
                                                        <td style={{ padding: '10px 12px', fontWeight: 600, color: isPurchase || isRecharge ? '#16a34a' : '#dc2626' }}>
                                                            {item.transactionType}
                                                        </td>
                                                        <td style={{ padding: '10px 12px', fontWeight: 600, color: '#1e293b' }}>
                                                            {item.walletName || item.walletId?.customWalletName || item.walletId?.serviceId?.serviceName || 'Wallet Plan'}
                                                        </td>
                                                        <td style={{ padding: '10px 12px', color: '#0f172a' }}>
                                                            {purchaseAmtVal > 0 ? (() => {
                                                                const isGst = Boolean(item.isGstApplicable || item.walletId?.isGstApplicable);
                                                                const gstRate = Number(item.gstPercentage ?? item.walletId?.gstPercentage ?? 0);
                                                                const gstType = item.gstType || item.walletId?.gstType || 'Exclusive';

                                                                let gstAmt = Number(item.gstAmount ?? item.walletId?.gstAmount ?? 0);
                                                                let basePay = Number(item.customerBasePay ?? item.walletId?.customerBasePay ?? 0);

                                                                if (isGst && gstRate > 0) {
                                                                    if (gstType === 'Exclusive') {
                                                                        if (!basePay && gstAmt) basePay = purchaseAmtVal - gstAmt;
                                                                        if (!basePay) basePay = purchaseAmtVal / (1 + gstRate / 100);
                                                                        if (!gstAmt) gstAmt = purchaseAmtVal - basePay;
                                                                    } else { // Inclusive
                                                                        if (!gstAmt) gstAmt = purchaseAmtVal - (purchaseAmtVal / (1 + gstRate / 100));
                                                                        if (!basePay) basePay = purchaseAmtVal - gstAmt;
                                                                    }
                                                                } else {
                                                                    basePay = purchaseAmtVal;
                                                                    gstAmt = 0;
                                                                }

                                                                return (
                                                                    <div>
                                                                        <div style={{ fontWeight: 700, fontSize: '12.5px' }}>Paid: ₹{purchaseAmtVal.toFixed(2)}</div>
                                                                        {isGst && gstRate > 0 ? (
                                                                            <div style={{ fontSize: '10.5px', color: '#475569', marginTop: '2px', lineHeight: '1.3' }}>
                                                                                <div>Base: <strong>₹{basePay.toFixed(2)}</strong></div>
                                                                                <div>GST ({gstType} {gstRate}%): <strong>₹{gstAmt.toFixed(2)}</strong></div>
                                                                            </div>
                                                                        ) : (
                                                                            <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '1px' }}>GST: N/A</div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })() : '-'}
                                                        </td>
                                                        <td style={{ padding: '10px 12px', fontWeight: 600, color: '#64748b' }}>
                                                            {item.walletType === 'Cash' ? `₹${Number(item.previousWalletBalance || 0).toFixed(2)}` : '-'}
                                                        </td>
                                                        <td style={{ padding: '10px 12px', fontWeight: 700 }}>
                                                            {item.walletType === 'Service' ? (
                                                                <span style={{ color: isPurchase ? '#16a34a' : '#dc2626' }}>
                                                                    {isPurchase ? `+${item.serviceUsageCount || item.remainingServiceCount || 0} Usages` : `-${item.serviceUsageCount || 1} Usage${(item.serviceUsageCount || 1) > 1 ? 's' : ''}`}
                                                                </span>
                                                            ) : (
                                                                <span style={{ color: isPurchase || isRecharge ? '#16a34a' : '#dc2626' }}>
                                                                    {isPurchase || isRecharge ? `+₹${item.walletCredit || item.totalAmount || 0}` : `-₹${item.walletAmountUsed || 0}`}
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td style={{ padding: '10px 12px', fontWeight: 700, color: '#0f172a' }}>
                                                            {item.walletType === 'Service' ? (
                                                                <span style={{ color: '#16a34a' }}>{item.remainingServiceCount} Usages</span>
                                                            ) : (
                                                                <span style={{ color: '#16a34a' }}>₹{Number(item.remainingWalletBalance || 0).toFixed(2)}</span>
                                                            )}
                                                        </td>
                                                        <td style={{ padding: '10px 12px', color: '#475569', fontWeight: 600 }}>
                                                            {item.createdBy?.name || item.createdBy?.email || '-'}
                                                        </td>
                                                        <td style={{ padding: '10px 12px', color: '#64748b' }}>
                                                            {item.posBillNumber || '-'}
                                                        </td>
                                                        <td style={{ padding: '10px 12px', color: '#475569' }}>
                                                            {item.paymentMethod || 'Wallet'}
                                                        </td>
                                                        <td style={{ padding: '10px 12px' }}>
                                                            <span style={{
                                                                padding: '2px 6px',
                                                                borderRadius: '4px',
                                                                fontSize: '10px',
                                                                fontWeight: 800,
                                                                background: '#dcfce7',
                                                                color: '#15803d'
                                                            }}>
                                                                {item.status || 'SUCCESS'}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </Box>
            </Modal>

            {/* ✅ POS BUY / CREATE WALLET DIRECT MODAL */}
            <Modal open={showBuyWalletModal} onClose={() => setShowBuyWalletModal(false)}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '92%', sm: 540 },
                    bgcolor: 'background.paper',
                    borderRadius: 3,
                    boxShadow: 24,
                    p: 3,
                    maxHeight: '92vh',
                    overflowY: 'auto'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#3C0008' }}>
                            Customer Wallet
                        </Typography>
                        <IconButton size="small" onClick={() => setShowBuyWalletModal(false)}>
                            <Icon icon="mdi:close" width="20" height="20" />
                        </IconButton>
                    </div>

                    <Typography variant="body2" sx={{ color: '#64748b', mb: 2 }}>
                        Customer: <strong>{selectedCustomerOption?.label || 'Selected Customer'}</strong>
                    </Typography>

                    {(() => {
                        const hasActiveCash = (customerWallets || []).some(w => w.type === 'Cash' && w.status === 'ACTIVE' && w.isActive !== false);
                        const hasActiveService = (customerWallets || []).some(w => w.type === 'Service' && w.status === 'ACTIVE' && w.isActive !== false);

                        const activeTabToRender = walletModalTab;

                        return (
                            <>
                                {/* WALLET TYPE TABS (Always visible) */}
                                {true && (
                                    <div style={{ display: 'flex', background: '#f1f5f9', padding: '4px', borderRadius: '10px', marginBottom: '16px' }}>
                                        <button
                                            type="button"
                                            onClick={() => setWalletModalTab("Service")}
                                            style={{
                                                flex: 1,
                                                padding: '8px 12px',
                                                border: 'none',
                                                borderRadius: '8px',
                                                fontSize: '13px',
                                                fontWeight: 700,
                                                cursor: 'pointer',
                                                background: activeTabToRender === "Service" ? "#3C0008" : "transparent",
                                                color: activeTabToRender === "Service" ? "#fff" : "#64748b",
                                                transition: 'all 0.2s'
                                            }}
                                        >
                                            🏷️ Service Wallet
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => setWalletModalTab("Cash")}
                                            style={{
                                                flex: 1,
                                                padding: '8px 12px',
                                                border: 'none',
                                                borderRadius: '8px',
                                                fontSize: '13px',
                                                fontWeight: 700,
                                                cursor: 'pointer',
                                                background: activeTabToRender === "Cash" ? "#3C0008" : "transparent",
                                                color: activeTabToRender === "Cash" ? "#fff" : "#64748b",
                                                transition: 'all 0.2s'
                                            }}
                                        >
                                            💰 Cash / Price Wallet
                                        </button>
                                    </div>
                                )}

                                {/* SERVICE WALLET TAB FORM */}
                                {activeTabToRender === "Service" && (
                                    <div>
                                        {(() => {
                                            const activeSvcW = (customerWallets || []).find(w => w.type === 'Service' && w.status === 'ACTIVE' && w.isActive !== false);
                                            return (
                                                <>
                                                    {activeSvcW ? (
                                                        <div style={{ background: '#e0e7ff', border: '1px solid #c7d2fe', borderRadius: '10px', padding: '12px', marginBottom: '16px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 700, color: '#3730a3', fontSize: '13px' }}>
                                                                <span>🏷️ Active Service Wallet Found</span>
                                                            </div>
                                                            <div style={{ fontSize: '12px', color: '#4338ca', marginTop: '4px' }}>
                                                                This customer already has an active Service Wallet. A new Service Wallet cannot be created until the existing one is fully used or expires.
                                                            </div>
                                                            <div style={{ marginTop: '8px', padding: '8px 12px', background: '#ffffff', borderRadius: '6px', border: '1px solid #a5b4fc', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                    <span style={{ fontSize: '12px', color: '#3730a3', fontWeight: 600 }}>Wallet Name:</span>
                                                                    <strong style={{ fontSize: '13px', color: '#312e81' }}>{activeSvcW.customWalletName || activeSvcW.walletPackageId?.name || 'Service Wallet'}</strong>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                    <span style={{ fontSize: '12px', color: '#3730a3', fontWeight: 600 }}>Remaining Usages:</span>
                                                                    <strong style={{ fontSize: '13px', color: '#16a34a' }}>{activeSvcW.remainingCount} Usages</strong>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                    <span style={{ fontSize: '12px', color: '#3730a3', fontWeight: 600 }}>Expiry Date:</span>
                                                                    <strong style={{ fontSize: '12px', color: '#ef4444' }}>{activeSvcW.expiryDate ? new Date(activeSvcW.expiryDate).toLocaleDateString('en-GB') : '-'}</strong>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <div style={{ marginBottom: '14px' }}>
                                                                <label style={{ fontSize: '12px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>Wallet Name *</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control-pos"
                                                                    style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                                                                    value={serviceWalletForm.name}
                                                                    onChange={(e) => setServiceWalletForm(prev => ({ ...prev, name: e.target.value }))}
                                                                    placeholder="e.g. Service Wallet Package"
                                                                />
                                                            </div>

                                                            <div style={{ marginBottom: '14px', background: '#f8fafc', padding: '12px', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                                                    <label style={{ fontSize: '12.5px', fontWeight: 700, color: '#0f172a' }}>
                                                                        Included Services & Usages *
                                                                    </label>
                                                                    <Button
                                                                        size="small"
                                                                        startIcon={<Icon icon="mdi:plus" />}
                                                                        onClick={handleAddPosServiceRow}
                                                                        sx={{ textTransform: 'none', fontWeight: 700, color: '#3C0008', fontSize: '12px' }}
                                                                    >
                                                                        Add Service
                                                                    </Button>
                                                                </div>

                                                                {(serviceWalletForm.services || []).map((row, idx) => (
                                                                    <div key={idx} style={{ background: '#ffffff', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', marginBottom: '10px' }}>
                                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                                                                            <span style={{ fontWeight: 700, fontSize: '12px', color: '#1e293b' }}>Service #{idx + 1}</span>
                                                                            {(serviceWalletForm.services || []).length > 1 && (
                                                                                <IconButton size="small" onClick={() => handleRemovePosServiceRow(idx)} sx={{ color: '#ef4444' }}>
                                                                                    <Icon icon="mdi:trash-can-outline" width="16" />
                                                                                </IconButton>
                                                                            )}
                                                                        </div>

                                                                        <div style={{ marginBottom: '8px' }}>
                                                                            <FormControl fullWidth size="small">
                                                                                <MuiSelect
                                                                                    value={row.serviceId}
                                                                                    onChange={(e) => handlePosServiceRowChange(idx, 'serviceId', e.target.value)}
                                                                                    displayEmpty
                                                                                    sx={{ borderRadius: '6px', fontSize: '12px', background: '#fff' }}
                                                                                >
                                                                                    <MenuItem value="" disabled>-- Select Service --</MenuItem>
                                                                                    {availableServicesForWallet.map(svc => {
                                                                                        const pVal = Number(svc?.nonMemberShipPrice ?? svc?.servicePrice ?? svc?.price ?? svc?.amount ?? 0);
                                                                                        return (
                                                                                            <MenuItem key={svc._id} value={svc._id}>
                                                                                                {svc.serviceName} - ₹{pVal}
                                                                                            </MenuItem>
                                                                                        );
                                                                                    })}
                                                                                </MuiSelect>
                                                                            </FormControl>
                                                                        </div>

                                                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '6px' }}>
                                                                            <div>
                                                                                <label style={{ fontSize: '10.5px', fontWeight: 600, color: '#475569', display: 'block', marginBottom: '2px' }}>Base Usage</label>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control-pos"
                                                                                    style={{ width: '100%', padding: '5px 8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px' }}
                                                                                    value={row.baseCount}
                                                                                    onChange={(e) => handlePosServiceRowChange(idx, 'baseCount', e.target.value)}
                                                                                    placeholder="10"
                                                                                />
                                                                            </div>
                                                                            <div>
                                                                                <label style={{ fontSize: '10.5px', fontWeight: 600, color: '#475569', display: 'block', marginBottom: '2px' }}>Additional</label>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control-pos"
                                                                                    style={{ width: '100%', padding: '5px 8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px' }}
                                                                                    value={row.additionalCount}
                                                                                    onChange={(e) => handlePosServiceRowChange(idx, 'additionalCount', e.target.value)}
                                                                                    placeholder="0"
                                                                                />
                                                                            </div>
                                                                            <div>
                                                                                <label style={{ fontSize: '10.5px', fontWeight: 600, color: '#475569', display: 'block', marginBottom: '2px' }}>Total Available</label>
                                                                                <input
                                                                                    type="text"
                                                                                    readOnly
                                                                                    className="form-control-pos"
                                                                                    style={{ width: '100%', padding: '5px 8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px', background: '#e2e8f0', fontWeight: 700, color: '#16a34a' }}
                                                                                    value={`${(Number(row.baseCount || 0) + Number(row.additionalCount || 0))} Uses`}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                                                                <div>
                                                                    <label style={{ fontSize: '12px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>Wallet Price *</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control-pos"
                                                                        style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                                                                        value={serviceWalletForm.totalAmount}
                                                                        onChange={(e) => setServiceWalletForm(prev => ({ ...prev, price: e.target.value, totalAmount: e.target.value }))}
                                                                        placeholder="Enter wallet price"
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <label style={{ fontSize: '12px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>Validity (Days) *</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control-pos"
                                                                        style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                                                                        value={serviceWalletForm.validityDays}
                                                                        onChange={(e) => setServiceWalletForm(prev => ({ ...prev, validityDays: e.target.value }))}
                                                                        placeholder="365"
                                                                    />
                                                                </div>
                                                            </div>

                                                            {/* GST OPTION FOR SERVICE WALLET */}
                                                            <div style={{ background: '#f8fafc', padding: '12px 14px', borderRadius: '10px', border: '1px solid #cbd5e1', marginBottom: '14px' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: serviceWalletForm.isGstApplicable ? '10px' : '0px' }}>
                                                                    <label style={{ fontSize: '12.5px', fontWeight: 700, color: '#0f172a', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', margin: 0 }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={serviceWalletForm.isGstApplicable}
                                                                            onChange={(e) => setServiceWalletForm(prev => ({ ...prev, isGstApplicable: e.target.checked }))}
                                                                            style={{ width: '16px', height: '16px', accentColor: '#3C0008', cursor: 'pointer' }}
                                                                        />
                                                                        Is GST Applicable?
                                                                    </label>
                                                                    {serviceWalletForm.isGstApplicable && (
                                                                        <span style={{ fontSize: '11px', fontWeight: 700, color: '#0284c7', background: '#e0f2fe', padding: '2px 8px', borderRadius: '12px' }}>
                                                                            GST Active
                                                                        </span>
                                                                    )}
                                                                </div>

                                                                {serviceWalletForm.isGstApplicable && (
                                                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginTop: '6px' }}>
                                                                        <div>
                                                                            <label style={{ fontSize: '11.5px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>GST Rate (%)</label>
                                                                            <select
                                                                                className="form-control-pos"
                                                                                style={{ width: '100%', padding: '6px 8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px' }}
                                                                                value={serviceWalletForm.gstPercentage}
                                                                                onChange={(e) => setServiceWalletForm(prev => ({ ...prev, gstPercentage: e.target.value }))}
                                                                            >
                                                                                <option value="0">0%</option>
                                                                                <option value="5">5%</option>
                                                                                <option value="12">12%</option>
                                                                                <option value="18">18%</option>
                                                                                <option value="28">28%</option>
                                                                            </select>
                                                                        </div>
                                                                        <div>
                                                                            <label style={{ fontSize: '11.5px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>GST Type</label>
                                                                            <select
                                                                                className="form-control-pos"
                                                                                style={{ width: '100%', padding: '6px 8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px' }}
                                                                                value={serviceWalletForm.gstType}
                                                                                onChange={(e) => setServiceWalletForm(prev => ({ ...prev, gstType: e.target.value }))}
                                                                            >
                                                                                <option value="Exclusive">Exclusive (Price + GST)</option>
                                                                                <option value="Inclusive">Inclusive (GST in Price)</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {(() => {
                                                                    const priceInput = Number(serviceWalletForm.totalAmount || 0);
                                                                    const gstRate = Number(serviceWalletForm.gstPercentage || 0);
                                                                    let basePay = priceInput;
                                                                    let calcGst = 0;
                                                                    let calcTotal = priceInput;

                                                                    if (serviceWalletForm.isGstApplicable && gstRate > 0) {
                                                                        if (serviceWalletForm.gstType === 'Exclusive') {
                                                                            basePay = priceInput;
                                                                            calcGst = (basePay * gstRate) / 100;
                                                                            calcTotal = basePay + calcGst;
                                                                        } else {
                                                                            calcGst = priceInput - (priceInput / (1 + gstRate / 100));
                                                                            basePay = priceInput - calcGst;
                                                                            calcTotal = priceInput;
                                                                        }
                                                                    }
                                                                    return (
                                                                        <div style={{ marginTop: '10px', paddingTop: '8px', borderTop: '1px dashed #cbd5e1', display: 'flex', flexDirection: 'column', gap: '3px', fontSize: '12px' }}>
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', color: '#475569' }}>
                                                                                <span>Wallet Price (Base):</span>
                                                                                <span>₹{basePay.toFixed(2)}</span>
                                                                            </div>
                                                                            {serviceWalletForm.isGstApplicable && gstRate > 0 && (
                                                                                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#0284c7' }}>
                                                                                    <span>GST ({serviceWalletForm.gstPercentage}% {serviceWalletForm.gstType}):</span>
                                                                                    <span>₹{calcGst.toFixed(2)}</span>
                                                                                </div>
                                                                            )}
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: '13px', color: '#0f172a', marginTop: '3px' }}>
                                                                                <span>Total Payable:</span>
                                                                                <span style={{ color: '#16a34a' }}>₹{calcTotal.toFixed(2)}</span>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })()}
                                                            </div>

                                                            <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                                                                <FormLabel sx={{ fontSize: '12px', fontWeight: 600, mb: 0.5 }}>Payment Method *</FormLabel>
                                                                <MuiSelect
                                                                    value={serviceWalletForm.paymentMethod}
                                                                    onChange={(e) => setServiceWalletForm(prev => ({ ...prev, paymentMethod: e.target.value }))}
                                                                >
                                                                    <MenuItem value="Cash">Cash</MenuItem>
                                                                    <MenuItem value="UPI">UPI / QR</MenuItem>
                                                                    <MenuItem value="Card">Card</MenuItem>
                                                                    <MenuItem value="Net Banking">Net Banking</MenuItem>
                                                                    <MenuItem value="Others">Others</MenuItem>
                                                                </MuiSelect>
                                                            </FormControl>
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        })()}
                                    </div>
                                )}

                                {/* CASH WALLET TAB FORM */}
                                {activeTabToRender === "Cash" && (
                                    <div>
                                        {(() => {
                                            const activeCashW = customerWallets.find(w => w.type === 'Cash' && w.status === 'ACTIVE' && w.isActive !== false);
                                            return (
                                                <>
                                                    {activeCashW ? (
                                                        <div style={{ background: '#fefce8', border: '1px solid #fef08a', borderRadius: '10px', padding: '12px', marginBottom: '16px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 700, color: '#713f12', fontSize: '13px' }}>
                                                                <span>💰 Active Cash Wallet Found</span>
                                                            </div>
                                                            <div style={{ fontSize: '12px', color: '#854d0e', marginTop: '4px' }}>
                                                                This customer already has an active Cash Wallet. As per system rules, a new wallet cannot be created. Please <strong>Recharge</strong> the existing balance.
                                                            </div>
                                                            <div style={{ marginTop: '8px', padding: '8px 12px', background: '#ffffff', borderRadius: '6px', border: '1px solid #fde047', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                <span style={{ fontSize: '12px', color: '#713f12', fontWeight: 600 }}>Current Wallet Balance:</span>
                                                                <strong style={{ fontSize: '15px', color: '#16a34a' }}>₹{Number(activeCashW.balance || 0).toFixed(2)}</strong>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div style={{ display: 'flex', gap: '12px', marginBottom: '14px' }}>
                                                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>
                                                                <input
                                                                    type="radio"
                                                                    name="cashSubTab"
                                                                    checked={cashWalletSubTab === "New"}
                                                                    onChange={() => setCashWalletSubTab("New")}
                                                                />
                                                                Create New Cash Wallet
                                                            </label>
                                                        </div>
                                                    )}

                                                    {(cashWalletSubTab === "New" && !activeCashW) ? (
                                                        <div>
                                                            <div style={{ marginBottom: '12px' }}>
                                                                <label style={{ fontSize: '12px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>Wallet Name *</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control-pos"
                                                                    style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                                                                    value={cashWalletForm.name}
                                                                    onChange={(e) => setCashWalletForm(prev => ({ ...prev, name: e.target.value }))}
                                                                    placeholder="e.g. VIP Cash Wallet"
                                                                />
                                                            </div>

                                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                                                                <div>
                                                                    <label style={{ fontSize: '12px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>Customer Pays (₹) *</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control-pos"
                                                                        style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                                                                        value={cashWalletForm.customerPays}
                                                                        onChange={(e) => setCashWalletForm(prev => ({ ...prev, customerPays: e.target.value }))}
                                                                        placeholder="e.g. 2000"
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <label style={{ fontSize: '12px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>Credited Wallet Amount (₹) *</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control-pos"
                                                                        style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                                                                        value={cashWalletForm.creditedAmount}
                                                                        onChange={(e) => setCashWalletForm(prev => ({ ...prev, creditedAmount: e.target.value }))}
                                                                        placeholder="e.g. 3000"
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div style={{ marginBottom: '12px' }}>
                                                                <label style={{ fontSize: '12px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>Validity (Days) *</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control-pos"
                                                                    style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                                                                    value={cashWalletForm.validityDays}
                                                                    onChange={(e) => setCashWalletForm(prev => ({ ...prev, validityDays: e.target.value }))}
                                                                    placeholder="365"
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            {/* RECHARGE UI */}
                                                            <div style={{ background: '#f8fafc', padding: '12px 14px', borderRadius: '8px', border: '1px solid #e2e8f0', marginBottom: '16px' }}>
                                                                <div style={{ fontSize: '13px', fontWeight: 700, color: '#334155', marginBottom: '6px' }}>
                                                                    Recharge Customer Wallet
                                                                </div>
                                                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '12px', color: '#475569' }}>
                                                                    <div>Customer: <strong>{selectedCustomerOption?.label || selectedCustomerOption?.data?.name || 'Selected Customer'}</strong></div>
                                                                    <div>Current Balance: <strong style={{ color: '#16a34a', fontSize: '13px' }}>₹{Number(activeCashW ? activeCashW.balance : 0).toFixed(2)}</strong></div>
                                                                </div>
                                                            </div>

                                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '14px' }}>
                                                                <div>
                                                                    <label style={{ fontSize: '12px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>Customer Pays (₹) *</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control-pos"
                                                                        style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                                                                        value={cashWalletForm.customerPays}
                                                                        onChange={(e) => setCashWalletForm(prev => ({ ...prev, customerPays: e.target.value }))}
                                                                        placeholder="e.g. 2000"
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <label style={{ fontSize: '12px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>Credited Wallet Amount (₹) *</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control-pos"
                                                                        style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                                                                        value={cashWalletForm.creditedAmount}
                                                                        onChange={(e) => setCashWalletForm(prev => ({ ...prev, creditedAmount: e.target.value }))}
                                                                        placeholder="e.g. 3000"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div style={{ marginBottom: '14px' }}>
                                                                <label style={{ fontSize: '12px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>New Wallet Balance (₹)</label>
                                                                <input
                                                                    type="text"
                                                                    readOnly
                                                                    className="form-control-pos"
                                                                    style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #bbf7d0', background: '#f0fdf4', fontWeight: 800, color: '#15803d', fontSize: '14px' }}
                                                                    value={`₹${(Number(activeCashW ? activeCashW.balance : 0) + Number(cashWalletForm.creditedAmount || 0)).toFixed(2)}`}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* GST OPTION FOR CASH WALLET */}
                                                    <div style={{ background: '#f8fafc', padding: '12px 14px', borderRadius: '10px', border: '1px solid #cbd5e1', marginBottom: '14px' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: cashWalletForm.isGstApplicable ? '10px' : '0px' }}>
                                                            <label style={{ fontSize: '12.5px', fontWeight: 700, color: '#0f172a', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', margin: 0 }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={cashWalletForm.isGstApplicable}
                                                                    onChange={(e) => setCashWalletForm(prev => ({ ...prev, isGstApplicable: e.target.checked }))}
                                                                    style={{ width: '16px', height: '16px', accentColor: '#3C0008', cursor: 'pointer' }}
                                                                />
                                                                Is GST Applicable?
                                                            </label>
                                                            {cashWalletForm.isGstApplicable && (
                                                                <span style={{ fontSize: '11px', fontWeight: 700, color: '#0284c7', background: '#e0f2fe', padding: '2px 8px', borderRadius: '12px' }}>
                                                                    GST Active
                                                                </span>
                                                            )}
                                                        </div>

                                                        {cashWalletForm.isGstApplicable && (
                                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginTop: '6px' }}>
                                                                <div>
                                                                    <label style={{ fontSize: '11.5px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>GST Rate (%)</label>
                                                                    <select
                                                                        className="form-control-pos"
                                                                        style={{ width: '100%', padding: '6px 8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px' }}
                                                                        value={cashWalletForm.gstPercentage}
                                                                        onChange={(e) => setCashWalletForm(prev => ({ ...prev, gstPercentage: e.target.value }))}
                                                                    >
                                                                        <option value="0">0%</option>
                                                                        <option value="5">5%</option>
                                                                        <option value="12">12%</option>
                                                                        <option value="18">18%</option>
                                                                        <option value="28">28%</option>
                                                                    </select>
                                                                </div>
                                                                <div>
                                                                    <label style={{ fontSize: '11.5px', fontWeight: 600, color: '#334155', display: 'block', marginBottom: '4px' }}>GST Type</label>
                                                                    <select
                                                                        className="form-control-pos"
                                                                        style={{ width: '100%', padding: '6px 8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px' }}
                                                                        value={cashWalletForm.gstType}
                                                                        onChange={(e) => setCashWalletForm(prev => ({ ...prev, gstType: e.target.value }))}
                                                                    >
                                                                        <option value="Exclusive">Exclusive (Price + GST)</option>
                                                                        <option value="Inclusive">Inclusive (GST in Price)</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {(() => {
                                                            const customerPaysInput = Number(cashWalletForm.customerPays || 0);
                                                            const gstRate = Number(cashWalletForm.gstPercentage || 0);
                                                            let basePay = customerPaysInput;
                                                            let calcGst = 0;
                                                            let calcTotal = customerPaysInput;

                                                            if (cashWalletForm.isGstApplicable && gstRate > 0) {
                                                                if (cashWalletForm.gstType === 'Exclusive') {
                                                                    basePay = customerPaysInput;
                                                                    calcGst = (basePay * gstRate) / 100;
                                                                    calcTotal = basePay + calcGst;
                                                                } else {
                                                                    calcGst = customerPaysInput - (customerPaysInput / (1 + gstRate / 100));
                                                                    basePay = customerPaysInput - calcGst;
                                                                    calcTotal = customerPaysInput;
                                                                }
                                                            }

                                                            const creditAmt = Number(cashWalletForm.creditedAmount || 0);

                                                            return (
                                                                <div style={{ marginTop: '10px', paddingTop: '8px', borderTop: '1px dashed #cbd5e1', display: 'flex', flexDirection: 'column', gap: '3px', fontSize: '12px' }}>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', color: '#475569' }}>
                                                                        <span>Customer Base Pay:</span>
                                                                        <span>₹{basePay.toFixed(2)}</span>
                                                                    </div>
                                                                    {cashWalletForm.isGstApplicable && (
                                                                        <div style={{ display: 'flex', justifyContent: 'space-between', color: '#0284c7' }}>
                                                                            <span>GST ({cashWalletForm.gstPercentage}% {cashWalletForm.gstType}):</span>
                                                                            <span>₹{calcGst.toFixed(2)}</span>
                                                                        </div>
                                                                    )}
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: '13px', color: '#0f172a', marginTop: '3px' }}>
                                                                        <span>Total Payable / Amount Paid:</span>
                                                                        <span style={{ color: '#16a34a' }}>₹{calcTotal.toFixed(2)}</span>
                                                                    </div>
                                                                    {creditAmt > 0 && (
                                                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: '12px', color: '#b91c1c', marginTop: '4px', paddingTop: '4px', borderTop: '1px dotted #cbd5e1' }}>
                                                                            <span>Wallet Credit Amount:</span>
                                                                            <span>₹{creditAmt.toFixed(2)}</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })()}
                                                    </div>

                                                    <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                                                        <FormLabel sx={{ fontSize: '12px', fontWeight: 600, mb: 0.5 }}>Payment Method *</FormLabel>
                                                        <MuiSelect
                                                            value={cashWalletForm.paymentMethod}
                                                            onChange={(e) => setCashWalletForm(prev => ({ ...prev, paymentMethod: e.target.value }))}
                                                        >
                                                            <MenuItem value="Cash">Cash</MenuItem>
                                                            <MenuItem value="UPI">UPI / QR</MenuItem>
                                                            <MenuItem value="Card">Card</MenuItem>
                                                            <MenuItem value="Net Banking">Net Banking</MenuItem>
                                                            <MenuItem value="Others">Others</MenuItem>
                                                        </MuiSelect>
                                                    </FormControl>
                                                </>
                                            );
                                        })()}
                                    </div>
                                )}

                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 16 }}>
                                    <Button variant="outlined" color="inherit" onClick={() => setShowBuyWalletModal(false)}>
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={async () => {
                                            if (!selectedCustomerOption) return;
                                            const token = localStorage.getItem("Token");
                                            const custId = selectedCustomerOption.value || selectedCustomerOption._id;
                                            const validStore = (selectedStoreId && selectedStoreId !== 'null' && selectedStoreId !== 'undefined') ? selectedStoreId : undefined;

                                            try {
                                                let res;
                                                let printPayload = null;

                                                if (activeTabToRender === "Service") {
                                                    const validServices = (serviceWalletForm.services || []).filter(s => s.serviceId && (Number(s.baseCount || s.allowedUsages || 0) + Number(s.additionalCount || 0)) > 0);
                                                    if (validServices.length === 0 || !serviceWalletForm.totalAmount) {
                                                        toast.warning("Please select at least one Service with valid usage count and enter wallet price.");
                                                        return;
                                                    }

                                                    const formattedServices = validServices.map(s => {
                                                        const bCount = Number(s.baseCount || s.allowedUsages || 1);
                                                        const aCount = Number(s.additionalCount || 0);
                                                        return {
                                                            serviceId: s.serviceId,
                                                            baseCount: bCount,
                                                            additionalCount: aCount,
                                                            totalServiceCount: bCount + aCount
                                                        };
                                                    });

                                                    const primaryServiceId = formattedServices[0]?.serviceId;
                                                    const totalCountSum = formattedServices.reduce((sum, s) => sum + s.totalServiceCount, 0);

                                                    const priceInput = Number(serviceWalletForm.totalAmount || 0);
                                                    const gstRate = Number(serviceWalletForm.gstPercentage || 0);
                                                    let basePay = priceInput;
                                                    let calcGst = 0;
                                                    let calcTotal = priceInput;

                                                    if (serviceWalletForm.isGstApplicable && gstRate > 0) {
                                                        if (serviceWalletForm.gstType === 'Exclusive') {
                                                            basePay = priceInput;
                                                            calcGst = (basePay * gstRate) / 100;
                                                            calcTotal = basePay + calcGst;
                                                        } else {
                                                            calcGst = priceInput - (priceInput / (1 + gstRate / 100));
                                                            basePay = priceInput - calcGst;
                                                            calcTotal = priceInput;
                                                        }
                                                    }

                                                    const payload = {
                                                        customerId: custId,
                                                        storeId: validStore,
                                                        name: serviceWalletForm.name || "Service Wallet",
                                                        type: "Service",
                                                        serviceId: primaryServiceId,
                                                        totalServiceCount: totalCountSum,
                                                        services: formattedServices,
                                                        price: Number(basePay.toFixed(2)),
                                                        customerBasePay: Number(basePay.toFixed(2)),
                                                        amountPaid: Number(calcTotal.toFixed(2)),
                                                        gstAmount: Number(calcGst.toFixed(2)),
                                                        totalAmount: Number(calcTotal.toFixed(2)),
                                                        isGstApplicable: serviceWalletForm.isGstApplicable,
                                                        gstPercentage: gstRate,
                                                        gstType: serviceWalletForm.gstType || 'Exclusive',
                                                        validityDays: Number(serviceWalletForm.validityDays || 365),
                                                        paymentMethod: serviceWalletForm.paymentMethod || 'Cash'
                                                    };

                                                    res = await postData("wallets/purchase", payload, token);
                                                    printPayload = payload;
                                                } else if (cashWalletSubTab === "New" && !customerWallets.some(w => w.type === 'Cash' && w.status === 'ACTIVE' && w.isActive !== false)) {
                                                    if (!cashWalletForm.customerPays || !cashWalletForm.creditedAmount) {
                                                        toast.warning("Please enter payment and credit amounts.");
                                                        return;
                                                    }

                                                    const customerPaysInput = Number(cashWalletForm.customerPays || 0);
                                                    const gstRate = Number(cashWalletForm.gstPercentage || 0);
                                                    let basePay = customerPaysInput;
                                                    let calcGst = 0;
                                                    let calcTotal = customerPaysInput;

                                                    if (cashWalletForm.isGstApplicable && gstRate > 0) {
                                                        if (cashWalletForm.gstType === 'Exclusive') {
                                                            basePay = customerPaysInput;
                                                            calcGst = (basePay * gstRate) / 100;
                                                            calcTotal = basePay + calcGst;
                                                        } else {
                                                            calcGst = customerPaysInput - (customerPaysInput / (1 + gstRate / 100));
                                                            basePay = customerPaysInput - calcGst;
                                                            calcTotal = customerPaysInput;
                                                        }
                                                    }

                                                    const payload = {
                                                        customerId: custId,
                                                        storeId: validStore,
                                                        name: cashWalletForm.name || "VIP Cash Wallet",
                                                        type: "Cash",
                                                        creditedAmount: Number(cashWalletForm.creditedAmount),
                                                        price: Number(basePay.toFixed(2)),
                                                        customerBasePay: Number(basePay.toFixed(2)),
                                                        amountPaid: Number(calcTotal.toFixed(2)),
                                                        gstAmount: Number(calcGst.toFixed(2)),
                                                        totalAmount: Number(calcTotal.toFixed(2)),
                                                        isGstApplicable: cashWalletForm.isGstApplicable,
                                                        gstPercentage: gstRate,
                                                        gstType: cashWalletForm.gstType || 'Exclusive',
                                                        validityDays: Number(cashWalletForm.validityDays || 365),
                                                        paymentMethod: cashWalletForm.paymentMethod || 'Cash'
                                                    };

                                                    res = await postData("wallets/purchase", payload, token);
                                                    printPayload = payload;
                                                } else {
                                                    const activeCashW = customerWallets.find(w => w.type === 'Cash' && w.status === 'ACTIVE' && w.isActive !== false);
                                                    const targetWalletId = activeCashW?._id || cashWalletForm.selectedWalletForRecharge;

                                                    const customerPaysAmt = Number(cashWalletForm.customerPays);
                                                    const creditedAmt = Number(cashWalletForm.creditedAmount);

                                                    if (!customerPaysAmt || customerPaysAmt <= 0 || !creditedAmt || creditedAmt <= 0) {
                                                        toast.warning("Please enter valid payment and credit amounts.");
                                                        return;
                                                    }

                                                    const gstRate = Number(cashWalletForm.gstPercentage || 0);
                                                    let basePay = customerPaysAmt;
                                                    let calcGst = 0;
                                                    let calcTotal = customerPaysAmt;

                                                    if (cashWalletForm.isGstApplicable && gstRate > 0) {
                                                        if (cashWalletForm.gstType === 'Exclusive') {
                                                            basePay = customerPaysAmt;
                                                            calcGst = (basePay * gstRate) / 100;
                                                            calcTotal = basePay + calcGst;
                                                        } else {
                                                            calcGst = customerPaysAmt - (customerPaysAmt / (1 + gstRate / 100));
                                                            basePay = customerPaysAmt - calcGst;
                                                            calcTotal = customerPaysAmt;
                                                        }
                                                    }

                                                    const payload = {
                                                        customerWalletId: targetWalletId,
                                                        customerId: custId,
                                                        storeId: validStore,
                                                        rechargeAmount: Number(basePay.toFixed(2)),
                                                        customerPays: customerPaysAmt,
                                                        customerBasePay: Number(basePay.toFixed(2)),
                                                        creditedAmount: creditedAmt,
                                                        amountPaid: Number(calcTotal.toFixed(2)),
                                                        gstAmount: Number(calcGst.toFixed(2)),
                                                        totalAmount: Number(calcTotal.toFixed(2)),
                                                        isGstApplicable: cashWalletForm.isGstApplicable,
                                                        gstPercentage: gstRate,
                                                        gstType: cashWalletForm.gstType || 'Exclusive',
                                                        paymentMethod: cashWalletForm.paymentMethod || 'Cash'
                                                    };

                                                    res = await postData("wallets/recharge", payload, token);
                                                    printPayload = payload;
                                                }

                                                if (res && (res.status === 200 || res.status === 201 || res.data)) {
                                                    toast.success("Wallet saved successfully!");
                                                    setShowBuyWalletModal(false);
                                                    fetchCustomerWallets(custId);

                                                    const walletResult = res.data?.customerWallet || res.data?.wallet || res.data;
                                                    if (walletResult && (walletResult.type || walletResult.walletType || printPayload?.type === "Cash" || printPayload?.rechargeAmount)) {
                                                        const printData = {
                                                            ...walletResult,
                                                            ...(printPayload || {}),
                                                            customerId: { name: selectedCustomerOption.label, phoneNumber: selectedCustomerOption.phone, _id: custId }
                                                        };
                                                        const win = window.open("", "WALLET_PRINT", "width=850,height=750");
                                                        if (win) {
                                                            win.document.open();
                                                            win.document.write(generateWalletPrintHTML(printData, currentStore));
                                                            win.document.close();
                                                            win.onload = () => {
                                                                setTimeout(() => {
                                                                    win.focus();
                                                                    win.print();
                                                                }, 400);
                                                            };
                                                        }
                                                    }
                                                } else {
                                                    toast.error(res?.message || "Failed to process wallet request");
                                                }
                                            } catch (err) {
                                                console.error("Error creating/recharging wallet:", err);
                                                toast.error(err?.response?.data?.message || err?.data?.message || err?.message || "Error creating/recharging wallet");
                                            }
                                        }}
                                        sx={{
                                            background: '#3C0008',
                                            color: '#fff',
                                            fontWeight: 700,
                                            '&:hover': { background: '#5c000c' }
                                        }}
                                    >
                                        {customerWallets.some(w => w.type === 'Cash' && w.status === 'ACTIVE' && w.isActive !== false) && activeTabToRender === "Cash" ? "Confirm Recharge" : "Save Wallet"}
                                    </Button>
                                </div>
                            </>
                        );
                    })()}
                </Box>
            </Modal>

            {/* ✅ Payment Checkout Modal */}
            <Modal open={showPaymentModal} onClose={() => setShowPaymentModal(false)}>
                <Box sx={{ ...modalStyle, width: { xs: '95%', sm: 600 }, maxHeight: "95vh", overflowY: "auto", p: 0 }}>
                    <div className="modal-header" style={{ padding: '20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>Checkout</h2>
                        <button onClick={() => setShowPaymentModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '24px' }}>&times;</button>
                    </div>

                    <div style={{ padding: '24px' }}>
                        <div style={{
                            background: '#f8fafc',
                            padding: '20px',
                            borderRadius: '12px',
                            textAlign: 'center',
                            marginBottom: '24px'
                        }}>
                            <div style={{ fontSize: '14px', color: '#000000ff', marginBottom: '4px' }}>Total Payable Amount</div>
                            <div style={{ fontSize: '32px', fontWeight: '800', color: '#1e293b' }}>{paymentModalTotal.toFixed(2)}</div>
                        </div>

                        {/* ✅ SERVICE WALLET REDEMPTION SUMMARY & USE WALLET TOGGLE */}
                        {(() => {
                            const activeServiceWallets = (customerWallets || []).filter(w => {
                                if (w.type !== 'Service' || (w.status !== 'ACTIVE' && w.status !== 'Active') || w.isActive === false) return false;
                                if (w.services && w.services.length > 0) {
                                    return w.services.some(s => (s.remainingCount || 0) > 0);
                                }
                                return (w.remainingCount || 0) > 0 || (w.balance || 0) > 0;
                            });

                            const hasAppliedItems = cart.some(item => item.isServiceWalletApplied);

                            const hasEligibleCartServices = cart.some(item => {
                                const isSvc = item.category?.toLowerCase() === 'service';
                                if (!isSvc) return false;
                                const itemSvcId = String(item.serviceId?._id || item.serviceId?.id || (typeof item.serviceId === 'string' ? item.serviceId : '') || item.id || item._id || '');
                                const itemSvcName = (item.serviceName || item.name || item.title || '').toLowerCase().trim();

                                return activeServiceWallets.some(w => {
                                    if (w.services && w.services.length > 0) {
                                        return w.services.some(s => {
                                            const sId = String(s.serviceId?._id || s.serviceId?.id || (typeof s.serviceId === 'string' ? s.serviceId : '') || '');
                                            const sName = (s.serviceId?.serviceName || s.serviceName || '').toLowerCase().trim();
                                            return (sId && itemSvcId && sId === itemSvcId) || (sName && itemSvcName && (sName === itemSvcName || sName.includes(itemSvcName) || itemSvcName.includes(sName)));
                                        });
                                    } else {
                                        const wSvcId = String(w.serviceId?._id || w.serviceId?.id || (typeof w.serviceId === 'string' ? w.serviceId : '') || w.walletPackageId?.serviceId?._id || w.walletPackageId?.serviceId?.id || '');
                                        const wSvcName = (w.serviceId?.serviceName || w.walletPackageId?.serviceId?.serviceName || w.walletPackageId?.name || '').toLowerCase().trim();
                                        return (wSvcId && itemSvcId && wSvcId === itemSvcId) || (wSvcName && itemSvcName && (wSvcName === itemSvcName || wSvcName.includes(itemSvcName) || itemSvcName.includes(wSvcName)));
                                    }
                                });
                            });

                            if (activeServiceWallets.length === 0 || (!hasAppliedItems && !hasEligibleCartServices)) return null;

                            const firstWallet = activeServiceWallets[0];
                            const walletTitleName = firstWallet?.walletPackageId?.name || firstWallet?.customWalletName || (firstWallet?.serviceId?.serviceName ? `${firstWallet.serviceId.serviceName} Package` : 'Service Wallet');

                            return (
                                <div style={{
                                    background: isServiceWalletUsedInCheckout ? '#eff6ff' : '#f8fafc',
                                    border: `1px solid ${isServiceWalletUsedInCheckout ? '#bfdbfe' : '#e2e8f0'}`,
                                    borderRadius: '12px',
                                    padding: '16px',
                                    marginBottom: '20px'
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: isServiceWalletUsedInCheckout ? '10px' : '0' }}>
                                        <div style={{ fontWeight: 700, fontSize: '13px', color: '#1e40af', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <Icon icon="solar:wallet-money-bold-duotone" width="20" height="20" style={{ color: '#2563eb' }} />
                                            <span>Customer Service Wallet ({walletTitleName})</span>
                                            <span style={{ fontSize: '12px', background: '#dbeafe', color: '#1e40af', padding: '2px 8px', borderRadius: '12px', fontWeight: 600 }}>
                                                {firstWallet.services && firstWallet.services.length > 0
                                                    ? `${firstWallet.services.reduce((acc, s) => acc + (s.remainingCount || 0), 0)} Usages Avail.`
                                                    : `${firstWallet.remainingCount || 0} Usages Avail.`
                                                }
                                            </span>
                                        </div>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '13px', color: '#1e40af' }}>
                                            <input
                                                type="checkbox"
                                                checked={isServiceWalletUsedInCheckout}
                                                onChange={(e) => handleToggleServiceWalletInCheckout(e.target.checked)}
                                                style={{ width: '17px', height: '17px', accentColor: '#2563eb', cursor: 'pointer' }}
                                            />
                                            <span>Use Wallet</span>
                                        </label>
                                    </div>

                                    {isServiceWalletUsedInCheckout ? (
                                        <div>
                                            {cart.filter(item => item.isServiceWalletApplied).map(item => {
                                                const matchedWallet = (customerWallets || []).find(w => String(w._id) === String(item.customerWalletId));
                                                const usagesRedeemed = Number(item.qty || 1);

                                                const itemSvcId = String(item.serviceId?._id || item.serviceId || '');
                                                const itemSvcName = (item.serviceName || item.name || '').toLowerCase().trim();

                                                let matchedSvc = null;
                                                if (matchedWallet && Array.isArray(matchedWallet.services)) {
                                                    matchedSvc = matchedWallet.services.find(s => {
                                                        const sId = String(s.serviceId?._id || s.serviceId || '');
                                                        const sName = (s.serviceId?.serviceName || s.serviceName || '').toLowerCase().trim();
                                                        return (sId && itemSvcId && sId === itemSvcId) || (sName && itemSvcName && (sName === itemSvcName || sName.includes(itemSvcName) || itemSvcName.includes(sName)));
                                                    });
                                                }

                                                const bCount = Number(matchedSvc?.baseCount ?? matchedWallet?.baseCount ?? 0);
                                                const eCount = Number(matchedSvc?.additionalCount ?? matchedWallet?.additionalCount ?? matchedWallet?.extraCount ?? 0);
                                                const totalCount = matchedSvc?.totalCount ||
                                                    matchedWallet?.totalCount ||
                                                    matchedWallet?.totalServiceCount ||
                                                    (bCount > 0 ? (bCount + eCount) : 0) ||
                                                    item.totalCount ||
                                                    1;

                                                const curRem = Number(matchedSvc?.remainingCount ?? matchedWallet?.remainingCount ?? totalCount);
                                                const remainingCount = Math.max(0, curRem - usagesRedeemed);
                                                const expiryDate = matchedWallet?.expiryDate ? new Date(matchedWallet.expiryDate).toLocaleDateString('en-GB') : null;

                                                const coveredVal = Number(item.walletCoveredAmount !== undefined ? item.walletCoveredAmount : (item.total || item.price || 0));

                                                return (
                                                    <div key={item._id || item.rowId || item.id} style={{
                                                        background: '#ffffff',
                                                        border: '1px solid #dbeafe',
                                                        borderRadius: '8px',
                                                        padding: '10px 12px',
                                                        marginTop: '8px'
                                                    }}>
                                                        <div style={{ fontWeight: 700, fontSize: '13px', color: '#1e3a8a' }}>
                                                            🏷️ {item.serviceName || item.name || item.title || 'Service'}
                                                        </div>
                                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px', fontSize: '11px', color: '#1e40af', marginTop: '6px' }}>
                                                            <div>Covered Service Value: <strong>₹{coveredVal.toFixed(2)}</strong></div>
                                                            <div>Wallet Package: <strong>{item.serviceWalletName || matchedWallet?.walletPackageId?.name || 'Service Wallet'}</strong></div>
                                                            <div>Usage for this Bill: <strong style={{ color: '#16a34a' }}>{usagesRedeemed} Usage{usagesRedeemed > 1 ? 's' : ''} Redeemed</strong></div>
                                                            <div>Remaining Wallet Balance: <strong style={{ color: '#16a34a' }}>{remainingCount} / {totalCount} Remaining</strong></div>
                                                            {expiryDate && (
                                                                <div>Valid Till: <strong>{expiryDate}</strong></div>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div style={{ fontSize: '12px', color: '#64748b', fontStyle: 'italic', marginTop: '4px' }}>
                                            Service Wallet available but not redeemed for this bill. Check "Use Wallet" to redeem eligible services.
                                        </div>
                                    )}
                                </div>
                            );
                        })()}

                        {/* ✅ CASH WALLET SUMMARY BREAKDOWN & MANUAL DEDUCTION CONTROLS */}
                        {appliedCashWallet && (() => {
                            const serviceTotals = getProductAndServiceTotals().serviceTotal;
                            const serviceWalletDeduction = (cart || []).filter(i => i.isServiceWalletApplied).reduce((sum, i) => sum + (Number(i.price || i.total || 0) * Number(i.qty || 1)), 0);
                            const eligibleServiceAmount = Math.max(0, serviceTotals - serviceWalletDeduction);

                            if (eligibleServiceAmount <= 0) return null;

                            return (
                                <div style={{
                                    background: isCashWalletApplied ? '#f0fdf4' : '#f8fafc',
                                    border: `1px solid ${isCashWalletApplied ? '#bbf7d0' : '#e2e8f0'}`,
                                    borderRadius: '12px',
                                    padding: '14px',
                                    marginBottom: '20px'
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                                        <div style={{ fontWeight: 700, fontSize: '13px', color: '#0f172a', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <Icon icon="solar:wallet-money-bold-duotone" width="20" height="20" style={{ color: '#0284c7' }} />
                                            <span>Customer Cash Wallet ({appliedCashWallet.walletPackageId?.name || 'Cash Wallet'})</span>
                                            <span style={{ fontSize: '12px', background: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: '12px', fontWeight: 600 }}>
                                                Balance: ₹{(appliedCashWallet.balance || 0).toFixed(2)}
                                            </span>
                                        </div>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '13px', color: '#0369a1' }}>
                                            <input
                                                type="checkbox"
                                                checked={isCashWalletApplied}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    if (!checked) {
                                                        handleWalletDeductionChange(0, false);
                                                    } else {
                                                        const eligible = Math.max(0, getProductAndServiceTotals().serviceTotal - (cart || []).filter(i => i.isServiceWalletApplied).reduce((sum, i) => sum + (Number(i.price || i.total || 0) * Number(i.qty || 1)), 0));
                                                        const maxDed = Math.min(appliedCashWallet.balance || 0, eligible);
                                                        handleWalletDeductionChange(maxDed, true);
                                                    }
                                                }}
                                                style={{ width: '17px', height: '17px', accentColor: '#0284c7', cursor: 'pointer' }}
                                            />
                                            <span>Use Wallet</span>
                                        </label>
                                    </div>

                                    {isCashWalletApplied && (() => {
                                        const serviceTotals = getProductAndServiceTotals().serviceTotal;
                                        const serviceWalletDeduction = (cart || []).filter(i => i.isServiceWalletApplied).reduce((sum, i) => sum + (Number(i.price || i.total || 0) * Number(i.qty || 1)), 0);
                                        const eligibleServiceAmount = Math.max(0, serviceTotals - serviceWalletDeduction);
                                        const maxEligible = Math.min(appliedCashWallet.balance || 0, eligibleServiceAmount);
                                        const numericDeduction = Math.min(Math.max(0, Number(customWalletDeductionAmount) || 0), maxEligible);
                                        const remainingWalletBal = Math.max(0, (appliedCashWallet.balance || 0) - numericDeduction);
                                        const totalBill = invoiceSummary.finalAmount;
                                        const remainingPayable = Math.max(0, totalBill - numericDeduction);

                                        return (
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                                    <div style={{ flex: 1, minWidth: '180px' }}>
                                                        <label style={{ display: 'block', fontSize: '11px', fontWeight: 600, color: '#475569', marginBottom: '4px' }}>
                                                            Wallet Deduction Amount (₹)
                                                        </label>
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            max={maxEligible}
                                                            step="any"
                                                            value={customWalletDeductionAmount}
                                                            onChange={(e) => handleWalletDeductionChange(e.target.value, true)}
                                                            placeholder="Enter amount to deduct"
                                                            style={{
                                                                width: '100%',
                                                                padding: '6px 10px',
                                                                borderRadius: '6px',
                                                                border: '1px solid #cbd5e1',
                                                                fontSize: '13px',
                                                                fontWeight: 700,
                                                                color: '#0f172a'
                                                            }}
                                                        />
                                                    </div>
                                                    <div style={{ display: 'flex', gap: '6px', marginTop: '16px' }}>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleWalletDeductionChange(maxEligible, true)}
                                                            style={{
                                                                padding: '6px 10px',
                                                                fontSize: '11px',
                                                                fontWeight: 600,
                                                                background: '#e0f2fe',
                                                                color: '#0284c7',
                                                                border: '1px solid #bae6fd',
                                                                borderRadius: '6px',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            Max Eligible (₹{maxEligible.toFixed(2)})
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleWalletDeductionChange(0, false)}
                                                            style={{
                                                                padding: '6px 10px',
                                                                fontSize: '11px',
                                                                fontWeight: 600,
                                                                background: '#f1f5f9',
                                                                color: '#64748b',
                                                                border: '1px solid #e2e8f0',
                                                                borderRadius: '6px',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            Clear (₹0)
                                                        </button>
                                                    </div>
                                                </div>

                                                <div style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                                                    gap: '6px',
                                                    background: '#ffffff',
                                                    padding: '8px 12px',
                                                    borderRadius: '8px',
                                                    border: '1px solid #e2e8f0',
                                                    fontSize: '12px'
                                                }}>
                                                    <div>Total Bill: <strong style={{ color: '#0f172a' }}>₹{totalBill.toFixed(2)}</strong></div>
                                                    <div>Wallet Used: <strong style={{ color: '#16a34a' }}>₹{numericDeduction.toFixed(2)}</strong></div>
                                                    <div>Remaining Payable: <strong style={{ color: remainingPayable > 0 ? '#dc2626' : '#16a34a' }}>₹{remainingPayable.toFixed(2)}</strong></div>
                                                    <div>Remaining Wallet Bal: <strong style={{ color: '#475569' }}>₹{remainingWalletBal.toFixed(2)}</strong></div>
                                                </div>
                                            </div>
                                        );
                                    })()}
                                </div>
                            );
                        })()}

                        <PaymentSection
                            payments={payments}
                            setPayments={setPayments}
                            addPaymentRow={addPaymentRow}
                            removePaymentRow={removePaymentRow}
                            finalAmount={paymentModalTotal}
                            customerWallets={customerWallets}
                            cart={cart}
                            setIsCashWalletApplied={setIsCashWalletApplied}
                            setAppliedCashWallet={setAppliedCashWallet}
                            getProductAndServiceTotals={getProductAndServiceTotals}
                        />

                        <div style={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
                            {!showPrintButton ? (
                                (() => {
                                    const hasWalletPayment = cart.some(item => item.isServiceWalletApplied) ||
                                        (isCashWalletApplied && appliedCashWallet && Number(customWalletDeductionAmount) > 0) ||
                                        payments.some(p => p.method === 'WALLET' && Number(p.amount) > 0);

                                    if (hasWalletPayment && !isWalletOtpVerified) {
                                        return (
                                            <button
                                                className="btn pulse"
                                                style={{
                                                    width: '100%',
                                                    padding: '16px',
                                                    fontSize: '16px',
                                                    fontWeight: 700,
                                                    background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '10px',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '8px'
                                                }}
                                                onClick={handleSendWalletOtp}
                                                disabled={walletOtpLoading}
                                            >
                                                <Icon icon="solar:shield-keyhole-bold-duotone" width="22" height="22" />
                                                {walletOtpLoading ? "Sending OTP..." : "SEND OTP"}
                                            </button>
                                        );
                                    }

                                    return (
                                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                            {hasWalletPayment && isWalletOtpVerified && (
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '6px',
                                                    background: '#dcfce7',
                                                    color: '#15803d',
                                                    border: '1px solid #86efac',
                                                    padding: '8px 12px',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    fontWeight: 700
                                                }}>
                                                    <Icon icon="solar:check-circle-bold-duotone" width="18" height="18" />
                                                    <span>Wallet Payment OTP Successfully Verified</span>
                                                </div>
                                            )}
                                            <button
                                                className="btn pulse"
                                                style={{ width: '100%', padding: '16px', fontSize: '16px', background: '#3C0008', color: 'white' }}
                                                onClick={handleSaveInvoice}
                                            >
                                                Generate Invoice
                                            </button>
                                        </div>
                                    );
                                })()
                            ) : (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
                                    <button
                                        className="btn print-btn"
                                        onClick={() => printInvoice(lastInvoice)}
                                        style={{ width: '100%', padding: '16px', fontSize: '16px', background: "#3C0008", color: 'white' }}
                                    >
                                        🖨 Print Invoice
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </Box>
            </Modal>

            {/* ✅ WALLET BILLING OTP VERIFICATION MODAL */}
            <Modal open={showWalletOtpModal} onClose={() => setShowWalletOtpModal(false)}>
                <Box sx={{ ...modalStyle, width: { xs: '95%', sm: 480 }, p: 0, borderRadius: '16px', overflow: 'hidden' }}>
                    <div style={{ padding: '20px 24px', background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Icon icon="solar:shield-keyhole-bold-duotone" width="26" height="26" style={{ color: '#38bdf8' }} />
                            <div>
                                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>Wallet OTP Verification</h3>
                                <div style={{ fontSize: '12px', color: '#94a3b8' }}>Security Verification for Customer Wallet</div>
                            </div>
                        </div>
                        <button onClick={() => setShowWalletOtpModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '24px', color: '#94a3b8' }}>&times;</button>
                    </div>

                    <div style={{ padding: '24px' }}>
                        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                            <div style={{ fontSize: '14px', color: '#475569', marginBottom: '4px' }}>
                                An OTP has been sent to customer <strong>{selectedCustomerOption?.label || "Customer"}</strong>
                            </div>
                            <div style={{ fontSize: '12px', color: '#64748b' }}>
                                Please enter the 6-digit OTP code below to confirm wallet payment
                            </div>
                        </div>

                        {walletOtpError && (
                            <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', color: '#991b1b', borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', fontSize: '13px', textAlign: 'center' }}>
                                {walletOtpError}
                            </div>
                        )}

                        <div style={{ marginBottom: '24px' }}>
                            <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#334155', marginBottom: '8px', textAlign: 'center' }}>Enter 6-Digit OTP</label>
                            <input
                                type="text"
                                maxLength={6}
                                value={walletOtpInput}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, '');
                                    setWalletOtpInput(val);
                                    setWalletOtpError("");
                                }}
                                placeholder="000000"
                                autoFocus
                                style={{
                                    width: '100%',
                                    padding: '14px',
                                    fontSize: '24px',
                                    fontWeight: '800',
                                    letterSpacing: '8px',
                                    textAlign: 'center',
                                    borderRadius: '10px',
                                    border: '2px solid #cbd5e1',
                                    outline: 'none',
                                    fontFamily: 'monospace'
                                }}
                            />
                        </div>

                        <div style={{ display: 'flex', gap: '12px' }}>
                            <button
                                style={{
                                    flex: 1,
                                    padding: '12px',
                                    borderRadius: '8px',
                                    border: '1px solid #cbd5e1',
                                    background: '#f8fafc',
                                    color: '#475569',
                                    fontWeight: 600,
                                    cursor: 'pointer'
                                }}
                                onClick={handleSendWalletOtp}
                                disabled={walletOtpLoading || walletOtpResendTimer > 0}
                            >
                                {walletOtpResendTimer > 0 ? `Resend in ${walletOtpResendTimer}s` : "Resend OTP"}
                            </button>
                            <button
                                style={{
                                    flex: 2,
                                    padding: '12px',
                                    borderRadius: '8px',
                                    border: 'none',
                                    background: '#0284c7',
                                    color: 'white',
                                    fontWeight: 700,
                                    fontSize: '15px',
                                    cursor: walletOtpInput.length === 6 ? 'pointer' : 'not-allowed',
                                    opacity: walletOtpInput.length === 6 ? 1 : 0.6
                                }}
                                onClick={handleVerifyWalletOtp}
                                disabled={walletOtpLoading || walletOtpInput.length !== 6}
                            >
                                {walletOtpLoading ? "Verifying..." : "VERIFY OTP"}
                            </button>
                        </div>
                    </div>
                </Box>
            </Modal>
            {/* ✅ Coupon Selection Modal (Luxury Revamp) */}
            <Modal open={showCouponModal} onClose={() => setShowCouponModal(false)}>
                <Box sx={{
                    ...modalStyle,
                    width: 'min(95vw, 750px)',
                    maxHeight: "90vh",
                    overflowY: "auto",
                    p: 0,
                    bgcolor: '#f8fafc',
                    borderRadius: '32px',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                }}>
                    <div className="coupon-modal-header">
                        <div className="title-group">
                            <Icon icon="mdi:ticket-percent" className="header-icon" />
                            <div>
                                <h2>Premium Rewards</h2>
                                <p>Unlock exclusive savings for your checkout</p>
                            </div>
                        </div>
                        <button onClick={() => setShowCouponModal(false)} className="close-modal-btn">
                            <Icon icon="solar:close-circle-bold-duotone" width={32} height={32} />
                        </button>
                    </div>

                    <div className="coupon-modal-grid">
                        {availableCoupons.length === 0 ? (
                            <div className="no-coupons-state">
                                <Icon icon="mdi:ticket-outline" className="icon" />
                                <p>No active rewards found for this store.</p>
                            </div>
                        ) : (
                            availableCoupons.map((coupon, idx) => {
                                const now = new Date();
                                const isSelected = couponInput.toUpperCase() === coupon.couponCode.toUpperCase();

                                // Validity check
                                const isExpired = coupon.endTime && new Date(coupon.endTime) < now;

                                // Usage check
                                const limit = Number(coupon.useLimit) || 0;
                                const used = Number(coupon.usedCount) || 0; // Assuming usedCount from backend
                                const remaining = Math.max(0, limit - used);
                                const isExhausted = limit > 0 && remaining <= 0;

                                const isDisabled = isExpired || isExhausted;

                                return (
                                    <div
                                        key={idx}
                                        className={`coupon-selection-card ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                                        onClick={() => {
                                            if (isDisabled) {
                                                if (isExpired) return toast.warning("This coupon has expired");
                                                if (isExhausted) return toast.warning("Coupon usage limit reached");
                                                return;
                                            }

                                            // ❌ FIX: Ensure cart is not empty before selecting coupon
                                            const { productTotal, serviceTotal } = getProductAndServiceTotals();
                                            if (productTotal === 0 && serviceTotal === 0) {
                                                return toast.error("Please add products or services to the cart before selecting a coupon.");
                                            }

                                            setCouponInput(coupon.couponCode.toUpperCase());
                                            setShowCouponModal(false);
                                            toast.info(`Success! ${coupon.couponCode} selected.`);
                                        }}
                                    >
                                        {/* Status Badge */}
                                        {isExpired && <div className="status-indicator-badge expired">Expired</div>}
                                        {isExhausted && !isExpired && <div className="status-indicator-badge exhausted">Exhausted</div>}

                                        {/* Left Side: Visual Sticker */}
                                        <div className="coupon-visual-side">
                                            <div className="discount-value-large">
                                                {coupon.discountType === "PERCENTAGE"
                                                    ? `${coupon.percentageOrAmount}%`
                                                    : `${coupon.percentageOrAmount}`}
                                            </div>
                                            <div className="discount-type-label">OFF</div>
                                        </div>

                                        {/* Right Side: Information */}
                                        <div className="coupon-info-side">
                                            <div className="coupon-card-header">
                                                <div className="coupon-code-badge">{coupon.couponCode}</div>
                                                <div className="coupon-tags">
                                                    {coupon.couponType?.map(type => (
                                                        <span key={type} className={`tag type-${type}`}>
                                                            {type}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>

                                            <p className="coupon-desc">
                                                {coupon.description || "Apply this reward to get a exclusive discount on your current purchase."}
                                            </p>

                                            <div className="detailed-conditions-grid">
                                                <div className="condition-item">
                                                    <div className="icon-box"><Icon icon="mdi:cart-minus" /></div>
                                                    <div className="condition-text">
                                                        <span className="condition-label">Used / Limit</span>
                                                        <span className="condition-value">{used} / {limit > 0 ? limit : "∞"}</span>
                                                    </div>
                                                </div>

                                                <div className="condition-item">
                                                    <div className="icon-box"><Icon icon="mdi:refresh" /></div>
                                                    <div className="condition-text">
                                                        <span className="condition-label">Remaining</span>
                                                        <span className={`condition-value ${remaining === 0 ? 'text-danger' : ''}`}>
                                                            {limit > 0 ? remaining : "Unlimited"}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="condition-item">
                                                    <div className="icon-box"><Icon icon="mdi:calendar-clock" /></div>
                                                    <div className="condition-text">
                                                        <span className="condition-label">Valid Until</span>
                                                        <span className={`condition-value ${isExpired ? 'text-danger' : ''}`}>
                                                            {coupon.endTime ? new Date(coupon.endTime).toLocaleDateString('en-GB') : 'Forever'}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="condition-item days-item">
                                                    <div className="icon-box"><Icon icon="mdi:calendar-check" /></div>
                                                    <div className="condition-text">
                                                        <span className="condition-label">Days Applicable</span>
                                                        <span className="condition-value" style={{ fontSize: '11px' }}>
                                                            {coupon.daysAppliedon?.length === 7 ? "All Days (Mon - Sun)" : coupon.daysAppliedon?.join(', ')}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="select-action-overlay">
                                            <span>Select Reward</span>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </Box>
            </Modal>

            {/* ✅ Back-Date OTP Verification Modal */}
            <Modal open={showOtpModal} onClose={() => { setShowOtpModal(false); setPendingDate(null); setOtpInput(""); setOtpSent(false); }}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 420,
                    bgcolor: '#ffffff',
                    borderRadius: '20px',
                    boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
                    p: 0,
                    border: 0,
                    overflow: 'hidden'
                }}>
                    {/* Header */}
                    <div style={{
                        background: 'linear-gradient(135deg, #3C0008 0%, #7f1d1d 100%)',
                        padding: '24px 28px 20px',
                        color: '#fff'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                            <div style={{
                                width: 44, height: 44, borderRadius: '12px',
                                background: 'rgba(255,255,255,0.15)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: '22px'
                            }}>🔐</div>
                            <div>
                                <div style={{ fontSize: '18px', fontWeight: 800 }}>Admin OTP Required</div>
                                <div style={{ fontSize: '12px', opacity: 0.8 }}>Back-date billing verification</div>
                            </div>
                        </div>
                        <div style={{
                            background: 'rgba(255,255,255,0.12)',
                            borderRadius: '10px',
                            padding: '10px 14px',
                            fontSize: '13px',
                            marginTop: '8px'
                        }}>
                            <span style={{ opacity: 0.75 }}>Requested Date: </span>
                            <span style={{ fontWeight: 700 }}>
                                {pendingDate ? new Date(pendingDate + 'T00:00:00').toLocaleDateString('en-GB') : ''}
                            </span>
                        </div>
                    </div>

                    {/* Body */}
                    <div style={{ padding: '24px 28px 28px' }}>
                        <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '20px', lineHeight: 1.6 }}>
                            Billing for past dates requires authorization from the <strong>Store Admin</strong>.
                            Please request the OTP and enter it below to proceed.
                        </p>

                        {/* Step 1 — Send OTP */}
                        <div style={{
                            background: '#f8fafc',
                            borderRadius: '12px',
                            padding: '16px',
                            marginBottom: '16px',
                            border: '1px solid #e2e8f0'
                        }}>
                            <div style={{ fontSize: '12px', fontWeight: 700, color: '#3C0008', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px' }}>
                                Step 1 — Request OTP
                            </div>
                            <button
                                onClick={handleSendBackdateOtp}
                                disabled={otpLoading || otpSent}
                                style={{
                                    width: '100%',
                                    padding: '11px',
                                    background: otpSent
                                        ? 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)'
                                        : 'linear-gradient(135deg, #3C0008 0%, #7f1d1d 100%)',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '10px',
                                    fontSize: '14px',
                                    fontWeight: 700,
                                    cursor: otpLoading || otpSent ? 'not-allowed' : 'pointer',
                                    opacity: otpLoading ? 0.7 : 1,
                                    transition: 'all 0.2s'
                                }}
                            >
                                {otpLoading ? '⏳ Sending OTP...' : otpSent ? '✅ OTP Sent to Store Admin' : '📤 Send OTP to Store Admin'}
                            </button>
                        </div>

                        {/* Step 2 — Enter OTP */}
                        <div style={{
                            background: '#f8fafc',
                            borderRadius: '12px',
                            padding: '16px',
                            marginBottom: '20px',
                            border: `1px solid ${otpSent ? '#e2e8f0' : '#f1f5f9'}`,
                            opacity: otpSent ? 1 : 0.5,
                            transition: 'opacity 0.3s'
                        }}>
                            <div style={{ fontSize: '12px', fontWeight: 700, color: '#3C0008', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px' }}>
                                Step 2 — Enter OTP
                            </div>
                            <input
                                type="text"
                                inputMode="numeric"
                                maxLength={6}
                                disabled={!otpSent}
                                value={otpInput}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, '');
                                    setOtpInput(val);
                                }}
                                placeholder="Enter 6-digit OTP"
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    fontSize: '22px',
                                    fontWeight: 800,
                                    letterSpacing: '8px',
                                    textAlign: 'center',
                                    border: '2px solid',
                                    borderColor: otpSent ? '#3C0008' : '#e2e8f0',
                                    borderRadius: '10px',
                                    outline: 'none',
                                    color: '#1e293b',
                                    background: '#fff',
                                    boxSizing: 'border-box'
                                }}
                            />
                        </div>

                        {/* Action Buttons */}
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <button
                                onClick={() => { setShowOtpModal(false); setPendingDate(null); setOtpInput(""); setOtpSent(false); }}
                                style={{
                                    flex: 1,
                                    padding: '12px',
                                    background: '#f1f5f9',
                                    color: '#64748b',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '10px',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    cursor: 'pointer'
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleVerifyBackdateOtp}
                                disabled={!otpSent || !otpInput || otpVerifying}
                                style={{
                                    flex: 2,
                                    padding: '12px',
                                    background: (!otpSent || !otpInput || otpVerifying)
                                        ? '#e2e8f0'
                                        : 'linear-gradient(135deg, #3C0008 0%, #7f1d1d 100%)',
                                    color: (!otpSent || !otpInput || otpVerifying) ? '#94a3b8' : '#fff',
                                    border: 'none',
                                    borderRadius: '10px',
                                    fontSize: '14px',
                                    fontWeight: 700,
                                    cursor: (!otpSent || !otpInput || otpVerifying) ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s'
                                }}
                            >
                                {otpVerifying ? '⏳ Verifying...' : '🔓 Unlock Back-date Billing'}
                            </button>
                        </div>
                    </div>
                </Box>
            </Modal>

            {/* 🏷️ MRP SELECTION MODAL FOR MULTI-MRP PRODUCTS */}
            {mrpSelectionModal.open && (
                <MrpSelectionModal
                    open={mrpSelectionModal.open}
                    product={mrpSelectionModal.product}
                    options={mrpSelectionModal.options}
                    onClose={() => setMrpSelectionModal({ open: false, product: null, options: [] })}
                    onSelectMrp={(selectedOpt) => {
                        const prod = mrpSelectionModal.product;
                        if (Number(selectedOpt.stock || 0) <= 0) {
                            toast.error(`🚫 MRP ₹${selectedOpt.mrp} is Out of Stock (${selectedOpt.stock} available). Cannot add to cart.`);
                            return;
                        }
                        setMrpSelectionModal({ open: false, product: null, options: [] });
                        addToCart(prod, "Product", selectedOpt);
                    }}
                />
            )}
        </div>
    );
};

export default POSPage;

const PaymentSection = ({ payments, setPayments, addPaymentRow, removePaymentRow, finalAmount, customerWallets, cart, setIsCashWalletApplied, setAppliedCashWallet, getProductAndServiceTotals }) => {

    const basePaymentOptions = [
        {
            value: "WALLET",
            label: "Cash Wallet",
            icon: "solar:wallet-money-bold-duotone",
            color: "#3C0008",
            bg: "#f9f1f2"
        },
        {
            value: "CASH",
            label: "Cash",
            icon: "solar:wallet-money-bold-duotone",
            color: "#10b981",
            bg: "#d1fae5"
        },
        {
            value: "CARD",
            label: "Card",
            icon: "solar:card-bold-duotone",
            color: "#6366f1",
            bg: "#ede9fe"
        },
        {
            value: "UPI",
            label: "UPI",
            icon: "solar:smartphone-bold-duotone",
            color: "#f59e0b",
            bg: "#fef3c7"
        },
        {
            value: "OTHERS",
            label: "Others",
            icon: "solar:banknote-bold-duotone",
            color: "#ec4899",
            bg: "#fce7f3"
        }
    ];

    const totals = getProductAndServiceTotals ? getProductAndServiceTotals() : { serviceTotal: 0 };
    const serviceWalletDeduction = (cart || []).filter(i => i.isServiceWalletApplied).reduce((sum, i) => sum + (Number(i.price || i.total || 0) * Number(i.qty || 1)), 0);
    const eligibleServiceAmount = Math.max(0, totals.serviceTotal - serviceWalletDeduction);

    const hasActiveCashWallet = (customerWallets || []).some(
        (w) => w.type === 'Cash' && w.status === 'ACTIVE' && (w.balance || 0) > 0
    ) && eligibleServiceAmount > 0;

    const paymentOptions = basePaymentOptions.filter(
        (opt) => opt.value !== "WALLET" || hasActiveCashWallet || (payments || []).some(p => p.method === "WALLET")
    );

    const getOptionMeta = (method) =>
        basePaymentOptions.find((o) => o.value === method) || basePaymentOptions[0];
    const totalPaid = payments
        .filter(p => p.method !== "WALLET")
        .reduce((sum, p) => sum + (Number(p.amount) || 0), 0);

    const remainingBalance = finalAmount - totalPaid;

    const allSelected = paymentOptions.every(opt => payments.some(p => p.method === opt.value));

    if (finalAmount <= 0) {
        return (
            <div className="payments-section">
                <div className="payment-footer-summary" style={{ marginTop: '0px' }}>
                    <div className="footer-stat">
                        <span className="stat-label">Total Paid</span>
                        <span className="stat-value primary">0.00</span>
                    </div>
                    <div className="footer-stat">
                        <span className="stat-label">Remaining</span>
                        <span className="stat-value warning">0.00</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="payments-section">
            <span className="section-title">Payment Methods</span>

            <div className="payment-list">
                {payments.map((p, idx) => {
                    const selectedOption = getOptionMeta(p.method);
                    const selectedElsewhere = payments
                        .filter((_, i) => i !== idx)
                        .map((pm) => pm.method)
                        .filter(Boolean);
                    const filteredOptions = paymentOptions.filter(
                        (opt) => !selectedElsewhere.includes(opt.value)
                    );
                    return (
                        <div className="payment-row" key={idx}>

                            {/* PAYMENT METHOD */}

                            <div className="payment-select-wrapper">
                                <Select
                                    className="payment-method-dropdown"
                                    classNamePrefix="react-select"
                                    value={basePaymentOptions.find(
                                        (opt) => opt.value === p.method
                                    )}
                                    onChange={(selected) => {
                                        const updated = [...payments];
                                        updated[idx] = {
                                            ...updated[idx],
                                            method: selected?.value || ""
                                        };
                                        setPayments(updated);
                                    }}
                                    options={filteredOptions}
                                    formatOptionLabel={(option) => (
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: "30px",
                                                    height: "30px",
                                                    borderRadius: "8px",
                                                    background: option.bg,
                                                    color: option.color,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <Icon icon={option.icon} width="18" />
                                            </div>

                                            <span>{option.label}</span>
                                        </div>
                                    )}
                                />
                            </div>

                            {/* CARD NUMBER */}

                            {p.method === "CARD" && (
                                <input
                                    type="text"
                                    maxLength={4}
                                    value={p.cardNumber || ""}
                                    onChange={(e) => {

                                        const val = e.target.value.replace(/\D/g, "");

                                        const updated = [...payments];

                                        updated[idx] = {
                                            ...updated[idx],
                                            cardNumber: val
                                        };

                                        setPayments(updated);
                                    }}
                                    placeholder="Last 4 digits"
                                />
                            )}

                            {/* AMOUNT */}

                            {/* AMOUNT */}
                            <input
                                type="text"
                                inputMode="decimal"
                                value={p.amount}
                                onChange={(e) => {

                                    const val = e.target.value;

                                    if (/^\d*\.?\d*$/.test(val)) {

                                        const updated = [...payments];

                                        updated[idx] = {
                                            ...updated[idx],
                                            amount: val
                                        };

                                        setPayments(updated);
                                    }
                                }}
                                placeholder="0.00"
                                className="payment-amount-input"
                            />
                            {/* REMOVE BUTTON */}

                            {payments.length > 1 && (
                                <button
                                    className="delete-payment-btn"
                                    onClick={() => removePaymentRow(idx)}
                                    title="Remove Payment"
                                >
                                    <Icon icon="mdi:close" />
                                </button>
                            )}
                        </div>
                    );
                })}
            </div>

            {!allSelected && (
                <div className="payment-actions">
                    <button
                        type="button"
                        className="add-payment-link"
                        onClick={addPaymentRow}
                    >
                        <Icon icon="mdi:plus" /> Add Payment Method
                    </button>
                </div>
            )}

            <div className="payment-footer-summary">
                <div className="footer-stat">
                    <span className="stat-label">Total Paid</span>
                    <span className="stat-value primary">{totalPaid.toFixed(2)}</span>
                </div>
                <div className="footer-stat">
                    <span className="stat-label">{remainingBalance < 0 ? 'Change' : 'Remaining'}</span>
                    <span className={`stat-value ${remainingBalance < 0 ? 'primary' : 'warning'}`}>
                        {Math.abs(remainingBalance).toFixed(2)}
                    </span>
                </div>
            </div>
        </div>
    );
};

const MrpSelectionModal = ({ open, onClose, product, options, onSelectMrp }) => {
    if (!open || !product) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 99999
        }}>
            <div style={{
                background: '#fff',
                borderRadius: '12px',
                width: '420px',
                maxWidth: '90%',
                padding: '24px',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                    <h3 style={{ margin: 0, fontSize: '18px', color: '#1e293b' }}>Select MRP / Selling Price</h3>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#64748b' }}>×</button>
                </div>

                <p style={{ fontSize: '14px', color: '#64748b', marginBottom: '16px' }}>
                    Multiple MRPs found for <strong>{product.title}</strong>. Please select the price to bill:
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxHeight: '250px', overflowY: 'auto' }}>
                    {options.map((opt, idx) => {
                        const isOutOfStock = Number(opt.stock || 0) <= 0;
                        return (
                            <div
                                key={idx}
                                onClick={() => {
                                    if (isOutOfStock) {
                                        toast.error(`🚫 MRP ₹${opt.mrp} is Out of Stock (0 available). Cannot add to cart.`);
                                        return;
                                    }
                                    onSelectMrp(opt);
                                }}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '12px 16px',
                                    border: isOutOfStock ? '2px solid #fecaca' : '2px solid #e2e8f0',
                                    borderRadius: '8px',
                                    cursor: isOutOfStock ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease',
                                    background: isOutOfStock ? '#fef2f2' : '#f8fafc',
                                    opacity: isOutOfStock ? 0.7 : 1
                                }}
                                onMouseEnter={(e) => {
                                    if (!isOutOfStock) {
                                        e.currentTarget.style.borderColor = '#3C0008';
                                        e.currentTarget.style.background = '#fff5f5';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!isOutOfStock) {
                                        e.currentTarget.style.borderColor = '#e2e8f0';
                                        e.currentTarget.style.background = '#f8fafc';
                                    }
                                }}
                            >
                                <div>
                                    <div style={{ fontSize: '16px', fontWeight: 'bold', color: isOutOfStock ? '#991b1b' : '#3C0008' }}>
                                        ₹{opt.mrp}
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#64748b' }}>
                                        Effective: {opt.effectiveDate ? new Date(opt.effectiveDate).toLocaleDateString() : 'N/A'}
                                    </div>
                                </div>
                                <div style={{
                                    padding: '4px 10px',
                                    borderRadius: '12px',
                                    background: !isOutOfStock ? '#dcfce7' : '#fee2e2',
                                    color: !isOutOfStock ? '#166534' : '#991b1b',
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}>
                                    {!isOutOfStock ? `Available Stock: ${opt.stock}` : `Out of Stock (${opt.stock})`}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div style={{ marginTop: '20px', textAlign: 'right' }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: '8px 16px',
                            borderRadius: '6px',
                            border: '1px solid #cbd5e1',
                            background: '#fff',
                            cursor: 'pointer',
                            fontSize: '14px'
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};